import axios from '../../axios'
import { ThemeJSON } from './Theme/ThemeJSON'
import {formStateStore} from '../../Redux/Store/store';
import { checkValid, isObjectEmpty, checkEmpty} from "../../Resources/globalFunctions";
import forge from 'node-forge';
import CryptoJS from "crypto-js";
// import ShortUniqueId from 'short-unique-id';
import uuid from 'react-uuid';
import cloneDeep from 'lodash-es/cloneDeep';
import { recursiveJsonReader1, checkForAllNonFilledMandatoryFields, functions } from './ApplicationAPI/applicationApi';
import { controlFoundFalseMaker, updateComponentInJson } from './SectionLayoutLogic';
import {produce} from "immer"
import { updateFormStateWithoutRender, updateFormStateContextWithoutRender, updateStateInRedux, updateGridContexts, reset, updateMarvinContexts, updateRenderElement, setMap } from '../../Redux/Actions/FormStateActions';
import { removeMapping, sendRequestForMarvinAPI } from './RequestLogic';
import {getEncKey_gcm , getEncivf_gcm, sanitizeJson} from "../../Resources/globalFunctions"
import { useMediaQuery } from '@material-ui/core';
import { MediaDevice } from '../CustomHooks/CustomHooks';

export const test = () => {
}

export function findIndexInTempBuffer(buffer, stepId, subStepId) {
    let stIndex, sbstIndex;
    for (let i = 0; i < buffer?.length; i++) {
        if (buffer?.[i]?.id === stepId) {
            stIndex = i;
            if (buffer?.[i]?.children?.findIndex(child => child?.elem_type?.toLowerCase() === "substep") !== -1) {
                if (!subStepId) {
                    sbstIndex = 0;
                    break;
                } else {
                    for (let j = 0; j < buffer?.[i]?.children?.length; j++) {
                        if (buffer?.[i].children?.[j].id === subStepId) {
                            sbstIndex = j;
                            break;
                        }
                    }
                }
            }
            break;
        }
    }
    return [stIndex, sbstIndex];
}

const MaxIteration = 13;
const MaxLoopIteration = 999;

let elemIdCountState = {
    section: 0,
    frame: 0,
    container: 0,
    row: 0,
    column: 0,
    textbox: 0,
    textarea: 0,
    datepick: 0,
    label: 0,
    email: 0,
    combo: 0,
    password: 0,
    button: 0,
    submit: 0,
    column_1: 0,
    column_2: 0,
    column_3: 0,
    phonenumber: 0,
    checkbox: 0,
    radio: 0,
    listbox: 0,
    tab: 0,
    sheet: 0,
    table: 0,
    multiSelect: 0,
    listview: 0,
    advancelistview: 0,
    advancelistView:0,
    link: 0,
    toggle: 0,
    paragraph: 0,
    picklist: 0,
    image: 0,
    iframe: 0,
    temp_tableColumn: 0,
    richtexteditor: 0,
    slider: 0,
    imagecarousel: 0,
    tile: 0,
    wizard_h: 0,
    wizard_v: 0,
    step: 0,
    substep: 0,
    sidenavigation: 0,
    report: 0,
    captcha: 0
};

export function getShowAlertNotificationFromStore(containerId)
{
    const state=formStateStore.getState();
    if(containerId===undefined){
        containerId=getContainerId();
    }
    return (state.data.find(json => json.key === containerId))?.contexts?.showAlertConfirmNotifications;
}

export function getColumnLayout(device){
    if(device==="web"){
        return 12/window?.containerSizesOnDrop?.column_size_web || window.psh_configs?.column_size_web || 3;
    }
    else if(device==="tablet"){
        return 12/window?.containerSizesOnDrop?.column_size_tablet || window.psh_configs?.column_size_tablet || 6;
    }
    else if(device==="mobile"){
        return 12/window?.containerSizesOnDrop?.column_size_mobile || window.psh_configs?.column_size_mobile || 12;
    }
}

export function getColumnLayoutContainers(device){
    if(device==="web"){
        return window.psh_configs?.column_size_web || 3;
    }
    else if(device==="tablet"){
        return window.psh_configs?.column_size_tablet || 6;
    }
    else if(device==="mobile"){
        return window.psh_configs?.column_size_mobile || 12;
    }
}

export function resetPropertiesThroughThemes(formState,json){
    if(formState?.children) {
        for(let i = 0; i < formState.children.length; i++) {
            if(formState.children[i].style && formState.children[i].id !== 'GroupInfo' && formState.children[i].id !== 'Event') {
                if(json?.[formState?.children[i].controlName] || json?.[formState?.children[i].elem_type]) {
                    Object.assign(formState.children[i].style,json?.[formState?.children[i].controlName || formState?.children[i].elem_type ])
                }
                resetPropertiesThroughThemes(formState.children[i],json);    
            }
            else if(formState.children[i].subform && formState.children[i].elem_type === "button") {
                resetPropertiesThroughThemes(formState.children[i].subform,json);
            }
            else if(formState.children[i].listviewFrameLayoutJson && Object.keys(formState.children[i].listviewFrameLayoutJ)?.length) {
                resetPropertiesThroughThemes(formState.children[i].listviewFrameLayoutJson,json);
            }    
            else {
                resetPropertiesThroughThemes(formState.children[i],json);
            }
        }
    }
    return {...formState};
}

export function themeNoteResetFunction(formState, json) {
    if (formState?.children) {
        for (let i = 0; i < formState.children.length; i++) {
            if (formState.children[i].style && formState.children[i].id !== 'GroupInfo' && formState.children[i].id !== 'Event') {
                if (json?.[formState?.children[i].controlName] || json?.[formState?.children[i].elem_type]) {

                    Object.entries(json?.[formState?.children[i].controlName || formState?.children[i].elem_type]).map(([key, value]) => {
                        Object.entries(formState.children[i].style).map(([key1,value1]) => {
                            if(key===key1 && (value!==value1 && (value1 + "")?.toLowerCase() !=="select")){
                                formStateStore.dispatch(updateStateInRedux({name:"resetNoteTheme",value:true}))
                            }                            
                        })
                    })
                }
                 themeNoteResetFunction(formState.children[i], json);
            }
            else if (formState.children[i].subform && formState.children[i].elem_type === "button") {
                 themeNoteResetFunction(formState.children[i].subform, json);
            }
            else if (formState.children[i].listviewFrameLayoutJson && Object.keys(formState.children[i].listviewFrameLayoutJ)?.length) {
                 themeNoteResetFunction(formState.children[i].listviewFrameLayoutJson, json);
            }
            else {
                 themeNoteResetFunction(formState.children[i], json);
            }
        }
    }
    
}


function getNoOfCols(){
    const columnLayout = getColumnLayout("web");
    return 12/columnLayout;
}

function getNoOfColsContainers(){
    const columnLayout = getColumnLayoutContainers("web");
    return 12/columnLayout;
}

export function getCurrentDevice(){
    const deviceFromDom=document.querySelector("#canvasId")?.getAttribute("deviceMode");
    return deviceFromDom;
}

export function getDevice() {
    const state = formStateStore.getState();
    const containerId = state.containerInfo.containerId;
    const device = state.data.find((json) => json.key === containerId)?.contexts.device;
    const isDesigner = state?.isDesigner;
    const {isDesktop, isTablet, isMobile} = MediaDevice();
    if(isDesigner) {
        if(device === "mobile" || isMobile)
            return "mobile";
        else if(device === "tablet" || isTablet)
            return "tablet";
        else if(device === "web" || isDesktop)
            return "web";
    }
    return isMobile ? "mobile" : isDesktop ? "web" : "tablet";
}

let elemIdCountStateForSubForm = {
    section: 0,
    frame: 0,
    container: 0,
    row: 0,
    column: 0,
    textbox: 0,
    textarea: 0,
    datepick: 0,
    label: 0,
    email: 0,
    combo: 0,
    password: 0,
    button: 0,
    submit: 0,
    column_1: 0,
    column_2: 0,
    column_3: 0,
    phonenumber: 0,
    checkbox: 0,
    radio: 0,
    listbox: 0,
    tab: 0,
    sheet: 0,
    table: 0,
    multiSelect: 0,
    listview: 0,
    advancelistView:0,
    advancelistview: 0,
    link: 0,
    toggle: 0,
    paragraph: 0,
    picklist: 0,
    image: 0,
    iframe: 0,
    temp_tableColumn: 0,
    richtexteditor: 0,
    slider: 0,
    imagecarousel: 0,
    tile: 0,
    wizard_h: 0,
    wizard_v: 0,
    step: 0,
    substep: 0,
    sidenavigation: 0,
    report: 0,
    captcha: 0
};

export function checkControlIdExistance(controlId) {
  let idPresent = alreadyPresentControlIds.includes(controlId);
  return idPresent;
}

export function deleteControlIdFromExistance(controlId) {
  try {
    if (alreadyPresentControlIds.includes(controlId)) {
      alreadyPresentControlIds = alreadyPresentControlIds.filter(
        (e) => e !== controlId
      );
    }
    return true;
  } catch (error) {
     console.log("Error while deleting controlId from existance!!!");
    return false;
  }
}
var alreadyPresentControlIds = [];
export function addToAlreadyCreatedId(elemId) {
    alreadyPresentControlIds.push(elemId);
}

export function addIdsFromJsonToExistingIDs(provided_json) {
    if (Array.isArray(provided_json)) {
        provided_json.forEach(
            (currJson) => {
                addIdsFromJsonToExistingIDs(currJson);
            }
        )
    } else {
        if (provided_json && provided_json.id && provided_json.elem_type && (provided_json.elem_type === 'row' || provided_json.elem_type === 'column')) {
            addToAlreadyCreatedId(provided_json.id);
        }
        if (provided_json && provided_json.children) {
            provided_json.children.map(
                (child) => {
                    addIdsFromJsonToExistingIDs(child);
                }
            );
        }
    }
}

export const updateRowNColumn = (formState) => {   
        // if(value.elem_type==="button"){
        //     if(value.isButtonProperties){
        //         value.isButtonProperties = "";
        //     }
        // }
        if (formState?.children) {
        for(let i=0; i<formState.children.length;i++){
            if ((formState?.children[i]?.elem_type === 'row' || formState?.children[i]?.elem_type === 'column')) {
                if(formState.children[i].elem_type === 'row') {
                    formState.children[i]['id'] = createUniqueId('row');
                } else if (formState.children[i].elem_type === 'column') {
                    formState.children[i]['id'] = createUniqueId('column');
                }
            }
            if(formState.children[i].subform && formState.children[i].elem_type === "button") {
                updateRowNColumn(formState.children[i].subform);
            }
            if(formState.children[i].listviewFrameLayoutJson && formState.children[i].elem_type?.toLowerCase() === "advancelistview" || formState.children[i].elem_type?.toLowerCase() === "listview") {
                updateRowNColumn(formState.children[i].listviewFrameLayoutJson);
            }
            if(formState.children[i]) {
                updateRowNColumn(formState.children[i]);
            }
        }
    }
    else if(formState?.listviewFrameLayoutJson && (formState?.elem_type?.toLowerCase() === "advancelistview" || formState?.elem_type?.toLowerCase() === "listview")){
        updateRowNColumn(formState?.listviewFrameLayoutJson);
    }
    else if(formState?.subform && formState?.elem_type === "button") {
        updateRowNColumn(formState?.subform);
    }
}

export const getTabIndex = (data) => {
    const state = formStateStore.getState();
    let containerId = state.containerInfo.containerId;
    const { openCanvasForPreviewAdvance, currentAdvanceListviewStateJson, openCanvasForPreview, subFormListviewJson } = getGridStates();

    if( openCanvasForPreviewAdvance === "advanceListviewPopupInPreview" && currentAdvanceListviewStateJson) 
        return 0;

    if(subFormListviewJson && openCanvasForPreview === "showDataAdditonSection")
        return 0;

    if(data?.isAboveListview) {
        const tableId = data?.id?.split('_')?.[0];
        let tableJson; 
        if(window?.tabIndex?.[tableId]) {
            tableJson = window?.tabIndex?.[tableId];
        } else {
            tableJson = functions.readJson(getFormJsonFromStore(), tableId);
            window.tabIndex = {};
            window.tabIndex[tableId] = tableJson;
        }
        if(tableJson?.parentStepIndex)
            return parseInt(tableJson.parentStepIndex) + 1;
        if(tableJson?.stepIndex)
            return parseInt(tableJson.stepIndex) + 1;
        if(tableJson?.sheetIndex)
            return parseInt(tableJson?.sheetIndex) + 1;
        return 1;        
    }
    if(data?.parentStepIndex)
        return parseInt(data.parentStepIndex) + 1;
    if(data?.stepIndex)
        return parseInt(data.stepIndex) + 1;
    if(data?.sheetIndex)
        return parseInt(data?.sheetIndex) + 1;
    return 1;
}

export const updateRowNColumnOnSave = (formState, idObj={}) => {   
        // if(value.elem_type==="button"){
        //     if(value.isButtonProperties){
        //         value.isButtonProperties = "";
        //     }
        // }
        if (formState?.children) {
        for(let i=0; i<formState.children.length;i++){
            if ((formState?.children[i]?.elem_type === 'row' || formState?.children[i]?.elem_type === 'column')) {
                if(idObj[formState.children[i]['id']]) {
                    if(formState.children[i].elem_type === 'row') {
                        formState.children[i]['id'] = createUniqueId('row');
                    } else if (formState.children[i].elem_type === 'column') {
                        formState.children[i]['id'] = createUniqueId('column');
                    }
                    idObj[formState.children[i]['id']] = true;
                } else idObj[formState.children[i]['id']] = true;
            }
            if(formState.children[i].subform && formState.children[i].elem_type === "button") {
                updateRowNColumnOnSave(formState.children[i].subform, idObj);
            }
            if(formState.children[i].listviewFrameLayoutJson && formState.children[i].elem_type?.toLowerCase() === "advancelistview" || formState.children[i].elem_type?.toLowerCase() === "listview") {
                updateRowNColumnOnSave(formState.children[i].listviewFrameLayoutJson, idObj);
            }
            if(formState.children[i]) {
                updateRowNColumnOnSave(formState.children[i], idObj);
            }
        }
    }
    else if(formState?.listviewFrameLayoutJson && (formState?.elem_type?.toLowerCase() === "advancelistview" || formState?.elem_type?.toLowerCase() === "listview")){
        updateRowNColumnOnSave(formState?.listviewFrameLayoutJson,idObj);
    }
    else if(formState?.subform && formState?.elem_type === "button") {
        updateRowNColumnOnSave(formState?.subform, idObj);
    }
}

// export function updateRowNColumn(provided_json) {
//     if (Array.isArray(provided_json)) {
//         provided_json.forEach(
//             (currJson) => {
//                 return updateRowNColumn(currJson);
//             }
//         )
//     } else {
//         if (provided_json && provided_json.id && provided_json.elem_type && (provided_json.elem_type === 'row' || provided_json.elem_type === 'column')) {
//             if (provided_json.elem_type === 'row') {
//                 provided_json['id'] = createUniqueId('row');
//             } else if (provided_json.elem_type === 'column') {
//                 provided_json['id'] = createUniqueId('column');
//             }
//         }
//         if (provided_json && provided_json.children) {
//             provided_json.children.map(
//                 (child) => {
//                     return updateRowNColumn(child);
//                 }
//             );
//         }
//     }
//     return provided_json;
// }

export const updateValue = (id,json, shouldSaveInFormState = true, controlJSON) => {
    let formJson = {};
    const state = formStateStore.getState();
    let containerId = state.containerInfo.containerId;
    const { openCanvasForPreviewAdvance, currentAdvanceListviewStateJson, openCanvasForPreview, subFormListviewJson } = getGridStates();
    const subFormMetaData = getSubFormMetaData();
    const previewMode = getPreviewMode();

    if(shouldSaveInFormState === false) {
        shouldSaveInFormState = !controlJSON?.isAdvanceListview;
    }

    if(shouldSaveInFormState === false) {
        shouldSaveInFormState = !controlJSON?.isInsideListview;
    }

    if(subFormMetaData?.includes(controlJSON?.buttonId) && controlJSON?.isSubForm && previewMode) {
        formJson = getFormJsonFromStore();
    }    
    else if(openCanvasForPreviewAdvance === "advanceListviewPopupInPreview" && currentAdvanceListviewStateJson && subFormListviewJson && openCanvasForPreview === "showDataAdditonSection") {
        // formJson = currentAdvanceListviewStateJson?.listviewFrameLayoutJson;
        let lvJson = fetchGridStates()?.subFormListviewJson;
        fetchAndUpdateValue(lvJson,id,json);
        // let currentLvJson = functions.readJson(formJson, fetchGridStates()?.subFormListviewJson?.id)
        formStateStore.dispatch(
            updateGridContexts({
              name: "subFormListviewJson",
              key: containerId,
              value: lvJson,
              renderListView: false, 
              // renderCanvas: true
            })
          );
        // formStateStore.dispatch(updateGridContexts({name: "advanceListviewStateJson", key: containerId, value: { ...formJson}}));
        // formStateStore.dispatch(updateGridContexts({ name: "currentAdvanceListviewStateJson", key: containerId, value: { ...fetchGridStates().currentAdvanceListviewStateJson, listviewFrameLayoutJson: { ...formJson }}, renderAdvListView: false, renderListView: false}));
        return;
    } 
    else if(openCanvasForPreviewAdvance === "advanceListviewPopupInPreview" && currentAdvanceListviewStateJson && !shouldSaveInFormState) {
        formJson = currentAdvanceListviewStateJson?.listviewFrameLayoutJson;
    } 
    else if(subFormListviewJson && openCanvasForPreview === "showDataAdditonSection" && !shouldSaveInFormState) {
        formJson = subFormListviewJson?.listviewFrameLayoutJson;
    } 
    else {
        formJson = getFormJsonFromStore();
    }
    fetchAndUpdateValue(formJson,id,json);
    if(subFormMetaData?.includes(controlJSON?.buttonId) && controlJSON?.isSubForm && previewMode) {
        formStateStore.dispatch(updateFormStateWithoutRender(formJson));
    }    
    else if(openCanvasForPreviewAdvance === "advanceListviewPopupInPreview" && currentAdvanceListviewStateJson && !shouldSaveInFormState) {
        // formStateStore.dispatch(updateGridContexts({name: "advanceListviewStateJson", key: containerId, value: { ...formJson}}));
        formStateStore.dispatch(updateGridContexts({ name: "currentAdvanceListviewStateJson", key: containerId, value: { ...fetchGridStates().currentAdvanceListviewStateJson, listviewFrameLayoutJson: { ...formJson }}, renderAdvListView: false, renderListView: false}));
    }
    else if(subFormListviewJson && openCanvasForPreview === "showDataAdditonSection" && !shouldSaveInFormState) {
        formStateStore.dispatch(
            updateGridContexts({
              name: "subFormListviewJson",
              key: containerId,
              value: { ...fetchGridStates()?.subFormListviewJson, listviewFrameLayoutJson: { ...formJson }},
            //   renderListView: true, 
              // renderCanvas: true
            })
          );
    } 
    else{
        formStateStore.dispatch(updateFormStateWithoutRender(formJson));
    }
    // if(id && json){
    //     updateElementByValue(id, json)
    // }
}

export function addKeyInJson(key, value, json) {
    if(Array.isArray(json)){
      json.forEach((item)=>{
        item[key] = value;
        if(Object.keys(item).includes("children")){
          addKeyInJson(key, value, item);
        }
      })
    } else {
      json[key] = value;
      addKeyInJson(key, value, json?.["children"]);
    }
}

export const fetchAndUpdateValue = (formState,id,value) => {
    if (formState?.children) {
        for(let i=0; i<formState.children.length;i++){
            if (formState.children[i].id === id) {
                if(formState.children[i].elem_type === 'paragraph' || formState.children[i].elem_type === 'richtexteditor') {
                    formState.children[i].paragraphText = value;
                    formState.children[i].value = value;
                    break;
                }
                else {
                    formState.children[i].value = value;
                    break;
                }
            }
            else if(formState.children[i].subform && formState.children[i].elem_type === "button") {
                fetchAndUpdateValue(formState.children[i].subform,id,value);
            }
            else if(formState.children[i].listviewFrameLayoutJson && formState.children[i].elem_type?.toLowerCase() === "advancelistview" || formState.children[i].elem_type?.toLowerCase() === "listview") {
                fetchAndUpdateValue(formState.children[i].listviewFrameLayoutJson,id,value);
            }
            else {
                fetchAndUpdateValue(formState.children[i],id,value);
            }
        }
    }
}

var elementIndex = 0;
var frameIndex = parseInt(elemIdCountState.section);

var controlFound_createSmartFormState=false;

export function createSmartFormState(formState, targetId, targetElemType, elementTypeToCreate, column_layout, frameIndex, controlElemToAdd, targetRowId, targetColId, device, extraDetails ,containerId, parentCall=true) {
    const {setOpenQuickToolFor} = getReduxContexts()
    if(elementTypeToCreate === 'frame' && targetElemType === 'frame'){
        elementTypeToCreate = 'section'
        targetElemType = 'section'
    }

    if(formState.containerControl) {
        controlElemToAdd.containerControl = formState.containerControl;

        if(!controlElemToAdd.isWizardHeader && formState.sectionAboveWizard) {
            const parentFrame = document.querySelector(`#${targetId}`)?.closest(`[elem_type=frame]`);
            const frameId = parentFrame?.getAttribute("id") || parentFrame?.getAttribute("control_id");

            if(frameId === formState.sectionAboveWizard) {
                controlElemToAdd.isWizardHeader = formState.isAboveWizard;
            }
        }
    }

    if (controlElemToAdd?.style){
        controlElemToAdd.style.Label = 
          controlElemToAdd?.style?.Label || controlElemToAdd?.style?.Label === ""
          ? controlElemToAdd?.style?.Label
          : controlElemToAdd.id;
          if(controlElemToAdd?.elem_type === "picklist")
        controlElemToAdd.style.PopupText = 
          controlElemToAdd?.style?.Label || controlElemToAdd?.style?.Label === ""
          ? controlElemToAdd?.style?.Label
          : controlElemToAdd.id;

    }
    

        
    if(controlElemToAdd?.controlName === "doclist") 
        controlElemToAdd.style.DocumentLabel =
            controlElemToAdd?.style?.DocumentLabel || controlElemToAdd?.style?.DocumentLabel === ""
            ? controlElemToAdd?.style?.DocumentLabel
            : controlElemToAdd.id;
    
    if (!alreadyPresentControlIds.includes(controlElemToAdd.id)) {
        alreadyPresentControlIds.push(controlElemToAdd.id);
        if (controlElemToAdd.children !== null && controlElemToAdd.children !== undefined) {
            controlElemToAdd.children.map(
                child => {
                    if (!alreadyPresentControlIds.includes(child.id)) {
                        alreadyPresentControlIds.push(child.id);
                    }
                }
            );
        }
    }
    
    var smartJson = formState;
    var controlElem = {};
    var jsonToSend = {};
    
    const isDesignerPageBlank = isEmptyObject(formState); 

    if (targetId === 'design_page') {
        if (isDesignerPageBlank) {

            if (elementTypeToCreate === 'section' || elementTypeToCreate === 'tab' || elementTypeToCreate === "wizard_h" || 
            elementTypeToCreate === "wizard_v" || elementTypeToCreate === "sidenavigation" || elementTypeToCreate === "Menu" ) {
                if (elementTypeToCreate === 'section') {
                    var FormDef = {};
                    FormDef.ControlType = "form";
                    FormDef.id = "FormDef";
                    FormDef.elem_type = "form";
                    FormDef.children = [];

                    var RootControl = {};
                    RootControl.id = "RootControl";
                    RootControl.elem_type = "form";
                    RootControl.children = [];

                    var Frame = {};
                    Frame = elementTypeToCreate;

                    RootControl.children.push(Frame);
                    FormDef.children.push(RootControl);
                    smartJson = FormDef;
                }
                if (elementTypeToCreate === 'tab') {
                    var FormDef = {};
                    FormDef.ControlType = "form";
                    FormDef.id = "FormDef";
                    FormDef.elem_type = "form";
                    FormDef.children = [];

                    var tab = {};
                    tab.id = createUniqueId('tab');
                    tab.elem_type = "tab";
                    tab.children = [];
                    tab.style = {};
                    for (let i = 1; i <= 4; i++) {
                        var tabChild = {};
                        tabChild.id = createUniqueId("tabChild");
                        tabChild.elem_type = 'tabChild';
                        tabChild.tabChildName = tabChild.id;
                        tabChild.ColumnLayout = "4";
                        tabChild.children = [];
                        tabChild.icon = { name: "", file: "" };
                        tabChild.style = {};
                        tab.children.push(tabChild);
                    }

                    tab.children.push(tabChild);
                    FormDef.children.push(tab);
                    smartJson = FormDef;
                }
                if (elementTypeToCreate === 'wizard_h' || elementTypeToCreate === 'wizard_v' || elementTypeToCreate === 'sidenavigation') {

                    var FormDef = {};
                    FormDef.ControlType = "form";
                    FormDef.id = "FormDef";
                    FormDef.elem_type = "form";
                    FormDef.children = [];

                    var RootControl = {};
                    RootControl.id = "RootControl";
                    RootControl.elem_type = "form";
                    RootControl.children = [];


                    var wizard = { ...controlElemToAdd };
                    wizard.children = [];

                    var i=0;
                    const addSteps= () => {
                        sendRequestForControl(frameIndex, 'add', "step", {loading:true})
                            .then((response) => {
                                var newStep = response.data;
                                newStep.stepName = newStep.id;
                                wizard.children.push(newStep);
                                i=i+1;
                                if(i<4){
                                    addSteps();
                                }
                                if(i === 3){
                                    setOpenQuickToolFor(controlElemToAdd?.id);
                                    window.loading(false);
                                }
                            })  
                            .catch((err) =>{
                                 console.log(err);
                                 window.loading(false)
                            })  
                    }

                    addSteps();
                    window.loading(true);

                    RootControl.children.push(wizard);
                    FormDef.children.push(RootControl);
                    smartJson = FormDef;
                }
                if(elementTypeToCreate=== "Menu"){

                    var FormDef = {};
                    FormDef.ControlType = "form";
                    FormDef.id = "FormDef";
                    FormDef.elem_type = "form";
                    FormDef.children = [];

                    var RootControl = {};
                    RootControl.id = "RootControl";
                    RootControl.elem_type = "form";
                    RootControl.children = [];


                    var menu = { ...controlElemToAdd };
                    menu.children = [];

                    var i=0;
                    const addSteps= () => {
                        
                        var extraDetails={};
                        extraDetails.elem_type="MainMenu";
                        extraDetails.loading = true;

                        sendRequestForControl(frameIndex, 'add', "step", extraDetails)
                            .then((response) => {
                                var newStep = response.data;
                                newStep.stepName = newStep.id;
                                menu.children.push(newStep);
                                i=i+1;
                                if(i<2){
                                    addSteps();
                                }
                                if(i === 1){
                                    setOpenQuickToolFor(controlElemToAdd?.id);
                                    window.loading(false);
                                }
                            })  
                            .catch((err) =>{
                                 console.log(err);
                                 window.loading(false)
                            })  
                    }

                    addSteps();
                    window.loading(true);

                    RootControl.children.push(menu);
                    FormDef.children.push(RootControl);
                    smartJson = FormDef;
                }
            } else {
                console.log('In order to add any form element, you need to first add a section or a tab');
            }
        }
        else {
            if (elementTypeToCreate === 'section' || elementTypeToCreate === 'frame' || elementTypeToCreate === 'tab' || elementTypeToCreate === 'wizard_h' || elementTypeToCreate === 'wizard_v' ||
                elementTypeToCreate === 'sidenavigation') {

                var FormDef = smartJson;
                var RootControl = FormDef.children[0];
                FormDef.children.map(
                    m => {
                        if (m.id === 'RootControl') {
                            RootControl = m;
                        }
                    }
                );
                if (elementTypeToCreate === 'section' || elementTypeToCreate === 'frame') {


                    var Frame = {};
                    if(controlElemToAdd?.isParentOfTab!==true){
                        var rowElement = {};
                        rowElement.id = createUniqueId('row');
                        rowElement.elem_type = 'row';
                        rowElement.frameIndex = controlElemToAdd.frameIndex;
                        rowElement.children = [];
                        rowElement.parent_id = controlElemToAdd.id;

                        var noOfCols = getNoOfCols() || parseInt(controlElemToAdd.ColumnLayout);
                        noOfCols = parseInt(noOfCols);

                        if(noOfCols < MaxIteration) {
                            for (let c = 0; c < (parseInt(noOfCols)); c++) {
                                var col = {};
                                col.id = createUniqueId('column');//newElement;
                                col.elem_type = 'column';
                                const w = 12 / parseInt(noOfCols);
                                col.w = getColumnLayout("web");
                                col.md = getColumnLayout( getCurrentDevice() || "web");
                                col.sm = getColumnLayout("tablet");
                                col.xs = getColumnLayout("mobile");
                                col.children = [];
                                col.style = {};
                                col.style["heightselect"] = "set";
                                col.frameIndex = controlElemToAdd.frameIndex;
                                rowElement.children.push(col);
                            }
                        }
                        if(extraDetails && extraDetails.notCreateRow == "true"){
                        
                        }else{
                            controlElemToAdd.children.push(rowElement);
                        }
                    }  
                    
                    Frame = controlElemToAdd;
                    
                    if(Frame.templateCategory){

                        if(Frame.templateCategory == "Header"){
                            if(RootControl.children[0] && (Frame.templateCategory == RootControl.children[0].templateCategory)){
                                RootControl.children.shift() ;
                            }
                            RootControl.children.unshift(Frame);
                        }
                        else if(Frame.templateCategory == "Footer"){
                            if(RootControl.children && RootControl.children[RootControl.children.length -1] && 
                                Frame.templateCategory == RootControl.children[RootControl.children.length -1].templateCategory){
                                RootControl.children.pop() ;
                            }
                            RootControl.children.push(Frame);
                        }
                        else {
                            RootControl.children.push(Frame);
                        }
                    }
                    else {  
                        if(RootControl.children && RootControl.children[RootControl.children.length -1] && 
                            RootControl.children[RootControl.children.length -1].templateCategory &&
                            RootControl.children[RootControl.children.length -1].templateCategory == "Footer"){
                            const existingFooterJson = RootControl.children.pop() ;
                            RootControl.children.push(Frame);
                            RootControl.children.push(existingFooterJson);
                        }
                        else
                            RootControl.children.push(Frame);
                    }

                    
                    FormDef.children = FormDef.children.map(
                        child => {
                            if (child.id === "RootControl") {
                                return RootControl;
                            } else {
                                return child;
                            }
                        }
                    );
                    smartJson = FormDef;
                }
                if (controlElemToAdd.elem_type === 'wizard_h' || controlElemToAdd.elem_type === 'wizard_v' || controlElemToAdd.elem_type === 'sidenavigation') {

                    var wizard = { ...controlElemToAdd };
                    wizard.children = [];

                    var i=0;
                    const addSteps= () => {
                        sendRequestForControl(frameIndex, 'add', "step", {loading:true})
                            .then((response) => {
                                var newStep = response.data;
                                newStep.stepName = newStep.id;
                                wizard.children.push(newStep);
                                i=i+1;
                                if(i<4){
                                    addSteps();
                                }
                                if(i === 3){
                                    setOpenQuickToolFor(controlElemToAdd?.id);
                                    window.loading(false);
                                }
                            })  
                            .catch((err) =>{
                                 console.log(err);
                                 window.loading(false)
                            })  
                    }
                    addSteps();
                    window.loading(true);
                    
                    RootControl.children.push(wizard);
                }
                if (elementTypeToCreate === 'tab') {
                    if (controlElemToAdd.elem_type === 'section' || controlElemToAdd.elem_type === 'frame') {
                        var section = controlElemToAdd;
                        section.isParentOfTab = true;
                        var tab = {};
                        tab.belongsToSection = section.id;
                        tab.frameIndex = frameIndex;
                        tab.id = createUniqueId('tab');
                        tab.elem_type = 'tab';
                        tab.ColumnLayout = "4";
                        tab.children = [];
                        tab.style = {};
                        for (let i = 1; i <= 4; i++) {
                            var tabChild = {};
                            tabChild.id = createUniqueId("tabChild");
                            tabChild.elem_type = 'tabChild';
                            tabChild.tabChildName = tabChild.id;
                            tabChild.ColumnLayout = "4";
                            tabChild.children = [];
                            tabChild.icon = { name: "", file: "" };

                            tab.children.push(tabChild);
                        }

                        section.children.push(tab);

                        RootControl.children.push(section);
                    } else if (controlElemToAdd.elem_type === 'frame' || controlElemToAdd.elem_type === 'section') {
                        RootControl.children.push(controlElemToAdd);
                    }
                    FormDef.children = FormDef.children.map(
                        child => {
                            if (child.id === 'RootControl') {
                                return RootControl;
                            } else {
                                return child;
                            }
                        }
                    );
                    smartJson = FormDef;
                }
            } else {
                console.log('Not allowed!')
            }
        }
    }
    else {
        var newJson = formState;
        var newJsonChildren = [];
        var cl;
        if (formState.ColumnLayout !== undefined) {
            cl = cl = parseInt(formState.ColumnLayout);
        } 
        else {
            cl = parseInt(column_layout);
        }

        for (let attr in formState) {
            if (formState['elem_type'] === 'frame' || formState['elem_type'] === 'headerframe') {
                cl = formState.ColumnLayout;
            }
            if (((formState.id === targetId) || ((formState?.tabChildName === targetId) && elementTypeToCreate === "section" && targetElemType === "tabChild")) && attr === 'id') {

                let newElement = {};// crating the new component to be dropped
                if (controlElemToAdd.id === undefined || controlElemToAdd.id === null) {
                    newElement.id = createUniqueId(elementTypeToCreate);
                }
                newElement.elem_type = elementTypeToCreate;

                if (newJson.elem_type === 'row') {

                    newJson.frameIndex = frameIndex;
                    //get all the column and controls it have in order to set the elementIndex for the specific Section/Frame
                    var totalControlsArray = [];

                    const response5 = newJson?.children ? newJson : {};
                    var columns = response5 ? response5?.children : [];
                    let columnsLength = columns?.length ? columns?.length : 0;
                    if(columnsLength > MaxLoopIteration) columnsLength = MaxLoopIteration;

                    if (columns !== undefined && columns !== null) {
                        if(columnsLength < MaxLoopIteration) {
                            for (let clm = 0; clm < columnsLength; clm++) {
                                var column = columns[clm];

                                const response7 = column?.children ? column : {};
                                var controls = response7 ? response7?.chiildren : [];
                                let controlLength = controls?.length ? controls?.length : 0;
    
                                if(controlLength > MaxLoopIteration) controlLength = MaxLoopIteration;
    
                                if (controls !== null && controls !== undefined) {
                                    if(controlLength < MaxLoopIteration) {
                                        for (let cntrl = 0; cntrl < controlLength; cntrl++) {
                                            totalControlsArray.push(controls[cntrl]);
                                        }
                                    }
                                }
                            }
                        }
                    }
                    elementIndex = totalControlsArray.length;
                }
                if (elementTypeToCreate === 'wizard_h' || elementTypeToCreate === 'wizard_v' || elementTypeToCreate === 'sidenavigation') {

                    var wizard = { ...controlElemToAdd };
                    wizard.children = [];                   

                    var i=0;
                    const addSteps= async() => {
                        sendRequestForControl(frameIndex, 'add', "step", {loading: true})
                            .then((response) => {
                                if(response.data.status === 0){
                                var newStep = response.data;
                                newStep.stepName = newStep.id;
                                wizard.children.push(newStep);
                                i=i+1;
                                if(i<parseInt(window?.psh_configs?.wizard_initial_step_count)){
                                    addSteps();
                                }
                                if(i===parseInt(window?.psh_configs?.wizard_initial_step_count)){
                                    setOpenQuickToolFor(controlElemToAdd?.id);
                                    const length=newJson.children.length;
                                    newJson.children[1]=wizard;
                                    extraDetails(wizard.id, wizard);
                                    window.loading(false);
                                    updateRenderState(wizard.id);
                                }
                                }
                                else if(response.data.status === 1){
                                    const x = getShowAlertNotificationFromStore()
                                    x({
                                      open: true,
                                      showConfirm: "showNotification",
                                      alertType: "error",
                                      alertContentKey:"Reopen_Form",
                                    });
                                  }
                            })
                            .catch((err) =>{
                                 console.log(err);
                                 window.loading(false)
                            })  
                    }

                    addSteps();
                    window.loading(true);

                }
                if (elementTypeToCreate === 'Menu') {

                    var menu = { ...controlElemToAdd };
                    menu.children = [];                   

                    var i=0;
                    const addSteps= async() => {
                        var extraDetails1={};
                        extraDetails1.elem_type="MainMenu";
                        extraDetails1.loading=true;

                        sendRequestForControl(frameIndex, 'add', "step", extraDetails1)
                            .then((response) => {
                                if(response.data.status === 0){
                                var newStep = response.data;
                                newStep.stepName = newStep.id;
                                menu.children.push(newStep);
                                i=i+1;
                                if(i<2){
                                    addSteps();
                                }
                                if(i===2){
                                    setOpenQuickToolFor(controlElemToAdd?.id);
                                    const length=newJson.children.length;
                                    const finalJson={...newJson};
                                    finalJson.children[1]={...menu};
                                    newJson={...finalJson};
                                    extraDetails(menu.id, menu);
                                    window.loading(false);

                                }
                                }
                                else if(response.data.status === 1){
                                    const x = getShowAlertNotificationFromStore()
                                    x({
                                      open: true,
                                      showConfirm: "showNotification",
                                      alertType: "error",
                                      alertContentKey:"Reopen_Form",
                                    });
                                  }
                            })
                            .catch((err) =>{
                                 console.log(err);
                                 window.loading(false)
                            })  
                    }

                    addSteps();
                    window.loading(true);
                    
                }
                if (elementTypeToCreate === 'column' && targetElemType === 'row') {

                    const w = 12 / parseInt(cl);
                    controlElemToAdd.w = getColumnLayout("web");
                    controlElemToAdd.md = getColumnLayout( getCurrentDevice() || "web");
                    controlElemToAdd.sm = getColumnLayout("tablet");
                    controlElemToAdd.xs = getColumnLayout("mobile");


                }
                else if (elementTypeToCreate === 'column' && targetElemType === 'section') {
                    var rowElem = {};
                    var col = newElement;
                    const w = 12 / parseInt(cl);
                    col.w = getColumnLayout("web");
                    col.md = getColumnLayout( getCurrentDevice() || "web");
                    col.sm = getColumnLayout("tablet");
                    col.xs = getColumnLayout("mobile");
                    col.children = [];
                    col.frameIndex = frameIndex;

                    rowElem.id = createUniqueId('row');
                    rowElem.children = [];
                    rowElem.elem_type = 'row';
                    rowElem.children.push(col);
                    rowElem.frameIndex = frameIndex;
                    rowElem.parent_id = newJson.id;
                    newElement = rowElem;
                }
                else if (elementTypeToCreate === 'section' && targetElemType === 'column') { 
                    //NEED TO REMOVE?
                    var rowForControlElemToAdd = {};
                    rowForControlElemToAdd.id = createUniqueId('row');
                    rowForControlElemToAdd.children = [];
                    rowForControlElemToAdd.elem_type = 'row';
                    rowForControlElemToAdd.frameIndex = frameIndex;
                    rowForControlElemToAdd.parent_id = newJson.id;
                    for (let c = 0; c < ( getNoOfCols() ); c++) {
                        var colElemForControlElemToAdd = {};
                        colElemForControlElemToAdd.id = createUniqueId('column',containerId);//newElement;
                        colElemForControlElemToAdd.elem_type = 'column';
                        const w = 12 / parseInt(controlElemToAdd.ColumnLayout);
                        colElemForControlElemToAdd.w = getColumnLayout("web");
                        colElemForControlElemToAdd.md = getColumnLayout( getCurrentDevice() || "web");
                        colElemForControlElemToAdd.sm = getColumnLayout("tablet");
                        colElemForControlElemToAdd.xs = getColumnLayout("mobile");
                        colElemForControlElemToAdd.children = [];
                        colElemForControlElemToAdd.frameIndex = frameIndex;
                        rowForControlElemToAdd.children.push(colElemForControlElemToAdd);
                    }

                    controlElemToAdd.children.push(rowForControlElemToAdd);

                    var rowElem = {};
                    var col = {};
                    col.id = createUniqueId('column',containerId);
                    const w = 12 / parseInt(cl);
                    col.w = getColumnLayout("web");
                    col.md = getColumnLayout( getCurrentDevice() || "web");
                    col.sm = getColumnLayout("tablet");
                    col.xs = getColumnLayout("mobile");
                    col.frameIndex = frameIndex;
                    col.children = [];
                    col.children.push(controlElemToAdd);

                    rowElem.id = createUniqueId('row');
                    rowElem.children = [];
                    rowElem.elem_type = 'row';
                    rowElem.frameIndex = frameIndex;
                    rowElem.parent_id = newJson.id;
                    rowElem.children.push(col);

                    for (let c = 0; c <  getNoOfCols() ; c++) {
                        var colElem = {};
                        colElem.id = createUniqueId('column',containerId);//newElement;
                        colElem.elem_type = 'column';
                        const w = 12 / parseInt(cl);
                        colElem.w = getColumnLayout("web");
                        colElem.md = getColumnLayout( getCurrentDevice() || "web");
                        colElem.sm = getColumnLayout("tablet");
                        colElem.xs = getColumnLayout("mobile");
                        colElem.children = [];
                        colElem.frameIndex = frameIndex;
                        rowElem.children.push(colElem);
                    }
                    newElement = rowElem;
                }
                else if (elementTypeToCreate === 'section' && targetElemType === 'row') {

                    var rowForControlElemToAdd = {};
                    rowForControlElemToAdd.id = createUniqueId('row');
                    rowForControlElemToAdd.children = [];
                    rowForControlElemToAdd.elem_type = 'row';
                    rowForControlElemToAdd.frameIndex = frameIndex;
                    rowForControlElemToAdd.parent_id = newJson.id;

                    let collayoutCM = parseInt(controlElemToAdd.ColumnLayout);
                    if(collayoutCM > MaxIteration) collayoutCM = MaxIteration;

                    if(collayoutCM < MaxIteration) {
                        for (let c = 0; c < collayoutCM; c++) {
                            var colElemForControlElemToAdd = {};
                            colElemForControlElemToAdd.id = createUniqueId('column',containerId);//newElement;
                            colElemForControlElemToAdd.elem_type = 'column';
                            const w = 12 / parseInt(controlElemToAdd.ColumnLayout);
                            colElemForControlElemToAdd.w = getColumnLayout("web");
                            colElemForControlElemToAdd.md = getColumnLayout( getCurrentDevice() || "web");
                            colElemForControlElemToAdd.sm = getColumnLayout("tablet");
                            colElemForControlElemToAdd.xs = getColumnLayout("mobile");
                            colElemForControlElemToAdd.children = [];
                            colElemForControlElemToAdd.frameIndex = frameIndex;
                            rowForControlElemToAdd.children.push(colElemForControlElemToAdd);
                        }
                    }
                    if(controlElemToAdd.children){
                        controlElemToAdd?.children?.push(rowForControlElemToAdd);
                    } else if(!controlElemToAdd.children && controlElemToAdd?.elem_type === "frame"){
                        let children = [rowForControlElemToAdd]
                        controlElemToAdd["children"] = children
                    }


                    var col = {};
                    col.id = createUniqueId('column',containerId);
                    col.elem_type = 'column';
                    const w = 12 / parseInt(cl);
                    col.w = getColumnLayout("web");
                    col.md = getColumnLayout( getCurrentDevice() || "web");
                    col.sm = getColumnLayout("tablet");
                    col.xs = getColumnLayout("mobile");
                    col.frameIndex = frameIndex;
                    col.style = {};
                    col.style["heightselect"] = "auto";
                    col.children = [];
                    col.children.push(controlElemToAdd);

                    controlElemToAdd = col;
                }
                else if (elementTypeToCreate === 'section' && targetElemType === 'section') {

                    controlElemToAdd.elem_type = 'section';

                    //columns and row for the newly announced section , that is yet to be added
                    var oneRowElem = {}
                    oneRowElem.id = createUniqueId('row');
                    oneRowElem.children = [];
                    oneRowElem.elem_type = 'row';
                    oneRowElem.frameIndex = frameIndex;
                    oneRowElem.parent_id = newJson.id;
                    if (controlElemToAdd.ColumnLayout !== undefined && controlElemToAdd.ColumnLayout !== null) {
                        //if the column layout is null or undefined then column layout should be 3
                    } else {
                        controlElemToAdd.ColumnLayout = 4;
                    }

                    let collayout_CM = parseInt(controlElemToAdd.ColumnLayout);
                    if(collayout_CM > MaxIteration) collayout_CM = MaxIteration;

                    if(collayout_CM < MaxIteration) {
                        for (let c = 0; c < collayout_CM; c++) {
                            var colElem = {};
                            colElem.id = createUniqueId('column',containerId);//newElement;
                            colElem.elem_type = 'column';
                            const w = 12 / parseInt(controlElemToAdd.ColumnLayout);
                            colElem.w = getColumnLayout("web");
                            colElem.md = getColumnLayout( getCurrentDevice() || "web");
                            colElem.sm = getColumnLayout("tablet");
                            colElem.xs = getColumnLayout("mobile");
                            colElem.children = [];
                            colElem.frameIndex = frameIndex;
                            col.style = {};
                            col.style["heightselect"] = "set";
                            oneRowElem.children.push(colElem);
                        }
                    }
                    if (controlElemToAdd.children !== null && controlElemToAdd.children !== undefined) {
                        controlElemToAdd.children.push(oneRowElem);
                    } else {
                        controlElemToAdd.children = [];
                        controlElemToAdd.children.push(oneRowElem);
                    }

                    var rowElem = {};
                    var col = {};
                    col.elem_type = 'column';
                    col.id = createUniqueId('column');
                    const w = 12 / parseInt(cl);
                    col.w = getColumnLayout("web");
                    col.md = getColumnLayout( getCurrentDevice() || "web");
                    col.sm = getColumnLayout("tablet");
                    col.xs = getColumnLayout("mobile");
                    col.style = {};
                    col.style["heightselect"] = "set";
                    col.frameIndex = frameIndex;
                    col.children = [];
                    col.children.push(controlElemToAdd);

                    rowElem.id = createUniqueId('row');
                    rowElem.children = [];
                    rowElem.elem_type = 'row';
                    rowElem.frameIndex = frameIndex;
                    rowElem.parent_id = newJson.id;
                    rowElem.children.push(col);

                    for (let c = 0; c < (parseInt(cl) - 1); c++) {
                        var colElem = {};
                        colElem.id = createUniqueId('column');//newElement;
                        colElem.elem_type = 'column';
                        const w = 12 / parseInt(cl);
                        colElem.w = getColumnLayout("web");
                        colElem.md = getColumnLayout( getCurrentDevice() || "web");
                        colElem.sm = getColumnLayout("tablet");
                        colElem.xs = getColumnLayout("mobile");
                        colElem.children = [];
                        col.style = {};
                        col.style["heightselect"] = "set";
                        colElem.frameIndex = frameIndex;
                        rowElem.children.push(colElem);
                    }
                    newElement = rowElem;


                }
                else if ((newElement.elem_type === 'frame' || newElement.elem_type === 'section') && targetId === 'RootControl') {

                    if (controlElemToAdd.isParentOfTab !== true) {
                        var rowElement = {};
                        rowElement.id = createUniqueId('row');
                        rowElement.elem_type = 'row';
                        rowElement.frameIndex = controlElemToAdd.frameIndex;
                        rowElement.children = [];
                        rowElement.parent_id = newJson.id;
                        var noOfCols = parseInt(controlElemToAdd.ColumnLayout);
                        if(extraDetails?.dataObjectDrop) {
                            if(noOfCols < extraDetails?.count) 
                            noOfCols = extraDetails?.count;
                    }
                    if(noOfCols > MaxIteration && !extraDetails?.dataObjectDrop) noOfCols = MaxIteration;
                    
                    let currentColLayout = getNoOfCols()
                    if(noOfCols % currentColLayout !== 0) {
                        noOfCols = noOfCols > currentColLayout ? currentColLayout * (parseInt(noOfCols / currentColLayout) + 1) : currentColLayout;
                    }

                        if(noOfCols < MaxIteration || extraDetails?.dataObjectDrop) {
                            for (let c = 0; c < noOfCols; c++) {
                                var col = {};
                                col.id = createUniqueId('column');//newElement;
                                col.elem_type = 'column';
                                const w = 12 / parseInt(noOfCols);
                                col.w = getColumnLayout("web");
                                col.md = getColumnLayout( getCurrentDevice() || "web");
                                col.sm = getColumnLayout("tablet");
                                col.xs = getColumnLayout("mobile");
                                col.children = [];
                                col.style = {};
                                col.style["heightselect"] = "set";
                                col.frameIndex = controlElemToAdd.frameIndex;
                                rowElement.children.push(col);
                            }
                        }
                        if(extraDetails && extraDetails.notCreateRow == "true"){

                        } else {
                            controlElemToAdd.children.push(rowElement);
                        }
                        
                    }
                }
                else if (elementTypeToCreate === 'sheet') {
                    var rowElement = {};
                    rowElement.id = createUniqueId('row');
                    rowElement.elem_type = 'row';
                    rowElement.frameIndex = controlElemToAdd.frameIndex;
                    rowElement.children = [];
                    rowElement.parent_id = newJson.id;

                    var noOfCols = parseInt(controlElemToAdd.ColumnLayout);
                    if(noOfCols > MaxIteration) noOfCols = MaxIteration;

                    if(noOfCols < MaxIteration) {
                        for (let c = 0; c < noOfCols; c++) {
                            var col = {};
                            col.id = createUniqueId('column');//newElement;
                            col.elem_type = 'column';
                            const w = 12 / parseInt(noOfCols);
                            col.w =getColumnLayout("web");
                            col.md = getColumnLayout( getCurrentDevice() || "web");
                            col.sm = getColumnLayout("tablet");
                            col.xs = getColumnLayout("mobile");
                            col.children = [];
                            col.style = {};
                            col.style["heightselect"] = "set";
                            col.frameIndex = controlElemToAdd.frameIndex;
                            rowElement.children.push(col);
                        }
                    } 
                    if(extraDetails && extraDetails.notCreateRow == "true"){

                    } else {
                        controlElemToAdd.children.push(rowElement);
                    }
                }
                else if(elementTypeToCreate === 'tab' && targetElemType === "column") {
                    const response1 = controlElemToAdd?.children ? controlElemToAdd : {};
                    const response2 = response1 ? (response1?.children ? response1.children : []) : [];
                    let loopLength = response2?.length ? response2?.length : 0;

                    if(loopLength > MaxLoopIteration) loopLength = MaxLoopIteration;

                    if(loopLength < MaxLoopIteration) {
                        for(let q = 0; q < loopLength; q++) {
                            var rowElement = {};
                            rowElement.id = createUniqueId('row');
                            rowElement.elem_type = 'row';
                            rowElement.frameIndex = controlElemToAdd.frameIndex;
                            rowElement.children = [];
                            rowElement.parent_id = newJson.id;
    
                            let ColumnLayout = controlElemToAdd.children[q]["ColumnLayout"]
                            ColumnLayout = parseInt(ColumnLayout);
                            
                            if(ColumnLayout < MaxIteration) {
                                for (let c = 0; c < ColumnLayout; c++) {
                                    var col = {};
                                    col.id = createUniqueId('column');//newElement;
                                    col.elem_type = 'column';
                                    const w = 12 / parseInt(ColumnLayout);
                                    col.w =getColumnLayoutContainers("web");
                                    col.md = getColumnLayoutContainers( getCurrentDevice() || "web");
                                    col.sm = getColumnLayoutContainers("tablet");
                                    col.xs = getColumnLayoutContainers("mobile");
                                    col.children = [];
                                    col.style = {};
                                    col.style["heightselect"] = "set";
                                    col.frameIndex = controlElemToAdd.frameIndex;
                                    rowElement.children.push(col);
                                }
                            }
                            if(extraDetails && extraDetails.notCreateRow == "true"){
        
                            } else {
                                controlElemToAdd.children[q].children.push(rowElement);
                            }
                        }
                    }
                }
                if (
                    formState['elem_type'] === 'textbox' ||
                    formState['elem_type'] === 'datepick' ||
                    formState['elem_type'] === 'doclist' ||
                    formState['elem_type'] === 'combo' ||
                    formState['elem_type'] === 'checkbox' ||
                    formState['elem_type'] === 'radio' ||
                    formState['elem_type'] === 'phonenumber' ||
                    formState['elem_type'] === 'password' ||
                    formState['elem_type'] === 'email' ||
                    formState['elem_type'] === 'button' ||
                    formState['elem_type'] === 'textarea' ||
                    formState['elem_type'] === 'listbox' ||
                    formState['elem_type'] === 'toggle' ||
                    formState['elem_type'] === 'multiSelect' ||
                    formState['elem_type'] === 'table' ||
                    formState['elem_type'] === 'listview' ||
                    formState['elem_type'] === 'advancelistview' ||
                    formState['elem_type'] === 'advancelistView' ||
                    formState['elem_type'] === 'label' ||
                    formState['elem_type'] === 'link' ||
                    formState['elem_type'] === 'paragraph' ||
                    formState['elem_type'] === 'iframe' ||
                    formState['elem_type'] === 'richtexteditor' ||
                    formState['elem_type'] === 'slider' ||
                    formState['elem_type'] === 'tile' ||
                    formState['elem_type'] === 'report' ||
                    formState['elem_type'] === 'captcha' ||
                    formState['elem_type'] === 'password'
                ) {
                }
                else {
                    if (
                        elementTypeToCreate === 'textbox' ||
                        elementTypeToCreate === 'datepick' ||
                        elementTypeToCreate === 'doclist' ||
                        elementTypeToCreate === 'combo' ||
                        elementTypeToCreate === 'checkbox' ||
                        elementTypeToCreate === 'email' ||
                        elementTypeToCreate === 'password' ||
                        elementTypeToCreate === 'radio' ||
                        elementTypeToCreate === 'phonenumber' ||
                        elementTypeToCreate === 'button' ||
                        elementTypeToCreate === 'textarea' ||
                        elementTypeToCreate === 'listbox' ||
                        elementTypeToCreate === 'multiSelect' ||
                        elementTypeToCreate === 'toggle' ||
                        elementTypeToCreate === 'tab' ||
                        elementTypeToCreate === 'table' ||
                        elementTypeToCreate.toLowerCase() === 'listview' ||
                        elementTypeToCreate === 'advancelistview' ||
                        elementTypeToCreate === 'advancelistView' ||
                        elementTypeToCreate === 'label' ||
                        elementTypeToCreate === 'link' ||
                        elementTypeToCreate === 'paragraph' ||
                        elementTypeToCreate === 'picklist' ||
                        elementTypeToCreate === 'image' ||
                        elementTypeToCreate === 'iframe' ||
                        elementTypeToCreate === 'richtexteditor' ||
                        elementTypeToCreate === 'slider' ||
                        elementTypeToCreate === 'imagecarousel' ||
                        elementTypeToCreate === 'slider' ||
                        elementTypeToCreate === 'tile' ||
                        elementTypeToCreate === 'report' ||
                        elementTypeToCreate === 'captcha'

                    ) {

                        if (targetElemType === 'section' || targetElemType === 'frame') {                            

                            var control = {};

                            control = controlElemToAdd; 
                            control.elem_type = elementTypeToCreate;
                            if(elementTypeToCreate==='tab'){
                                const response1 = control?.children ? control : {};
                                const response2 = response1 ? (response1?.children ? response1.children : []) : [];
                                let loopLength = response2?.length ? response2?.length : 0;
                                if(loopLength > MaxLoopIteration) loopLength = MaxLoopIteration;


                                if(control.children && (loopLength > 0)){
                                    if(loopLength < MaxLoopIteration) {
                                        for(let sheetCount=0; sheetCount < loopLength; sheetCount++){
                                            let ColumnLayout = control.children[sheetCount]["ColumnLayout"];
                                            if (
                                              ColumnLayout !== null &&
                                              ColumnLayout !== undefined &&
                                              ColumnLayout !== ""
                                            ) {
                                              try {
                                                ColumnLayout = parseInt(ColumnLayout);
                                                if(ColumnLayout > MaxIteration) ColumnLayout = MaxIteration;
                                                var rowElem = {};
                                                rowElem.id = createUniqueId("row");
                                                rowElem.children = [];
                                                rowElem.elem_type = "row";
                                                rowElem.frameIndex = frameIndex;
                                                rowElem.parent_id = newJson.id;
                                                if(ColumnLayout < MaxIteration) {
                                                    for (let clm = 0; clm < ColumnLayout; clm++) {
                                                      var col = {};
                                                      col.id = createUniqueId("column"); //newElement;
                                                      col.elem_type = "column";
                                                      const w = 12 / ColumnLayout;
                                                      col.w = getColumnLayout("web");
                                                      col.md = getColumnLayout( getCurrentDevice() || "web");
                                                      col.sm = getColumnLayout("tablet");
                                                      col.xs = getColumnLayout("mobile");
                                                      col.children = [];
                                                      col.style = {};
                                                      col.style["heightselect"] = "set";
                                                      col.frameIndex = frameIndex;
                                                      rowElem.children.push(col);
                                                    }
                                                }
                                                if (control.children[sheetCount].children)
                                                  control.children[sheetCount].children.push(
                                                    rowElem
                                                  );
                                                else {
                                                  control.children[sheetCount].children = [];
                                                  control.children[sheetCount].children.push(
                                                    rowElem
                                                  );
                                                }
                                              } catch (error) {
                                                 console.log(error);
                                              }
                                            }
                                        }
                                    }
                                }
                                
                            }

                            if (ThemeJSON[elementTypeToCreate] !== null && ThemeJSON[elementTypeToCreate] !== undefined) {

                                if (control.style === undefined || control.style === null) {
                                    control.style = ThemeJSON[control['elem_type']];
                                } else if (isEmptyObject(control.style) > 0) {
                                    var control_style = control.style;
                                    var control_theme = ThemeJSON[elementTypeToCreate];
                                    for (let theme_prop in control_theme) {
                                        if (!control_style.hasOwnProperty(theme_prop)) {
                                            control.style[theme_prop] = control_theme[theme_prop];
                                        }
                                    }
                                }
                            } 
                            else {
                                if (control.style === undefined) {
                                    control.style = ThemeJSON[control['elem_type']];

                                }
                            }

                            if (elementTypeToCreate === 'richtexteditor') {
                                control.elem_type = 'textarea';
                            }
                            if (control.elem_type === 'tab' && newJson.isParentOfTab === true) {
                                newElement = control;
                            } 
                            else {
                                let rowElem = {};
                                rowElem.id = createUniqueId('row');
                                rowElem.children = [];
                                rowElem.elem_type = 'row';
                                rowElem.frameIndex = frameIndex;
                                rowElem.parent_id = newJson.id;

                                var colm = {};
                                colm.id = createUniqueId('column');//newElement;
                                colm.elem_type = 'column';
                                const w = 12 / parseInt(cl);
                                colm.w = getColumnLayout("web");
                                colm.md = getColumnLayout( getCurrentDevice() || "web");
                                colm.sm = getColumnLayout("tablet");
                                colm.xs = getColumnLayout("mobile");
                                colm.children = [];
                                colm.frameIndex = frameIndex;
                                colm.children.push(control);
                                rowElem.children.push(colm);

                                for (let c = 0; c <  getNoOfCols(); c++) {
                                    var col = {};
                                    col.id = createUniqueId('column');//newElement;
                                    col.elem_type = 'column';
                                    const w = 12 / parseInt(cl);
                                    col.w = getColumnLayout("web");
                                    col.md = getColumnLayout( getCurrentDevice() || "web");
                                    col.sm = getColumnLayout("tablet");
                                    col.xs = getColumnLayout("mobile");
                                    col.children = [];
                                    col.style = {};
                                    col.style["heightselect"] = "set";
                                    col.frameIndex = frameIndex;
                                    rowElem.children.push(col);
                                }
                                newElement = rowElem;

                            }
                        }
                        else if (targetElemType === 'row') {
                                var cols=[];
                                var col = {};
                                col.id = createUniqueId('column');
                                col.elem_type = 'column';
                                const w = 12 / parseInt(cl);
                                col.w = getColumnLayout("web");
                                col.md = getColumnLayout( getCurrentDevice() || "web");
                                col.sm = getColumnLayout("tablet");
                                col.xs = getColumnLayout("mobile");
                                col.children = [];
                                if(formState.isWizardHeader)
                                    col.isWizardHeader = true;
                                col.style = {};
                                col.style["heightselect"] = "set";
                                col.frameIndex = frameIndex;
    
                                var control = {};
                                control = controlElemToAdd;
                                control.elem_type = elementTypeToCreate;
                                
    
                                if (ThemeJSON[elementTypeToCreate] !== null && ThemeJSON[elementTypeToCreate] !== undefined) {
                                    if (control.style === undefined || control.style === null) {
                                        control.style = ThemeJSON[control['elem_type']];
                                    } else if (isEmptyObject(control.style) > 0) {
                                        var control_style = control.style;
                                        var control_theme = ThemeJSON[elementTypeToCreate];
                                        for (let theme_prop in control_theme) {
                                            if (!control_style.hasOwnProperty(theme_prop)) {
                                                control.style[theme_prop] = control_theme[theme_prop];
                                            }
                                        }
                                    }
                                } 
                                else {
                                    if (control.style === undefined) {
                                        control.style = {};
                                    }
                                }
                                if (elementTypeToCreate === 'richtexteditor') {
                                    control.elem_type = 'textarea';
                                }
                                col.children.push(control);
                                cols.push(col);
    
                                if(targetRowId.includes("after_row")){
                                    var noOfColumnsToAdd= getNoOfCols();
                                    if(noOfColumnsToAdd){
                                        noOfColumnsToAdd =  getNoOfCols();
                                    }
                                    if( newJson?.children?.length % noOfColumnsToAdd!==0 ){
                                        noOfColumnsToAdd = noOfColumnsToAdd - newJson?.children?.length%noOfColumnsToAdd ;
                                    }
                                    
                                    if(noOfColumnsToAdd > MaxIteration) noOfColumnsToAdd = MaxIteration;

                                    
                                    if(noOfColumnsToAdd < MaxIteration) {
                                        const colCheck = noOfColumnsToAdd -1 ;
                                        // if(colCheck===1){
                                        //     colCheck = 2;
                                        // }
                                        for(let i=0; i<colCheck ; i++){
                                            var col_extra = {};
                                            col_extra.id = createUniqueId('column');
                                            col_extra.elem_type = 'column';
                                            const w = 12 / parseInt(cl);
                                            col_extra.w = getColumnLayout("web");
                                            col_extra.md = getColumnLayout( getCurrentDevice() || "web");
                                            col_extra.sm = getColumnLayout("tablet");
                                            col_extra.xs = getColumnLayout("mobile");
                                            col_extra.children = [];
                                            col.style = {};
                                            if(formState.isWizardHeader){
                                                col.isWizardHeader = true;
                                                col_extra.isWizardHeader = true;
                                            }
                                            col.style["heightselect"] = "set";
                                            col_extra.style = {};
                                            col_extra.style["heightselect"] = "set";
                                            col_extra.frameIndex = frameIndex;
                                            col_extra.style = {};
                                            col_extra.style["heightselect"] = "set";
        
                                            cols.push(col_extra);
                                            console.log('json_We_Got::col_extra',col_extra);
        
                                        }
                                    }
                                }
                                console.log('json_We_Got::cols',cols);
    
                                if(targetRowId.includes("after_row")){
                                    newElement= undefined;
                                    newJson.children.push(...cols);
                                    console.log('json_We_Got::newElement',newElement,newJson);
                                }
                                else{
                                    newElement = col;
                                }
                        }
                        else if (targetElemType === 'column' || targetElemType === 'column_tabChild') {
                            if (ThemeJSON[elementTypeToCreate] !== null && ThemeJSON[elementTypeToCreate] !== undefined) {
                                if (controlElemToAdd.style === undefined || controlElemToAdd.style === null) {
                                    controlElemToAdd.style = ThemeJSON[controlElemToAdd['elem_type']];
                                } else if (isEmptyObject(controlElemToAdd.style) > 0) {
                                    var controlElemToAdd_style = controlElemToAdd.style;
                                    var controlElemToAdd_theme = ThemeJSON[elementTypeToCreate];
                                    for (let theme_prop in controlElemToAdd_theme) {
                                        if (!controlElemToAdd_style.hasOwnProperty(theme_prop)) {
                                            controlElemToAdd.style[theme_prop] = controlElemToAdd_theme[theme_prop];
                                        }
                                    }
                                }
                            } else {
                                if (controlElemToAdd.style === undefined) {
                                    controlElemToAdd.style = {};
                                }
                            }                                 
                            newElement = controlElemToAdd;
                        }
                        else if (targetElemType === 'tabChild') {
                            var rowElem = {};
                            rowElem.id = createUniqueId('row');
                            rowElem.children = [];
                            rowElem.elem_type = 'row';
                            rowElem.frameIndex = frameIndex;
                            rowElem.parent_id = newJson.id;

                            var col = {};
                            col.id = createUniqueId('column');
                            col.elem_type = 'column';
                            const w = 12 / parseInt(cl);
                            col.w = getColumnLayout("web");
                            col.md = getColumnLayout( getCurrentDevice() || "web");
                            col.sm = getColumnLayout("tablet");
                            col.xs = getColumnLayout("mobile");
                            col.children = [];
                            col.style = {};
                            col.style["heightselect"] = "set";
                            col.frameIndex = frameIndex;

                            var control = {};
                            control = controlElemToAdd;
                            control.elem_type = elementTypeToCreate;
                            if (control.style === undefined || control.style === null) {
                                control.style = ThemeJSON[control['elem_type']];
                                } else if (isEmptyObject(control.style) > 0) {
                                    var controlElemToAdd_style = control.style;
                                    var controlElemToAdd_theme = ThemeJSON[elementTypeToCreate];
                                    for (let theme_prop in controlElemToAdd_theme) {
                                        if (!controlElemToAdd_style.hasOwnProperty(theme_prop)) {
                                            control.style[theme_prop] = controlElemToAdd_theme[theme_prop];
                                        }
                                    }
                                }

                            if (elementTypeToCreate === 'richtexteditor') {
                                control.elem_type = 'textarea';
                            }
                            col.children.push(control);
                            rowElem.children.push(col);

                            for (let rm = 0; rm <  getNoOfCols()-1; rm++) {
                                var colm = {};
                                colm.id = createUniqueId('column');
                                colm.elem_type = 'column';
                                const w = 12 / parseInt(cl);
                                colm.w = getColumnLayout("web");
                                colm.md = getColumnLayout( getCurrentDevice() || "web");
                                colm.sm = getColumnLayout("tablet");
                                colm.xs = getColumnLayout("mobile");
                                colm.children = [];
                                colm.style = {};
                                colm.style["heightselect"] = "set";
                                colm.frameIndex = frameIndex;
                                rowElem.children.push(colm);
                            }

                            newElement = rowElem;
                            
                        }

                    }
                    else {
                        if(elementTypeToCreate === 'section' && (targetElemType.toLowerCase() === 'step' || targetElemType.toLowerCase() === 'substep')) {

                                newElement = controlElemToAdd;
                                if(controlElemToAdd?.isParentOfTab!==true){
                                    var rowElement = {};
                                    rowElement.id = createUniqueId('row');
                                    rowElement.elem_type = 'row';
                                    rowElement.frameIndex = controlElemToAdd.frameIndex;
                                    rowElement.children = [];
                                    rowElement.parent_id = controlElemToAdd.id;
                                
                                    var noOfCols = parseInt(controlElemToAdd.ColumnLayout);
                                    for (let c = 0; c <  getNoOfCols(); c++) {
                                        var col = {};
                                        col.id = createUniqueId('column');//newElement;
                                        col.elem_type = 'column';
                                        const w = 12 / parseInt(noOfCols);
                                        col.w = getColumnLayout("web");
                                        col.md = getColumnLayout( getCurrentDevice() || "web");
                                        col.sm = getColumnLayout("tablet");
                                        col.xs = getColumnLayout("mobile");
                                        col.children = [];
                                        col.style = {};
                                        col.style["heightselect"] = "set";
                                        col.frameIndex = controlElemToAdd.frameIndex;
                                        rowElement.children.push(col);
                                    }
                                    if(extraDetails && extraDetails.notCreateRow == "true"){
                                    
                                    }else{
                                        controlElemToAdd.children.push(rowElement);
                                    }
                                }  

                                newElement = controlElemToAdd;

                                if (newElement.elem_type === 'row') {
                                    for (let c = 0; c <  getNoOfCols(); c++) {
                                        var col = {};
                                        col.id = createUniqueId('column');//newElement;
                                        col.elem_type = 'column';
                                        const w = 12 / parseInt(cl);
                                        col.w = getColumnLayout("web");
                                        col.md = getColumnLayout( getCurrentDevice() || "web");
                                        col.sm = getColumnLayout("tablet");
                                        col.xs = getColumnLayout("mobile");
                                        col.children = [];
                                        col.style = {};
                                        col.style["heightselect"] = "set";
                                        col.frameIndex = frameIndex;
                                        newElement.children.push(col);
                                    }
                                }
                            }
                            else {                               
                                newElement = controlElemToAdd;
                                if (newElement.elem_type === 'row') {
                                    for (let c = 0; c < (parseInt(cl)); c++) {
                                        let col = {};
                                        col.id = createUniqueId('column');//newElement;
                                        col.elem_type = 'column';
                                        const w = 12 / parseInt(cl);
                                        col.w = getColumnLayout("web");
                                        col.md = getColumnLayout( getCurrentDevice() || "web");
                                        col.sm = getColumnLayout("tablet");
                                        col.xs = getColumnLayout("mobile");
                                        col.children = [];
                                        col.style = {};
                                        col.style["heightselect"] = "set";
                                        col.frameIndex = frameIndex;
                                        newElement.children.push(col);
                                    }
                                } 
                                else if ((newElement.elem_type === 'frame') || (newElement.elem_type === 'headerframe') || (newElement.elem_type === 'section')) {
                                    if(newElement && (newElement['isParentOfTab']===true)){
                                        // No need to add any row when Section is a parent of Tab and that Tab is dropped over
                                    } 
                                    else {
                                        const rowPresent=(newElement?.children?.length>0 && newElement?.children?.[0]?.elem_type==="row" ) || false;
                                        if(!rowPresent){
                                        let row ={};
                                        row.elem_type='row';
                                        row.children=[];
                                        row.id=createUniqueId('row');
                                        row.frameIndex=newElement['frameIndex'];
                                        row.sheetIndex=formState['sheetIndex'];
                                        row.parent_id= newElement?.id;
                                        row.sheetElementIndex = newElement["sheetElementIndex"]
                                        let noofCols = getNoOfColsContainers();
                                        if(extraDetails?.dataObjectDrop) {
                                            if(parseInt(noofCols) < extraDetails?.count) 
                                                noofCols = extraDetails?.count;
                                        }
                                        let currentColLayout = getNoOfCols()
                                        if(noofCols % currentColLayout !== 0) {
                                            noofCols = noofCols > currentColLayout ? currentColLayout * (parseInt(noofCols / currentColLayout) + 1) : currentColLayout;
                                        }
                                        for (let c = 0; c <  noofCols ; c++) {
                                            let col = {};
                                            col.id = createUniqueId('column');//newElement;
                                            col.elem_type = 'column';
                                            const w = 12 / parseInt(cl);
                                            col.w = getColumnLayoutContainers("web");
                                            col.md = getColumnLayoutContainers( getCurrentDevice() || "web");
                                            col.sm = getColumnLayoutContainers("tablet");
                                            col.xs = getColumnLayoutContainers("mobile");
                                            col.children = [];
                                            col.frameIndex = frameIndex;
                                            col.style = {};
                                            col.style["heightselect"] = "set";
                                            col.sheetElementIndex = newElement["sheetElementIndex"]
                                            row.children.push(col);
                                        }

                                        if(extraDetails && extraDetails.notCreateRow == "true"){

                                        }
                                        else{
                                            if (newElement.children)
                                                newElement.children.push(row);
                                            else {
                                                newElement.children=[];
                                                newElement.children.push(row);
                                            }
                                        }
                                    }
                                    }
                                }
                            }
                        if (elementTypeToCreate !== 'section' && frameIndex) {
                            newElement.frameIndex = frameIndex;
                        }
                        if (newElement.children === undefined) {
                            newElement.children = [];
                        }

                    }
                    if (newJson.children !== undefined && newElement) {
                        if (targetElemType === 'form' && (newElement.elem_type === 'row' || newElement.elem_type === 'column')) {
                            //row can't be placed over the form directly
                            console.log(newElement.elem_type + " can't be placed over the form directly!")
                        }
                        else if (targetElemType === 'column' && newElement.elem_type === 'row') {
                            //row can't be placed inside the column
                            console.log("Row can't be placed inside the column!");
                        } 
                        else {
                            if (targetRowId !== undefined && targetRowId !== '' && targetRowId !== null && (targetElemType === 'section' || targetElemType === 'sheet' || targetElemType === 'tabChild')) {
                                var positionToPlace = -1; // -1 means position to place is not found
                                if (targetRowId.startsWith('before_')) {
                                    positionToPlace = 0; //0 means the control will be put at the same position as of index
                                } else if (targetRowId.startsWith('after_')) {
                                    positionToPlace = 1; //1 means control will be put after the position of found index
                                }
                                var idToFind = targetRowId.replace('before_', '').replace('after_', '');
                                var indexFound = -1;
                                formState.children.map(
                                    (child, index) => {
                                        if (child.id === idToFind) {
                                            indexFound = index;
                                        }
                                    }
                                )
                                if (indexFound !== -1) {
                                    if (positionToPlace !== -1) {
                                        //control will be added only if the postion (before/after) is detected
                                        newJson.children.splice((indexFound + positionToPlace), 0, newElement);
                                    }
                                }
                            }
                            else if (targetRowId === '' && targetRowId !== null && (targetElemType === 'form') && (targetRowId.startsWith('before_') || targetRowId.startsWith('after_'))) {
                                var positionToPlace = -1; // -1 means position to place is not found
                                if (targetRowId.startsWith('before_')) {
                                    positionToPlace = 0; //0 means the control will be put at the same position as of index
                                } else if (targetRowId.startsWith('after_')) {
                                    positionToPlace = 1; //1 means control will be put after the position of found index
                                }
                                var idToFind = targetRowId.replace('before_', '').replace('after_', '');
                                var indexFound = -1;
                                formState.children.map(
                                    (child, index) => {
                                        if (child.id === idToFind) {
                                            indexFound = index;
                                        }
                                    }
                                )
                                if (indexFound !== -1) {
                                    if (positionToPlace !== -1) {
                                        //control will be added only if the postion (before/after) is detected
                                        newJson.children.splice((indexFound + positionToPlace), 0, newElement);
                                    }
                                }
} else if (targetColId === '' && targetColId !== null && (targetElemType === 'form') && (targetColId.startsWith('before_') || targetColId.startsWith('after_'))) {
                                var positionToPlace = -1; // -1 means position to place is not found
                                if (targetColId.startsWith('before_')) {
                                    positionToPlace = 0; //0 means the control will be put at the same position as of index
                                } else if (targetColId.startsWith('after_')) {
                                    positionToPlace = 1; //1 means control will be put after the position of found index
                                }
                                var idToFind = targetColId.replace('before_', '').replace('after_', '');
                                var indexFound = -1;
                                formState.children.map(
                                    (child, index) => {
                                        if (child.id === idToFind) {
                                            indexFound = index;
                                        }
                                    }
                                )
                                if (indexFound !== -1) {
                                    if (positionToPlace !== -1) {
                                        //control will be added only if the postion (before/after) is detected
                                        newJson.children.splice((indexFound + positionToPlace), 0, newElement);
                                    }
                                }
                            }
                            else if(targetColId && targetColId !== "" && targetColId !== null && (targetColId.startsWith('before_') || targetColId.startsWith('after_'))){
                                let colIndex = "";
                                let columnId = targetColId.startsWith('before_') ? targetColId.slice(7,) : targetColId.slice(6,)
                                let currentColLayout = getNoOfCols()
                                let currentColWidth = 12 / currentColLayout;
                                let oldColWidth = 12 / currentColLayout
                                let newColWidth = 12 / currentColLayout

                                newJson?.children?.forEach((val, Idx) => {
                                    if(val?.id === columnId){
                                        colIndex = Idx
                                        currentColWidth = val?.w
                                    }
                                })

                                if(currentColLayout <= 6){
                                    if(currentColWidth > 1){
                                        oldColWidth = currentColWidth >= 4 ? Math.ceil(currentColWidth / 2) : currentColWidth % 2 === 0 ? Math.ceil(currentColWidth / 2) : 2
                                        newColWidth = currentColWidth >= 4 ? Math.floor(currentColWidth / 2) : currentColWidth % 2 === 0 ? Math.floor(currentColWidth / 2) : 1
                                        if(newColWidth > (12 / currentColLayout)){
                                            newColWidth = 12 / currentColLayout
                                            oldColWidth = currentColWidth - newColWidth
                                        }
                                    }else{
                                        oldColWidth = 1
                                        newColWidth = 1
                                    }
                                }

                                let updatedOldCol = newJson?.children?.map((val) => {
                                    if(val?.id === columnId){
                                        return ({...val, md:oldColWidth, w: oldColWidth, sm:oldColWidth, xs:oldColWidth})
                                    }else{
                                        return ({...val})
                                    }
                                })
                                newJson.children.splice(0, newJson?.children?.length, ...updatedOldCol)
                                newElement = {...newElement, md: newColWidth, w: newColWidth, sm:newColWidth, xs:newColWidth}


                                if(targetColId.startsWith('before_')){
                                    if(newJson.children && newJson.children[newJson.children.length -1] &&
                                        newJson.children[newJson.children.length -1].templateCategory &&
                                        newJson.children[newJson.children.length -1].templateCategory == "Footer"){
                                        const existingFooterJson = newJson.children.pop() ;
                                        newJson.children.push(newElement);
                                        newJson.children.push(existingFooterJson);
                                    }
                                    else{
                                        newJson.children.splice(colIndex, 0, newElement);
                                    }
                                }else{
                                    if(newJson.children && newJson.children[newJson.children.length -1] &&
                                        newJson.children[newJson.children.length -1].templateCategory &&
                                        newJson.children[newJson.children.length -1].templateCategory == "Footer"){
                                        const existingFooterJson = newJson.children.pop() ;
                                        newJson.children.push(newElement);
                                        newJson.children.push(existingFooterJson);
                                    }
                                    else{
                                        newJson.children.splice(colIndex + 1, 0, newElement);
                                    }
                                }
                                
                            }
                            else {
                                if(newJson.children && newJson.children[newJson.children.length -1] &&
                                    newJson.children[newJson.children.length -1].templateCategory &&
                                    newJson.children[newJson.children.length -1].templateCategory == "Footer"){
                                    const existingFooterJson = newJson.children.pop() ;
                                    newJson.children.push(newElement);
                                    newJson.children.push(existingFooterJson);
                                }
                                else{
                                    newJson.children.push(newElement);
                                }
                            }
                        }
                    } 
                    else {
                        if(newElement){
                            newJson.children = [];
                            newJson.children.push(newElement);
                        }
                    }
                }
                controlFound_createSmartFormState=true;
            }
            if (attr === 'children' && controlFound_createSmartFormState===false ) {
                if (formState.children.length > 0) {
                    formState.children.map(
                        child => {
                            createSmartFormState(child, targetId, targetElemType, elementTypeToCreate, cl, frameIndex, controlElemToAdd, targetRowId, targetColId,device,extraDetails, containerId, parentCall=false);
                        }
                    );
                }
            }
            else {
                newJson[attr] = formState[attr];
            }
        }
            smartJson = {...newJson};
        }
        
        controlFound_createSmartFormState=false;
    return smartJson;
}

export const validIndexFunction = (data) => {
    if(data === undefined || data === null || data?.toString() === "-1"){
        return false
    }
    else{
        return true
    }
}


export const recurseJson = (obj, frameIndex, insideSubForm) => {
    var newJSON = {};
    var newJSONChildren = [];
    var colComps = [];
    var sheetArray = [];
    for (let key in obj) {
        if (obj.elem_type === 'button' && key === 'subform') {
            let subformObj = obj[key];
            let updatedSubFormObj = recurseJson(subformObj, 0, true);
            obj[key] = updatedSubFormObj;
        }
        
        if (obj.elem_type === 'advancelistview' && key === 'listviewFrameLayoutJson') {
            let subformObj = obj[key];
            let updatedSubFormObj = recurseJson(subformObj, 0, true);
            obj[key] = updatedSubFormObj;
        }

        
        if (key !== 'children') {

            newJSON[key] = obj[key];

        } else {
            var children = obj.children;
            var column_layout = 0;
            var colWidth = 0;
            if (obj.elem_type === 'frame' || obj.elem_type === 'headerframe') {
                if (insideSubForm) {
                    frameIndex = parseInt(elemIdCountStateForSubForm.section) + "";
                } else {
                    frameIndex = parseInt(elemIdCountState.section) + "";
                }
                column_layout = obj.ColumnLayout;
                if (column_layout !== undefined) {
                    colWidth = 12 / column_layout;
                }
            }
            if (obj.elem_type === 'sheet') {
                column_layout = obj.style.ColumnLayout;
                if (column_layout !== undefined) {
                    colWidth = 12 / column_layout;
                }
            }
            if (children !== undefined) {
                children.map(
                    child => {
                        if (
                            child['elem_type'] === 'textbox' ||
                            child['elem_type'] === 'doclist' ||
                            child['elem_type'] === 'datepick' ||
                            child['elem_type'] === 'combo' ||
                            child['elem_type'] === 'checkbox' ||
                            child['elem_type'] === 'radio' ||
                            child['elem_type'] === 'textarea' ||
                            child['elem_type'] === 'button' ||
                            child['elem_type'] === 'email' ||
                            child['elem_type'] === 'password' ||
                            child['elem_type'] === 'textarea' ||
                            child['elem_type'] === 'listbox' ||
                            child['elem_type'] === 'multiSelect' ||
                            child['elem_type'] === 'table' ||
                            child['elem_type'] === 'listview' ||
                            child['elem_type'] === 'advancelistview' ||
                            child['elem_type'] === 'advancelistView' ||
                            child['elem_type'] === 'label' ||
                            child['elem_type'] === 'link' ||
                            child['elem_type'] === 'toggle' ||
                            child['elem_type'] === 'paragraph' ||
                            child['elem_type'] === 'tab' ||
                            child['elem_type'] === 'sheet' ||
                            child['elem_type'] === 'picklist' ||
                            child['elem_type'] === 'image' ||
                            child['elem_type'] === 'iframe' ||
                            child['elem_type'] === 'richtexteditor' ||
                            child['elem_type'] === 'slider' ||
                            child['elem_type'] === 'imagecarousel' ||
                            child['elem_type'] === 'slider' ||
                            child['elem_type'] === 'tile' ||
                            child['elem_type'] === 'wizard_h' ||
                            child['elem_type'] === 'wizard_v' ||
                            child['elem_type'] === 'sidenavigation' ||
                            child['elem_type'] === 'report' ||
                            child['elem_type'] === 'captcha' ||
                            child['elem_type'] === 'EmptyRow' ||
                            child['elem_type'] === 'EmptyCell' 
                        ) {
                            if (child['elem_type'] === 'tab' ||
                                child['elem_type'] === 'sheet') {
                                 
                            }

                            alreadyPresentControlIds.push(child.id);
                            var controlJson = recurseJson(child, (parseInt(frameIndex) - 1), insideSubForm);
                             
                            controlJson.frameIndex = (parseInt(frameIndex) - 1);
                             
                            if (ThemeJSON[controlJson['elem_type']] !== null && ThemeJSON[controlJson['elem_type']] !== undefined) {
                                 
                                if (controlJson.style === undefined || controlJson.style === null) {
                                    controlJson.style = ThemeJSON[controlJson['elem_type']];
                                } else if (!isEmptyObject(controlJson.style)) {
                                    var controlJson_style = controlJson.style;
                                    var controlJson_theme = ThemeJSON[controlJson['elem_type']];
                                    for (let theme_prop in controlJson_theme) {
                                        if (!controlJson_style.hasOwnProperty(theme_prop)) {
                                            controlJson.style[theme_prop] = controlJson_theme[theme_prop];
                                        }
                                    }
                                }
                            } else {
                                 
                                if (controlJson.style === undefined) {
                                    controlJson.style = {};
                                }
                            }
                            //make columns and wrapping the controls with column
                            if (controlJson.elem_type !== "sheet") {
                                //creating column object
                                let columnObject = {};
                                if (controlJson.elem_type !== "EmptyCell")
                                  columnObject.id = createUniqueId("column");
                                else{
                                    columnObject.id = controlJson.id;
                                    columnObject.isEmptyCell = true;
                                }
                                columnObject.elem_type = 'column';

                                if (frameIndex !== -1) {
                                    columnObject.frameIndex = (parseInt(frameIndex) - 1);
                                }
                                if (controlJson.merge_section !== undefined) {
                                    columnObject.merge_section = controlJson.merge_section;
                                } else {
                                    columnObject.merge_section = "1";
                                }
                                columnObject.GroupId = controlJson.GroupId;
                                columnObject.GroupingValue = controlJson.GroupingValue;
                                columnObject.w = parseInt(colWidth);
                                let columnChildren = [];
                                if(controlJson.elem_type!=='EmptyCell' && controlJson.elem_type!=='EmptyRow'){
                                    columnChildren.push(controlJson);
                                    columnObject.children = columnChildren;
                                    colComps.push(columnObject);
                                } else if (controlJson.elem_type === "EmptyRow"){
                                    colComps.push(controlJson);
                                } else {
                                    colComps.push(columnObject);
                                }
                            } else {
                                sheetArray.push(controlJson);
                            }
                        } else {
                            if (child['elem_type'] === 'frame' && !insideSubForm) {
                                frameIndex = elemIdCountState.section + '';
                                elemIdCountState.section = elemIdCountState.section + 1;
                                child.frameIndex = frameIndex + '';
                            } else if (child['elem_type'] === 'frame' && insideSubForm) {
                                frameIndex = elemIdCountStateForSubForm.section + '';
                                elemIdCountStateForSubForm.section = elemIdCountStateForSubForm.section + 1;
                                child.frameIndex = frameIndex + '';
                            }
                             

                            if (ThemeJSON[child['elem_type']] !== null && ThemeJSON[child['elem_type']] !== undefined) {
                                if (child.style === undefined || child.style === null) {
                                    child.style = ThemeJSON[child['elem_type']];
                                } else if (isEmptyObject(child.style) === false) {
                                    var child_style = child.style;
                                    var child_theme = ThemeJSON[child['elem_type']];
                                    for (let theme_prop in child_theme) {
                                        if (!child_style.hasOwnProperty(theme_prop)) {
                                            child.style[theme_prop] = child_theme[theme_prop];
                                            if (theme_prop === 'ControlStyle' && child['elem_type'] === 'tab') {
                                                child.style[theme_prop] = 'Style1';
                                            }
                                        }
                                        else if (child_style.hasOwnProperty(theme_prop)) {
                                            //some styles should be overriden with defaults or not?
                                            if (theme_prop === 'ControlStyle' && child['elem_type'] === 'tab') {
                                                child.style[theme_prop] = 'Style1';
                                            }
                                        }
                                    }
                                }
                            } else {
                                if (child.style === undefined) {
                                    child.style = {};
                                }
                            }


                            newJSONChildren.push(recurseJson(child, parseInt(frameIndex), insideSubForm));
                        }
                    }
                )

                //New coding logic starts here
                
                if (colComps.length > 0) {
                    if (column_layout !== undefined && column_layout!='') {
                        try{
                            parseInt(column_layout);
                        } catch(err) {
                            console.error(err);
                            column_layout = 1;
                        }
                            var totRows = [];
                            var presentRow;
                            let colsAddedSoFar=0;
                            let previousGroupId;
                            let elementIndex = 0;

                            var rowObj = {};
                            rowObj.id = createUniqueId("row");
                            rowObj.elem_type = "row";
                            rowObj.frameIndex = frameIndex - 1;
                            rowObj.children = [];

                            var rowChildren = [];
                            presentRow = rowObj;

                            for(let r=0;colsAddedSoFar<colComps.length;r++){
                                if(colComps[colsAddedSoFar].elem_type!=='EmptyRow'){
                                    let presentGroupId = colComps[colsAddedSoFar].GroupId;
                                    if(previousGroupId===undefined)
                                        previousGroupId = presentGroupId;
                                    if (presentGroupId !== "" && presentGroupId!==undefined && presentGroupId!==null){
                                        presentRow.haveGrouping=true;
                                        var presentColm = colComps[colsAddedSoFar];
                                        
                                        const GroupingValue = colComps[colsAddedSoFar].GroupingValue;
                                        presentColm.w = GroupingValue;
                                        presentColm.xs = GroupingValue;
                                        presentColm.sm = GroupingValue;
                                        presentColm.md = GroupingValue;
    
                                        if(previousGroupId===presentGroupId){
                                            var presentColmChildren = [];
                                            if(presentColm.children && presentColm.children.length>0){
                                                for(let tempCount=0;tempCount<presentColm.children.length; tempCount++){
                                                    var tempCtrl = presentColm.children[tempCount];
                                                    tempCtrl.elementIndex = elementIndex+'';
                                                    presentColmChildren.push(tempCtrl);
                                                    elementIndex++;
                                                }
                                                presentColm.children = presentColmChildren;
                                            } else {
                                                presentColm.children = presentColmChildren;
                                            }
                                            presentRow.children.push(presentColm);
                                        } else {
                                            totRows.push(presentRow);
                                            previousGroupId = presentGroupId;
                                            var newRow = {};
                                            newRow.id = createUniqueId("row");
                                            newRow.elem_type = "row";
                                            newRow.frameIndex = frameIndex - 1;
                                            newRow.children = [];
    
                                            presentRow = newRow;
    
                                            var presentColmChildren = [];
                                            if(presentColm.children && presentColm.children.length>0){
                                                for(let tempCount=0;tempCount<presentColm.children.length; tempCount++){
                                                    var tempCtrl = presentColm.children[tempCount];
                                                    tempCtrl.elementIndex = elementIndex+'';
                                                    presentColmChildren.push(tempCtrl);
                                                    elementIndex++;
                                                }
                                                presentColm.children = presentColmChildren;
                                            } else {
                                                presentColm.children = presentColmChildren;
                                            }
                                            presentRow.children.push(presentColm);
                                        }
                                    } else {
                                        if(presentRow.haveGrouping && presentRow.haveGrouping===true){
                                            totRows.push(presentRow);
                                             var newRow = {};
                                             newRow.id = createUniqueId("row");
                                             newRow.elem_type = "row";
                                             newRow.frameIndex = frameIndex - 1;
                                             newRow.children = [];
    
                                             presentRow = newRow;
                                        }
                                        let mobileColWidth=12;
                                        let tabColWidth = 6;
                                        let webColWidth = 12/ parseInt(column_layout);
                                        var spaceLeft = false;
                                        var presentColm = colComps[colsAddedSoFar];
                                        if(presentRow.children.length<column_layout){
                                            let spaceAquiredSoFar=0;
                                            for(let tc=0;tc<presentRow.children.length;tc++){
                                                spaceAquiredSoFar += presentRow.children[tc].w;
                                            }
                                            if(spaceAquiredSoFar<12){
                                                if((spaceAquiredSoFar+webColWidth)<=12){
                                                    let merge_section;// = presentColm.children[0].merge_section;
                                                    if(!presentColm.id.includes('EmptyCell'))
                                                        merge_section = presentColm.children[0].merge_section;
                                                    else
                                                        merge_section = presentColm.merge_section;
                                                    if(merge_section!==undefined && merge_section!==null && merge_section!==''){
                                                        merge_section = parseInt(merge_section);
                                                    } else {
                                                        merge_section = 1;
                                                    }
                                                    let requiredSpace = merge_section * webColWidth;
                                                    if(requiredSpace <= (12-spaceAquiredSoFar)){
                                                        spaceLeft = true;
                                                    } else {
                                                        spaceLeft = false;
                                                    }
                                                }
                                            }
                                        } else {
                                            spaceLeft = false;
                                        }
                                        if(presentRow.children.length<column_layout && spaceLeft){
    
                                            let merge_section;
                                            if(!presentColm.id.includes('EmptyCell'))
                                                merge_section = presentColm.children[0].merge_section;
                                            else
                                                merge_section = presentColm.merge_section;
                                            try{
                                                parseInt(merge_section);
                                            } catch(err){
                                                merge_section = 1;
                                            }
                                            if (merge_section>1) {
                                              let requiredSpace = merge_section * webColWidth;
                                              presentColm.w = requiredSpace;
                                              presentColm.xs = requiredSpace;
                                              presentColm.sm = requiredSpace;
                                              presentColm.md = requiredSpace;
                                            } else {
                                              presentColm.w = webColWidth;
                                              presentColm.xs = mobileColWidth;
                                              presentColm.sm = tabColWidth;
                                              presentColm.md = webColWidth;
                                            }
    
                                            var presentColmChildren = [];
                                            if(presentColm.children && presentColm.children.length>0){
                                                for(let tempCount=0;tempCount<presentColm.children.length; tempCount++){
                                                    var tempCtrl = presentColm.children[tempCount];
                                                    tempCtrl.elementIndex = elementIndex+'';
                                                    presentColmChildren.push(tempCtrl);
                                                    elementIndex++;
                                                }
                                                presentColm.children = presentColmChildren;
                                            } else {
                                                presentColm.children = presentColmChildren;
                                            }
                                            presentRow.children.push(presentColm);
                                        } else {
                                            totRows.push(presentRow);
                                            var newRow = {};
                                            newRow.id = createUniqueId("row");
                                            newRow.elem_type = "row";
                                            newRow.frameIndex = frameIndex - 1;
                                            newRow.children = [];
    
                                            presentRow = newRow;
    
                                            let merge_section;
                                            if(!presentColm.id.includes('EmptyCell'))
                                                merge_section = presentColm.children[0].merge_section;
                                            else
                                                merge_section = presentColm.merge_section;
                                            try{
                                                parseInt(merge_section);
                                            } catch(err){
                                                merge_section = 1;
                                            }
                                            if (merge_section>1) {
                                              let requiredSpace = merge_section * webColWidth;
                                              presentColm.w = requiredSpace;
                                              presentColm.xs = requiredSpace;
                                              presentColm.sm = requiredSpace;
                                              presentColm.md = requiredSpace;
                                            } else {
                                              presentColm.w = webColWidth;
                                              presentColm.xs = mobileColWidth;
                                              presentColm.sm = tabColWidth;
                                              presentColm.md = webColWidth;
                                            }
    
    
                                            var presentColmChildren = [];
                                            if(presentColm.children && presentColm.children.length>0){
                                                for(let tempCount=0;tempCount<presentColm.children.length; tempCount++){
                                                    var tempCtrl = presentColm.children[tempCount];
                                                    tempCtrl.elementIndex = elementIndex+'';
                                                    presentColmChildren.push(tempCtrl);
                                                    elementIndex++;
                                                }
                                                presentColm.children = presentColmChildren;
                                            } else {
                                                presentColm.children = presentColmChildren;
                                            }
                                            presentRow.children.push(presentColm);
                                        }
    
                                    }

                                } else {
                                    totRows.push( presentRow);
                                    var emptyRow = {};
                                    emptyRow.id = colComps[colsAddedSoFar].id;//createUniqueId("row");
                                    emptyRow.elem_type = "row";
                                    emptyRow.frameIndex = frameIndex - 1;
                                    emptyRow.isEmptyRow = true;
                                    emptyRow.children = [];

                                    totRows.push(emptyRow);

                                    var rowObj = {};
                                    rowObj.id = createUniqueId("row");
                                    rowObj.elem_type = "row";
                                    rowObj.frameIndex = frameIndex - 1;
                                    rowObj.children = [];

                                    presentRow = rowObj;
                                    
                                }
                                colsAddedSoFar++;
                            }
                            
                            totRows.push( presentRow);

                            for (let i = 0; i < totRows.length; i++) {
                                newJSONChildren.push(totRows[i]);
                            }
                    }
                }


                if (sheetArray.length > 0 && obj.elem_type === 'tab') {
                    for (let i = 0; i < sheetArray.length; i++) {
                        newJSONChildren.push(sheetArray[i]);
                    }
                }
                newJSON.children = newJSONChildren;
                          
            }
        }
    }
    return newJSON;
};

export const addRowObject = (frameIndexRow, sectionId, colLayout) =>{

    var rowObj = {};
    rowObj.id = createUniqueId("row");
    rowObj.elem_type = "row";
    rowObj.frameIndex = parseInt(frameIndexRow) ;
    rowObj.children = [];
    rowObj.parent_id = sectionId;


     var noOfCols = parseInt(colLayout);
        var col = {};
        col.id = createUniqueId('column');//newElement;
        col.elem_type = 'column';
        const w = 12 / parseInt(noOfCols);
        col.w = getColumnLayout("web");
        col.md = getColumnLayout( getCurrentDevice() || "web");
        col.sm = getColumnLayout("tablet");
        col.xs = getColumnLayout("mobile");
        col.children = [];
        col.style = {};
        col.style["heightselect"] = "set";
        col.frameIndex = frameIndexRow;
        rowObj.children.push(col);
    return rowObj;

}

export const addColumnObject = (frameIndexRow,w) =>{

    var col = {};
    col.id = createUniqueId('column');//newElement;
    col.elem_type = 'column';
    col.w = getColumnLayout("web");
    col.md = getColumnLayout( getCurrentDevice() || "web");
    col.sm = getColumnLayout("tablet");
    col.xs = getColumnLayout("mobile");
    col.style = {};
    col.style["heightselect"] = "set";
    col.merge_section = "1";
    col.children = [];
    col.frameIndex = frameIndexRow;

    return col;
   
}

function isEmptyObject(obj) {
    return !Object.keys(obj).length;
}

function searchItemAndUpdate(children,searchItem){
    for(let item of children){
      if(item.children){
        searchItemAndUpdate(item.children,searchItem)
      }
      if(item.treeName === searchItem){
        item.isMapped = false
      }
    }
}

export const searchDataObjectsAndReturnChild = (children, searchItem) => {
    for(let item of children){
      if(item.children){
        const result = searchDataObjectsAndReturnChild(item.children,searchItem)
        if(result){
            return result
        }
      }
      if(item.treeName === searchItem){
        return item.children
      }
    }
    return undefined
}

export const removeMappingFromControl = (controlJson,updatedComponentInFormState,dataObject,setCurrentMappedDO,setfilteredDataObject, controlNAMEE , formState2) => {
    searchItemAndUpdate(dataObject,controlJson.dataclass)
    setCurrentMappedDO((prev) => {
        const result = prev.filter((item) => item != controlJson.dataclass);
        return [...result];
      });
    
    var hasChild;
    if (controlJson.unBounded === "Y") {
        if (
            controlJson.elem_type === "table" ||
            controlJson.elem_type === "listview" ||
            controlJson.elem_type === "advancelistView"
        ) {
            hasChild = true;
        } else {
            hasChild = false;
        }
    } else if (controlJson.unBounded === "N") {
        hasChild = false;
    }


    const jsonToSend = {
        mappedField: controlJson?.dataclass,
        unbounded: controlJson?.unBounded,
        isProcessVar:
            controlJson?.dataObjectType === "M"
                ? false
                : controlJson?.dataObjectType === "P"
                    ? true
                    : "",
        formId: getFormId().toString(),
        hasChild: hasChild,
    };

    removeMapping(jsonToSend)
        .then((response) => {
            window.loading(false);
        })
        .catch((error) => {
            window.loading(false);
            console.error('removeMapping failed', error);
        });

    if(controlJson.style){
        controlJson.style.Label = controlJson?.style?.Label || controlJson?.id;
    }
    delete controlJson?.dataclass
    delete controlJson?.datamapid
    delete controlJson?.datamapVariableType
    delete controlJson?.TypeOfValue
    delete controlJson?.datamapPercision
    delete controlJson?.datamapVariableLength
    delete controlJson?.dataObjectType
    delete controlJson?.unBounded
    delete controlJson?.style?.Mapping
    delete controlJson?.style?.MappingId
    
    if(controlJson.elem_type === "textbox") {
        delete controlJson?.style?.masking
    }
    if(controlJson.elem_type === "CustomControl" && controlJson.controlName === "tile"){
        delete controlJson?.Mapping  
    }
    if (controlJson.elem_type === "doclist") {
        delete controlJson?.style?.["AllowAutoCreation"];
        delete controlJson?.style?.["AllowAutoCreationDO"];
    }
    if(controlJson.elem_type === "table" || 
        controlJson.elem_type === "listview" || 
        controlJson.elem_type?.toLowerCase() === "advancelistview"
    ) {
        if(controlJson?.columnList?.length) {
            controlJson.columnList.forEach(item=>{
                delete item?.style?.["AssociatedField"];
                delete item?.style?.["complexFieldName"];
                delete item?.style?.["associatedControlId"];
                delete item?.style?.["complexFieldType"];
                delete item?.style?.["complexFieldVariableLength"];
                delete item?.style?.["complexFieldVariablePrecision"];
                // item.style["MaxLength"] = ThemeJSON?.tableColumn1?.["MaxLength"]
                // item.style["AllowAlphabets"] = ThemeJSON?.tableColumn1?.["AllowAlphabets"]
                // item.style["AllowNull"] = ThemeJSON?.tableColumn1?.["AllowNull"]
                // item.style["AllowSpaces"] = ThemeJSON?.tableColumn1?.["AllowSpaces"]
                // item.style["AllowSpecialChars"] = ThemeJSON?.tableColumn1?.["AllowSpecialChars"]
                // item.style["AllowNumbers"] = ThemeJSON?.tableColumn1?.["AllowNumbers"]
                // item.style["MinValue"] = ThemeJSON?.tableColumn1?.["MinValue"]
                // item.style["MaxValue"] = ThemeJSON?.tableColumn1?.["MaxValue"]
            })
        }
        if(controlJson?.listviewFrameLayoutJson){
            removeMappingFromGridChild(controlJson?.listviewFrameLayoutJson)
        }
    }
    if(controlJson.elem_type === "frame"){
        delete controlJson?.style?.["SectionKeyField"]
        delete controlJson?.style?.["SectionKeyValue"]
    }
    setfilteredDataObject(dataObject)
    if(controlNAMEE ==="subform"){
        fetchAndUpdateJSON( JSON.parse(JSON.stringify(formState2)), controlJson.id , controlJson );
    }
    else{
        updatedComponentInFormState(controlJson.id ,controlJson)
    }
}

const removeMappingFromGridChild = (controlJson,updatedComponentInFormState,dataObject,setCurrentMappedDO,setfilteredDataObject) => {
    if(controlJson?.dataclass){
       controlJson.style.Label = controlJson?.style?.Label || controlJson?.id;
       delete controlJson?.dataclass
       delete controlJson?.datamapid
       delete controlJson?.datamapVariableType
       delete controlJson?.TypeOfValue
       delete controlJson?.datamapPercision
       delete controlJson?.datamapVariableLength
       delete controlJson?.dataObjectType
       delete controlJson?.unBounded
       delete controlJson?.style?.Mapping
       delete controlJson?.style?.MappingId
    }
    if(controlJson.elem_type === "table" || controlJson.elem_type === "listview") {
       if(controlJson?.columnList?.length) {
           controlJson.columnList.forEach(item=>{
               delete item?.style?.["AssociatedField"];
               delete item?.style?.["complexFieldName"];
               delete item?.style?.["associatedControlId"];
               delete item?.style?.["complexFieldType"];
               delete item?.style?.["complexFieldVariableLength"];
               delete item?.style?.["complexFieldVariablePrecision"];
           })
       }
       if(controlJson?.listviewFrameLayoutJson){
           removeMappingFromGridChild(controlJson?.listviewFrameLayoutJson)
       }
   }
    if(controlJson?.children && controlJson?.children?.length > 0){
       controlJson?.children?.map((controlJsonChild) => {
           removeMappingFromGridChild(controlJsonChild, updatedComponentInFormState)
       })
    }
   }

let enableValue = true;
let readOnlyValue = false;

export const findFrameEnableOrNot = (frameId,formState) => {
    if (formState?.children) {
        for(let i=0; i<formState.children.length;i++){
            if (formState.children[i].id === frameId) {
                enableValue = formState?.children[i]?.style?.Enable || true;
            }
            else if(formState.children[i].subform && formState.children[i].elem_type === "button") {
                findFrameEnableOrNot(frameId,formState.children[i].subform);
            }
            else if(formState.children[i].listviewFrameLayoutJson && formState.children[i].elem_type === "advancelistView") {
                findFrameEnableOrNot(frameId,formState.children[i].listviewFrameLayoutJson);
            }
            else {
                findFrameEnableOrNot(frameId,formState.children[i]);
            }
        }
    }
    return enableValue;
}

export const findFrameReadOnlyOrNot = (frameId,formState) => {
    if (formState?.children) {
        for(let i=0; i<formState.children.length;i++){
            if (formState.children[i].id === frameId) {
                readOnlyValue = formState?.children[i]?.style?.ReadOnly || false;
            }
            else if(formState.children[i].subform && formState.children[i].elem_type === "button") {
                findFrameEnableOrNot(frameId,formState.children[i].subform);
            }
            else if(formState.children[i].listviewFrameLayoutJson && formState.children[i].elem_type === "advancelistView") {
                findFrameEnableOrNot(frameId,formState.children[i].listviewFrameLayoutJson);
            }
            else {
                findFrameEnableOrNot(frameId,formState.children[i]);
            }
        }
    }
    return readOnlyValue;
}

export function getMicroFrontendDataToken(containerId)
{
    const state=formStateStore.getState();
    const data=formStateStore.getState().data;

    if(containerId===undefined){
        containerId=getContainerId()
    }

    let microFrontendData= state.data.find(json => json.key === containerId)?.formMataData?.token;

    if(!microFrontendData){
        microFrontendData = (state.data.find(json => json.formMataData.token.length > 0))?.formMataData?.token;
    }
    
    return microFrontendData;
}

export const updateSheetId = (state, updatedIndex) => {
        state.sheetIndex = updatedIndex;
        state.sheetId = updatedIndex;
    if (state?.children) {
        for(let i=0; i < state.children.length;i++){
            if(state.children[i].children) {
                updateSheetId(state.children[i],updatedIndex);
            }
            else if(state.children[i].tileContents) {
                    state.children[i].sheetIndex = updatedIndex;
                    state.children[i].sheetId = updatedIndex;
                for(let j = 0 ; j < state.children[i].tileContents.length; j++) {
                        state.children[i].tileContents[j].sheetIndex = updatedIndex;
                        state.children[i].tileContents[j].sheetId = updatedIndex;
                }
            }
            else {
                    state.children[i].sheetIndex = updatedIndex;
                    state.children[i].sheetId = updatedIndex;
            }
        }
    }
    else {
        return;
    }
}

const allPrimitiveControlList = [
  "textbox",
    "password",
    "frame",
    "textarea",
    "richtexteditor",
    "datepick",
    "slider",
    "listbox",
    "combo",
    "tab",
    "radio",
    "checkbox",
    "toggle",
    "tile",
    "doclist",
    "picklist",
    "button",
    "link",
    "label",
    "paragraph",
    "table",
    "listview",
    "advancelistview",
    "image",
    "imagecarousel",
    "report",
    "iframe",
    "captcha",
    "sheet",
    "CustomControl",
  ];

export const createNewId = (stateData, activeStep,activeStepIndex, activeSubStepIndex, activeChildSubStepIndex) => {
    if (Array.isArray(stateData)) {
        for(let state of stateData) {
            if(allPrimitiveControlList.includes(state.elem_type)) {
                if(activeChildSubStepIndex || activeChildSubStepIndex === 0)
                    state.idNew = `${state.id}_${activeStep}_${activeStepIndex}_${activeSubStepIndex}_${activeChildSubStepIndex}`;
                else if(activeSubStepIndex || activeSubStepIndex === 0)
                    state.idNew = `${state.id}_${activeStep}_${activeStepIndex}_${activeSubStepIndex}`
                else state.idNew = `${state.id}_${activeStep}_${activeStepIndex}`;  
                if(state.tileContents) {
                    for(const elem of state.tileContents) {
                        if(activeSubStepIndex || activeSubStepIndex === 0)
                            elem.idNew = `${elem.id}_${activeStep}_${activeStepIndex}_${activeSubStepIndex}`
                        else elem.idNew = `${elem.id}_${activeStep}_${activeStepIndex}`;  
                    }  
            }
        }
        if (state?.children) {
            for(const element of state.children){
                if(allPrimitiveControlList.includes(element.elem_type)) {
                    if(activeChildSubStepIndex || activeChildSubStepIndex === 0)
                        element.idNew = `${element.id}_${activeStep}_${activeStepIndex}_${activeSubStepIndex}_${activeChildSubStepIndex}`
                    else if(activeSubStepIndex || activeSubStepIndex === 0)
                        element.idNew = `${element.id}_${activeStep}_${activeStepIndex}_${activeSubStepIndex}`
                    else element.idNew = `${element.id}_${activeStep}_${activeStepIndex}`;  
                    if(element.tileContents) {
                        for(const elem of element.tileContents) {
                            if(activeChildSubStepIndex || activeChildSubStepIndex === 0)
                                elem.idNew = `${elem.id}_${activeStep}_${activeStepIndex}_${activeSubStepIndex}_${activeChildSubStepIndex}`
                            else if(activeSubStepIndex || activeSubStepIndex === 0)
                                elem.idNew = `${elem.id}_${activeStep}_${activeStepIndex}_${activeSubStepIndex}`
                            else elem.idNew = `${elem.id}_${activeStep}_${activeStepIndex}`;  
                        }  
                    }
                }
                if(element.children) {
                    createNewId(element,activeStep,activeStepIndex,activeSubStepIndex);
                }
                else if(element.subform && element.elem_type === "button") {
                    createNewId(element.subform,activeStep,activeStepIndex,activeSubStepIndex);
                }
                else if(element.listviewFrameLayoutJson && element.elem_type === "advancelistView") {
                    createNewId(element.listviewFrameLayoutJson,activeStep,activeStepIndex,activeSubStepIndex);
                }
            }
        }
    }
    }
}


const containsSubsteps = (json, find) =>{
    const findKey=find?.toLowerCase();
    return json?.children?.findIndex(function(child){return child?.elem_type?.toLowerCase()=== findKey })!==-1
}

export const makeChildrenEmpty = (data, check = false) => {
    data?.children?.map((child) => {
        if(containsSubsteps(child,"substep")) {
            child.children?.map((newChild) => {
                if(newChild.subformName || check) {
                    newChild.children = [];
                }
            })
        }
        else {
            if(child.subformName || check)
                child.children = [];
        }
    })
}

export const updateStepIndex = (state, updatedIndex, type) => {
    if(state?.[type])
        state[type] = updatedIndex;
    if (state?.children && !state.subformName) {
        for(let i=0; i < state.children.length;i++){
            if(state.children[i].children && !state.children[i].subformName) {
                updateStepIndex(state.children[i],updatedIndex,type);
            }
            else if(state.children[i].tileContents) {
                if(state.children[i]?.[type])
                    state.children[i].type = updatedIndex;
                for(let j = 0 ; j < state.children[i].tileContents.length; j++) {
                    if(state.children[i].tileContents[j]?.[type])
                        state.children[i].tileContents[j][type] = updatedIndex;
                }
            }
            else {
                if(state.children[i]?.[type])
                    state.children[i][type] = updatedIndex;
            }
        }
    }
    else {
        return;
    }
}

export const changeControlProperty = (val,field,formState) => {
    if(formState?.children) {
        for(let i = 0; i < formState.children.length; i++) {
            if(formState.children[i].style && formState.children[i].id !== 'GroupInfo' && formState.children[i].id !== 'Event') {
                if(field === "Enable") {
                    formState.children[i].style.Enable = val;
                    if(formState.children[i].elem_type === "textbox" && (val === false || val === "false"))
                        formState.children[i].style.AutoComplete = false;
                    if(formState.children[i].elem_type ==="doclist"){
                        formState.children[i].style.updateFormState = Date.now();
                    }
                }
                else if(field === "ReadOnlyStyle") {
                    if(formState?.children[i]?.elem_type === "paragraph" || formState?.children[i]?.controlName === "richtexteditor"){

                    }
                    else{
                        formState.children[i].style.ReadOnlyStyle = val;
                    }

                    if((formState.children[i].elem_type === "table" || formState.children[i].elem_type === "listview" || formState.children[i].elem_type === "advancelistView" || formState.children[i].elem_type === "advancelistview" || formState.children[i].elem_type === "doclist")){
                        formState.children[i].style.Enable = val === "true" || val === true ? "false" : "true";
                    }

                    if(formState.children[i].elem_type === "textbox" && (val === true || val === "true"))
                        formState.children[i].style.AutoComplete = false;
                }
                else if(field === "ReadOnly") {
                    formState.children[i].style.ReadOnly = val;
                    if((formState.children[i].elem_type === "table" || formState.children[i].elem_type === "listview" || formState.children[i].elem_type === "advancelistView" || formState.children[i].elem_type === "advancelistview" || formState.children[i].elem_type === "doclist")){
                        formState.children[i].style.Enable = val === "true" || val === true ? "false" : "true";
                    }
                    if(formState.children[i].elem_type === "textbox" && (val === true || val === "true"))
                        formState.children[i].style.AutoComplete = false;
                }
                changeControlProperty(formState.children[i].style[field],field,formState.children[i]);    
            }
            if(formState.children[i].subform && formState.children[i].elem_type === "button" && window?.enableSubFormFieldsWithButton && window.enableSubFormFieldsWithButton()) {
                changeControlProperty(val,field,formState.children[i].subform);
            }
            else if(formState.children[i].listviewFrameLayoutJson && (formState.children[i].elem_type === "advancelistView" || formState.children[i].elem_type === "listview") && window?.enableSubFormFieldsWithButton && window.enableSubFormFieldsWithButton()) {
                changeControlProperty(val,field,formState.children[i].listviewFrameLayoutJson);
            }    
            else if(formState.children[i]){
                changeControlProperty(val,field,formState.children[i]);
            }
        }
    }
    return {...formState};
}

export const readOnlyChange = (val,formState) => {
    if(formState?.children) {
        for(let i = 0; i < formState.children.length; i++) {
            if(formState.children[i].style && formState.children[i].id !== 'GroupInfo' && formState.children[i].id !== 'Event') {
                    if(val === "true" || val === true) {
                        if(formState.children[i].style.previousReadOnly !== undefined) 
                            formState.children[i].style.ReadOnlyStyle = formState.children[i].style.previousReadOnly; 
                        else formState.children[i].style.ReadOnlyStyle = val;
                    }
                    else formState.children[i].style.ReadOnlyStyle = val; 
                    readOnlyChange(val,formState.children[i]);
                // }
            }
            else if(formState.children[i].subform && formState.children[i].elem_type === "button") {
                readOnlyChange(val,formState.children[i].subform);
            }
            else if(formState.children[i].listviewFrameLayoutJson && formState.children[i].elem_type === "advancelistView") {
                readOnlyChange(val,formState.children[i].listviewFrameLayoutJson);
            }
            else {
                readOnlyChange(val,formState.children[i]);
            }
        }
    }
    return {...formState};
}

  const removeFromFormState = (key,formState) => {
    if (formState.children) {
      for(let i=0; i<formState.children.length;i++){
        if (formState.children[i].dataclass === key) {
          delete formState.children[i].dataclass;
          delete formState.children[i].datamapPercision;
          delete formState.children[i].datamapVariableLength;
          delete formState.children[i].datamapVariableType;
          delete formState.children[i].datamapid;
          delete formState.children[i].style.MappingId;
          delete formState.children[i].style.Mapping;
          // formState.children[i].style.Label = formState.children[i].id;

          if((formState.children[i].elem_type === "advancelistView" ||
            formState.children[i].elem_type === "advancelistview" ||
            formState.children[i].elem_type === "listview" ||
            formState.children[i].elem_type === "table") &&
            formState?.children?.[i]?.columnList?.length
          ) {
            formState.children[i].columnList.forEach(col => {
              delete col.style["complexFieldName"];
              delete col.style["associatedControlId"];
              delete col.style["complexFieldType"];
              delete col.style["complexFieldVariableLength"];
              delete col.style["complexFieldVariablePrecision"];
            })
          }
        }
        if (formState.children[i].subform && formState.children[i].elem_type === "button") {
          removeFromFormState(key,formState.children[i].subform);
        }
        else if(
          formState.children[i].listviewFrameLayoutJson &&
          (formState.children[i].elem_type === "advancelistView" ||
            formState.children[i].elem_type === "advancelistview" ||
            formState.children[i].elem_type === "listview")
        ) {
          removeFromFormState(key,formState.children[i].listviewFrameLayoutJson);
        }
        else {
          removeFromFormState(key,formState.children[i]);
        }
      }
    }
    else {
      return;
    }
  }

export const removeUniqueMapping = (node, formState) => {
    if(node.children) {
        node.children.map((key,value) => {
            if(key.children) {
                removeUniqueMapping(key,formState);
            }
            else {
                removeFromFormState(key.treeName,formState);
            }
        })
    }
}

export const createUniqueId = (elemType, containerId) => {

    if (elemType === null || elemType === undefined) elemType = '';
    let generatedId;
        if (elemType === 'section') {
            const max = elemIdCountState.section + 1;
            generatedId = 'section' +  max;
            elemIdCountState.section = max;
        } 
        else if (elemType === 'frame') {
            const max = elemIdCountState.frame + 1;
            generatedId = 'frame' + max;
            elemIdCountState.frame = max;
        } 
        else if (elemType === 'row') {
            // const uid = new ShortUniqueId();
            // uid.setDictionary('alphanum');
            // generatedId = 'row' + uid(10);
            generatedId = 'row' + uuid().slice(-8);
        }
        else if (elemType === 'column') {
            // const uid = new ShortUniqueId();
            // uid.setDictionary('alphanum')
            // generatedId = 'column' + uid(10);
            generatedId = 'column' + uuid().slice(-8);
        } 
        else if (elemType === 'label') {
            const max = elemIdCountState.label + 1;
            generatedId = 'label' + max;
            elemIdCountState.label = max;
        }
        else if (elemType === 'textbox') {
            const max = elemIdCountState.textbox + 1;
            generatedId = 'textbox' + max;
            elemIdCountState.textbox = max;
        }
        else if (elemType === 'textarea') {
            const max = elemIdCountState.textarea + 1;
            generatedId = 'textarea' + max;
            elemIdCountState.textarea = max;
        }
        else if (elemType === 'submit') {
            const max = elemIdCountState.submit + 1;
            generatedId = 'submit' + max;
            elemIdCountState.submit = max;
        }
        else if (elemType === 'button') {   
            const max = elemIdCountState.button + 1;
            generatedId = 'button' + max;
            elemIdCountState.button = max;
        }
        else if (elemType === 'email') {
            const max = elemIdCountState.email + 1;
            generatedId = 'email' + max;
            elemIdCountState.email = max;
        } 
        else if (elemType === 'password') {
            const max = elemIdCountState.password + 1;
            generatedId = 'password' + max;
            elemIdCountState.password = max;
        } 
        else if (elemType === 'combo') {
            const max = elemIdCountState.combo + 1;
            generatedId = 'combo' + max;
            elemIdCountState.combo = max;
        } 
        else if (elemType === 'datepick') {
            const max = elemIdCountState.datepick + 1;
            generatedId = 'datepick' + max;
            elemIdCountState.datepick = max;
        } 
        else if (elemType === 'phonenumber') {
            const max = elemIdCountState.phonenumber + 1;
            generatedId = 'phonenumber' + max;
            elemIdCountState.phonenumber = max;
        } 
        else if (elemType === 'radio') {
            const max = elemIdCountState.radio + 1;
            generatedId = 'radio' + max;
            elemIdCountState.radio = max;
        } else if (elemType === 'checkbox') {
            const max = elemIdCountState.checkbox + 1;
            generatedId = 'checkbox' + max;
            elemIdCountState.checkbox = max;
        } 
        else if (elemType === 'listbox') {
            const max = elemIdCountState.listbox + 1;
            generatedId = 'listbox' + max;
            elemIdCountState.listbox = max;
        } 
        else if (elemType === 'toggle') {
            const max = elemIdCountState.toggle + 1;
            generatedId = 'toggle' + max;
            elemIdCountState.toggle = max;
        } 
        else if (elemType === 'tabChild') {
            const max = elemIdCountState.sheet + 1;
            generatedId = 'sheet' + max;
            elemIdCountState.sheet = max;
        } 
        else if (elemType === 'tab') {
            const max = elemIdCountState.tab + 1;
            generatedId = 'tab' + max;
            elemIdCountState.tab = max;
        } 
        else if (elemType === 'multiSelect') {
            const max = elemIdCountState.multiSelect + 1;
            generatedId = 'multiSelect' + max;
            elemIdCountState.multiSelect = max;
        } 
        else if (elemType === 'table') {
            const max = elemIdCountState.table + 1;
            generatedId = 'table' + max;
            elemIdCountState.table = max;
        } 
        else if (elemType.toLowerCase() === 'listview') {
            const max = elemIdCountState.listview + 1;
            generatedId = 'listview' + max;
            elemIdCountState.listview = max;
        } 
        else if (elemType === 'advancelistview') {
            const max = elemIdCountState.advancelistview + 1;
            generatedId = 'advancelistview' + max;
            elemIdCountState.advancelistview = max;
        } 
         
        else if (elemType === 'paragraph') {
            const max = elemIdCountState.paragraph + 1;
            generatedId = 'paragraph' + max;
            elemIdCountState.paragraph = max;
        } 
        else if (elemType === 'image') {
            const max = elemIdCountState.image + 1;
            generatedId = 'image' + max;
            elemIdCountState.image = max;
        }
        else if (elemType === 'picklist') {
            const max = elemIdCountState.picklist + 1;
            generatedId = 'picklist' + max;
            elemIdCountState.picklist = max;
        }
        else if (elemType === 'iframe') {
            const max = elemIdCountState.iframe + 1;
            generatedId = 'iframe' + max;
            elemIdCountState.iframe = max;
        } 
        else if (elemType === 'report') {
            const max = elemIdCountState.report + 1;
            generatedId = 'report' + max;
            elemIdCountState.report = max;
        } 
        else if (elemType === 'temp_tableColumn') {
            const max = elemIdCountState.temp_tableColumn + 1;
            generatedId = 'temp_tableColumn' + max;
            elemIdCountState.temp_tableColumn = max;
        } 
        else if (elemType === 'richtexteditor') {
            const max = elemIdCountState.richtexteditor + 1;
            generatedId = 'richtexteditor' + max;
            elemIdCountState.richtexteditor = max;
        } 
        else if (elemType === 'slider') {
            const max = elemIdCountState.slider + 1;
            generatedId = 'slider' + max;
            elemIdCountState.slider = max;
        }
        else if (elemType === 'tile') {
            const max = elemIdCountState.tile + 1;
            generatedId = 'tile' + max;
            elemIdCountState.tile = max;
        } 
        else
            if (elemType === 'captcha') {
            const max = elemIdCountState.captcha + 1;
            generatedId = 'captcha' + max;
        }                        
    return generatedId;
}

export function getSelectedControlType(needToGeneratePage, controlSelected, activePage, isPortal) {
  const pageOrSubform = isPortal ? (activePage ? "Page" : "Subform") : "Form";

  let controlType =
    !needToGeneratePage && controlSelected?.elem_type
      ? controlSelected.elem_type === "frame"
        ? "Section"
        : controlSelected.elem_type === "form"
        ? pageOrSubform
        : "Control"
      : pageOrSubform;

  // if (!(activePage || activeSubForm)) {
  //     controlType = "Form";
  // }
  return controlType;
}

function checkEnableMarvinFunction(elements) {
  for (let element of elements) {
    if (element && element.marvin === "false") {
      return true;
    }

    if (element.children && element.children.length > 0) {
      if (checkEnableMarvinFunction(element.children)) {
        return true;
      }
    }
  }
  return false;
}
export function handleMarvinFormOpen(containerId, controlSelected = {}, needToGeneratePage = false) {
  const reduxContexts = getReduxContexts();
  const { formState2, activePage, activeSubForm, microFrontendData, isPortal } = reduxContexts;
  let checkEnableMarvin = false;
  const controlType = getSelectedControlType(needToGeneratePage, controlSelected, activePage, isPortal);

  const marvinType =
    controlType === "Page" || controlType === "Subform" || controlType === "Form"
      ? "5"
      : controlType === "Section"
      ? "6"
      : "7";
  const controlNameKey = `${
    controlType === "Page" || controlType === "Subform" || controlType === "Form" ? "page" : controlType.toLowerCase()
  }Name`;
  const controlNameValue =
    controlType === "Page" || controlType === "Subform"
      ? activePage?.formName || activeSubForm?.fragmentName
      : controlType === "Form"
      ? microFrontendData.formName || microFrontendData.applicationName
      : controlSelected?.style?.Label || controlSelected?.id;

//   let shouldEnableMarvinForExistingFields = false;
//   if ((marvinType === "5" || marvinType === "6") && controlSelected && (Object.keys(controlSelected).length > 0)) {
//     // const isNonMarvinControlPresent = checkNonMarvinControlPresent(controlSelected);
//     // shouldEnableMarvinForExistingFields = isNonMarvinControlPresent && controlSelected.marvinResponse.enableMarvinForExistingFields
//     const checkElements =
//       marvinType === "5" ? controlSelected?.children[1]?.children : controlSelected?.children[0]?.children;
//     checkEnableMarvin = checkEnableMarvinFunction(checkElements);
//     console.log("enableMarvin", checkEnableMarvin);
//   }

  const isPageHasControls =
    (controlType === "Page" || controlType === "Subform" || controlType === "Form") && !checkEmpty(formState2);
  const isControlLabelDifferentFromId =
    (controlType === "Control" || controlType === "Section") && controlSelected.id !== controlNameValue;
  const shouldNameFieldDisabled = isPageHasControls || isControlLabelDifferentFromId;
  let frameId;let frameJson;
  if(controlSelected && controlSelected?.elem_type!=="frame"){
    frameId=document.getElementById(controlSelected?.id)?.closest(`[elem_type=frame]`)?.getAttribute('control_id'); 
    frameJson=functions.readJson(formState2,frameId)
  }

  formStateStore.dispatch(
    updateMarvinContexts({
      key: containerId,
      states: {
        openMarvinModal: true,
        marvinButtonSelected: true,
        marvinFormJson: {
          inputField: [
            {
              label: `${controlType} Name`,
              field: controlNameKey,
              Placeholder: `Enter ${controlType} Name`,
              type: "textbox",
              editable: shouldNameFieldDisabled,
              disabled: shouldNameFieldDisabled,
            //   mandatory: true
            },
            {
              label: "Geography",
              field: `${
                controlType === "Page" || controlType === "Subform" || controlType === "Form"
                  ? "page"
                  : controlType.toLowerCase()
              }Geography`,
              Placeholder: `Enter Geography`,
              type: "textbox"
            },
            {
              label: "Input Validations",
              field: "additionalOptions",
              type: "checkboxStyle3",
              inline: true,
              options: [
                { value: "regex", label: "Regex", tooltip: "Use regular expressions to define specific input patterns for the generated controls, ensuring data consistency." },
                { value: "mandatory", label: "Mandatory", tooltip: "Automatically mark fields as required where applicable, ensuring essential information is provided by the user." },
                { value: "sensitive", label: "Sensitive", tooltip: "Encrypt sensitive data fields to enhance security and protect user information." }
              ]
            },
            {
              label: "Generate Data Objects",
              field: "generateDataObjects",
              type: "toggle",
              disabled: controlSelected?.dataclass || microFrontendData?.statusType === "R" || (frameJson && !frameJson?.dataclass)
            },
            // {
            //   label: "Enable Marvin for Existing Fields",
            //   field: "enableMarvinForExistingFields",
            //   type: "toggle",
            //   disabled: !checkEnableMarvin,
            //   tooltip: "This feature lets you use Marvin properties in fields you create manually."
            // },
            {
              label: "Additional Comment ",
              labelOptional: "(Optional)",
              field: "additionalComment",
              Placeholder: "Write comment here...",
              PlaceholderListening: "I’m listening",
              type: "textarea"
            }
          ],
          formDetails: {
            heading: `Ask Marvin to generate ${controlType}`,
            showCancel: true,
            showRegenerateButton:(controlType==="Page" || controlType === "Subform" || controlType === "Form") ? (formState2?.marvinResponse || formState2?.marvin === "true" ? true : false) : controlSelected?.marvinResponse || controlSelected?.marvin === "true" ? true : false,
            // showRegenerateButton: !checkEmpty(formState2),
            submitButtonLabel: "Generate",
            cancelButtonLabel: "Close",
            values: {
              additionalOptions: ["regex"],
              [`${
                controlType === "Page" || controlType === "Subform" || controlType === "Form"
                  ? "page"
                  : controlType.toLowerCase()
              }Geography`]: "India",
              [controlNameKey]: controlNameValue,
              ...controlSelected.marvinResponse
            },
            controlNameKey
          },
          payload: {
            marvinType
          }
        }
      },
      renderSectionForm: true,
      renderDesignerHeader: true,
      renderCanvas:true
    })
  );
  // }
}

const handleMarvinResponseError = (controlType) => {
  const state = formStateStore.getState();
  const containerId = state.containerInfo.containerId;
  const showAlertConfirmNotifications = getShowAlertNotificationFromStore();

  formStateStore.dispatch(
    updateMarvinContexts({
      key: containerId,
      states: {
        renderSectionForm: true,
        marvinRequestSent: false
      },
      renderSectionForm: true
    })
  );

  showAlertConfirmNotifications({
    open: true,
    showConfirm: "showNotification",
    alertType: "error",
    autoHideDuration: 5000,
    alertContentKey: controlType ? `${controlType}_Marvin_Server_Error` : `SERVER_ERROR_TITLE`
  });
};

export const resetMarvinStates = (jsonToUpdate = {}, setShowPagesSubForms) => {
  const state = formStateStore.getState();
  const containerId = state.containerInfo.containerId;

  if (setShowPagesSubForms) setShowPagesSubForms(false);

  formStateStore.dispatch(
    updateMarvinContexts({
      key: containerId,
      states: {
        openMarvinModal: false,
        marvinButtonSelected: false,
        marvinRequestSent: false,
        renamePageSubform: {
          pageRename: false,
          subformRename: false,
          NewName: ""
        },
        marvinFormJson: {},
        ...jsonToUpdate
      },
      renderSectionForm: true,
      renderDesignerHeader: true,
      renderCanvas:true
    })
  );
};

export function getAppId(containerId) {
  const state = formStateStore.getState();
  if (containerId === undefined) {
    containerId = state.containerInfo.containerId;
  }
  let appId = state.data.find((json) => json.key === containerId)?.contexts.appId;
  return appId;
}

const inputValidation = (additionalOptions, controlStyle) => {
  if (!additionalOptions?.includes("regex")) {
    controlStyle.CustomPattern = undefined;
  }
  if (!additionalOptions?.includes("mandatory")) {
    controlStyle.Mandatory = undefined;
  }
  if (!additionalOptions?.includes("sensitive")) controlStyle.SaveEncrypted = undefined;
  return controlStyle;
};
const extraThemeJson={
    ReadOnly:"false",
    ReadOnlyStyle:"false"
}
const editElementInMarvin = (marvinJson = {}, newFields = [], jsonToSend) => {
  for (let i = 0; i < newFields.length; i++) {
    const control = newFields[i];
    control.marvin = "true";
    control.style = {
      ...ThemeJSON[control.elem_type],
      ...extraThemeJson,
      ...control.style
    };
    if (control?.style) {
      control.style = inputValidation(jsonToSend?.additionalOptions, control?.style);
    }
    const col = {
      elem_type: "column",
      id: createUniqueId("column"),
      frameIndex: marvinJson.frameIndex,
      w: getColumnLayout("web"),
      md: getColumnLayout(getCurrentDevice() || "web"),
      sm: getColumnLayout("tablet"),
      xs: getColumnLayout("mobile"),
      children: [control],
      style: { heightselect: "set" }
    };
    marvinJson.children[0].children.push(col);
  }
};

const editElementsInMarvinThroughEnableMarvin = (marvinJson = {}, newFields = [], jsonToSend) => {
  let newFieldsMap = new Map();
  const fieldsTobeAdded = [];
  newFields.forEach((obj) => {
    if (!obj.id) {
      newFieldsMap.set(obj?.style?.Label, obj);
    } else {
      fieldsTobeAdded.push(obj);
    }
  });

  // Update objects in array A
  const oldJson = marvinJson.children[0].children;
  oldJson.forEach((obj, index) => {
    if (newFieldsMap.has(obj?.children[0]?.style?.Label)) {
      // let bObj = newFieldsMap.get(obj.label);
      oldJson[index].children[0].style = { ...oldJson[index].children[0].style, ...newFieldsMap.get(obj.label).style };
      // Modify properties of obj based on bObj
      // obj.value = bObj.newValue; // Example modification
      // obj.otherProp = bObj.anotherProp; // Example modification
    }
  });

  if (fieldsTobeAdded.length > 0) {
    editElementInMarvin(marvinJson, fieldsTobeAdded, jsonToSend);
  }
};

const addElementInMarvin = (marvinJson = {}, jsonToSend) => {
  marvinJson.style = {
    marvinResponseLabel: marvinJson.style.Label,
    ...ThemeJSON[marvinJson.elem_type],
    ...marvinJson.style
  };

  const rowElement = {
    id: createUniqueId("row"),
    elem_type: "row",
    frameIndex: marvinJson.frameIndex,
    children: [],
    parent_id: marvinJson.id
  };
  const col = {
    elem_type: "column",
    frameIndex: marvinJson.frameIndex,
    w: getColumnLayout("web"),
    md: getColumnLayout(getCurrentDevice() || "web"),
    sm: getColumnLayout("tablet"),
    xs: getColumnLayout("mobile"),
    children: [],
    style: { heightselect: "set" }
  };

  for (let i = 0; i < marvinJson?.children?.length; i++) {
    col.id = createUniqueId("column");
    const control = marvinJson?.children?.[i];
    if (control) {
      if (control?.id) {
        control.marvin = "true";
        control.style = {
          ...ThemeJSON[control.elem_type],
          ...extraThemeJson,          
          ...control.style
        };

        if (control?.style) {
          control.style = inputValidation(jsonToSend?.additionalOptions, control?.style);
        }

        col.children = [control];
      }
    }

    rowElement.children.push(cloneDeep(col));
  }

  if (marvinJson?.children?.length < parseInt(marvinJson?.ColumnLayout)) {
    col.children = [];
    for (let j = 0; j < parseInt(marvinJson?.ColumnLayout) - marvinJson?.children?.length; j++) {
      col.id = createUniqueId("column");
      rowElement.children.push(cloneDeep(col));
    }
  }
  marvinJson.marvin = "true";
  marvinJson.children = [];
  marvinJson.children.push(rowElement);
  // marvinJson.children = cloneDeep(rowElement)
  return marvinJson;
};

export const sendRequestForMarvin = async (payload, controlJson = {}, controller, containerId) => {
    
  const reduxContexts = getReduxContexts();
  const {
    formState2,
    setFormState2,
    activePage,
    setActivePage,
    activeSubForm,
    setActiveSubForm,
    setShowPagesSubForms,
    openCanvasForSubform,
    updateJson,
    microFrontendData,
    isPortal,
    fetchDataObject,
    fetchProcessDataObject
  } = reduxContexts;

  let updatedformState2 = cloneDeep(formState2);
  const controlExtraData = {};
  const controlType = getSelectedControlType(false, controlJson,activePage,isPortal);

  if (controlType === "Control" || controlType === "Section") {
    controlExtraData.elem_type = controlJson?.elem_type;
    controlExtraData.elementIndex = controlJson?.elementIndex;
    controlExtraData.frameIndex = controlJson?.frameIndex;
    controlExtraData.id = controlJson?.id;
    controlExtraData.isAdvanceListview = openCanvasForSubform === "advanceListviewFromScratch";
    controlExtraData.isSubForm = openCanvasForSubform === "subform";
    controlExtraData.opType = controlType === "Control" ? 1 : controlType === "Section" ? 7 : -1;

    if (
      updatedformState2?.containerControl === "Menu" ||
      updatedformState2?.containerControl === "wizard_h" ||
      updatedformState2?.containerControl === "wizard_v" ||
      updatedformState2?.containerControl === "sidenavigation"
    ) {
      controlExtraData.stepIndex =
        controlJson?.stepIndex || controlJson?.stepIndex === 0 ? controlJson?.stepIndex : "-1";
      controlExtraData.subChildMenuIndex =
        updatedformState2?.containerControl === "Menu" ? controlJson?.subChildMenuIndex : "-1";
      controlExtraData.subStepIndex =
        controlJson?.subStepIndex || controlJson?.subStepIndex === 0 ? controlJson?.subStepIndex : "-1";

      controlExtraData.opType = controlType === "Control" ? 2 : controlType === "Section" ? 8 : -1;
      controlExtraData.type =
        updatedformState2?.containerControl === "wizard_h" ||
        updatedformState2?.containerControl === "wizard_v" ||
        updatedformState2?.containerControl === "sidenavigation"
          ? "wizard"
          : "menu";
    }

    if (controlJson?.sheetId) {
      controlExtraData.sheetElementIndex = controlJson?.sheetElementIndex;
      controlExtraData.sheetFrameElementIndex = controlJson?.sheetFrameElementIndex;
      controlExtraData.sheetIndex = controlJson?.sheetIndex;
      controlExtraData.sheetId = controlJson?.sheetId;
      controlExtraData.opType = controlJson?.sheetFrameElementIndex ? 4 : 3;
    }

    if (controlType === "Control" && controlJson?.id) {
      const parentFrame = document.querySelector(`#${controlJson.id}`)?.closest(`[elem_type=frame]`);
      const frameId = parentFrame?.getAttribute("id") || parentFrame?.getAttribute("control_id");
      controlExtraData.frameId = frameId || "";
    }
  }

  try {
    const marvinType = payload?.marvinType;
    const jsonToSend = {
      ...payload,
      ...controlExtraData,
      formId: getFormId(),
      appId: getAppId(),
      Mode: isPortal ? "A" : "P",
      action: (marvinType === "6" || marvinType === "7") && payload?.action === "generate" ? "reset" : payload?.action
    };
    if (jsonToSend?.Mode === "P") {
      jsonToSend.processName = microFrontendData?.processName;
      jsonToSend.processId = microFrontendData?.processId;
      jsonToSend.processState = microFrontendData?.statusType;
    }
    const res = await sendRequestForMarvinAPI(jsonToSend, controller);

    let responseFinal = [];
    let jsonLength = res?.data?.children?.length;
    let finalJSON = {};

    //   res.data.marvinResponse = { ...(payload || {}) };

    if (jsonLength) {
      if (marvinType === "5") {
        for (let i = 0; i < jsonLength; i++) {
          responseFinal.push(addElementInMarvin(res?.data?.children?.[i], jsonToSend));
        }
        if (payload.action === "addmorefields") {
          updatedformState2.children[1].children = updatedformState2.children[1].children.concat(responseFinal);
        } else {
          responseFinal.unshift(cloneDeep(updatedformState2?.children?.[1].children?.[0]));
          updatedformState2.children[1].children = responseFinal;
        }
        updatedformState2.marvinResponse = { ...(payload || {}) };
        if (isPortal && payload?.marvinType === "5") {
          if (activePage && activePage?.formName !== jsonToSend?.pageName) {
            setShowPagesSubForms(true);
            setActivePage({ ...activePage, formBuffer: JSON.stringify(updatedformState2) });
            formStateStore.dispatch(
              updateMarvinContexts({
                key: containerId,
                states: {
                  renamePageSubform: {
                    pageRename: true,
                    subformRename: false,
                    NewName: jsonToSend?.pageName
                  }
                },
                renderPageSubform: true
              })
            );
          } else if (activeSubForm && activeSubForm?.fragmentName !== jsonToSend?.subformName) {
            setShowPagesSubForms(true);
            setActiveSubForm({ ...activeSubForm, formBuffer: JSON.stringify(updatedformState2) });
            formStateStore.dispatch(
              updateMarvinContexts({
                key: containerId,
                states: {
                  renamePageSubform: {
                    subformRename: true,
                    pageRename: false,
                    NewName: jsonToSend?.pageName
                  }
                }
              })
            );
          }
        }
        setFormState2(updatedformState2);
        finalJSON = {...updatedformState2};
      } else if (marvinType === "6") {
        let frameJson =
          payload.action === "reset" || payload?.action === "generate" ? cloneDeep(res?.data) : cloneDeep(controlJson);
        if (payload.action === "addmorefields") {
          if (payload?.enableMarvinForExistingFields) {
            editElementsInMarvinThroughEnableMarvin(frameJson, res?.data?.children, jsonToSend);
          } else {
            editElementInMarvin(frameJson, res?.data?.children, jsonToSend);
            if (res?.data?.dataclass) {
              frameJson.dataclass = res?.data?.dataclass;
            }
          }
        } else {
          frameJson = addElementInMarvin(frameJson, jsonToSend);
        }
        frameJson.marvinResponse = { ...(payload || {}) };
        finalJSON = updateComponentInJson(
            formState2,
            controlJson?.id,
            frameJson
          );
        if (updateJson.updatedComponentInFormState) {
          updateJson.updatedComponentInFormState(controlJson?.id, frameJson, false, true, false, true);
        }
      }
      const formId = getFormId();
        const id = `${finalJSON?.formId}`;
    
        const repopulateJson = {
          formId: `${formId || id}`,
          formJson: JSON.stringify(finalJSON),
        };
        if(jsonToSend?.Mode !== "P"){
            repopulateJson.applicationId=  getApplicationId()
        }
        axios
          .post("/idesign/populateFormStateFromJson", sanitizeJson(repopulateJson), {
            withCredentials: true
          })
          .then(() => {
            // fetchProcessVariables(str);
            if (jsonToSend?.Mode === "P") {
                fetchProcessDataObject(true);
              } else {
                fetchDataObject(false, false, true);
              }
          })
          .catch((err) => {
            console.log(err);
          });
    } else if (marvinType === "7") {
      if (!res?.data?.error) {
        let controlData = {};
        controlData.marvin = "true";
        if (res?.data?.action === "reset") {
          controlData = cloneDeep(res?.data);
          controlData.style = {
            marvinResponseLabel: controlData.style.Label,
            ...ThemeJSON[controlData.elem_type],
            ...extraThemeJson,
            ...controlData.style
          };
        } else {
          controlData = {...cloneDeep(controlJson),... jsonToSend?.generateDataObjects ? res?.data : {}};
          controlData.style = {
            ...ThemeJSON[controlData.elem_type],
            ...extraThemeJson,
            ...controlData?.style,
            ...jsonToSend?.generateDataObjects ? res?.data?.style : res?.data
          };
          if (res?.data?.options) {
            controlData.options = res?.data?.options;
          }
        }
        if (controlData?.style) {
          controlData.style = inputValidation(payload?.additionalOptions, controlData?.style);
        }
        if (res?.data) {
          controlData.marvinResponse = { ...(payload || {}) };
          finalJSON = updateComponentInJson(
            formState2,
            controlJson?.id,
            controlData
          );
          if (updateJson.updatedComponentInFormState) {
            updateJson.updatedComponentInFormState(controlJson?.id, controlData, false, true, false, true);
          }
        const formId = getFormId();
        const id = `${finalJSON?.formId}`;
    
        const repopulateJson = {
          formId: `${formId || id}`,
          formJson: JSON.stringify(finalJSON),
        };
        if(jsonToSend?.Mode !== "P"){
            repopulateJson.applicationId=  getApplicationId()
        }
        axios
          .post("/idesign/populateFormStateFromJson", sanitizeJson(repopulateJson), {
            withCredentials: true
          })
          .then(() => {
            // fetchProcessVariables(str);
            if (jsonToSend?.Mode === "P") {
                fetchProcessDataObject(true);
              } else {
                fetchDataObject(false, false, true);
              }
          })
          .catch((err) => {
            console.log(err);
          });
        }        
      }
    }

    if(microFrontendData?.formPageType === "Processes" && payload?.generateDataObjects && jsonLength && !document.querySelector("#interfaceDesignerMain")) {
        localStorage.setItem("afb_reloadDataObjects", true)
    }  
      
    resetMarvinStates(undefined, setShowPagesSubForms);
  } catch (error) {
    console.log("marvin Error", error);
    if(!controller.signal.aborted)
    handleMarvinResponseError(controlType);
  }
};
  
const containsWizard = () => {
    var formJSON = getFormJsonFromStore();
    var child = formJSON.children[1].children;
    for(let item of child){
      if(item.id === "wizard"){
        return true;
      }
    }
    return false;
  }

export async function sendRequestForControl(frameIndex, operationType, controlType, extraDetails = {loading : false}, extraDetails2, activePage,activeSubFrom,targetElement,controlElemToAdd, holdLoader) {

    var jsonToSend = {};
    var remainingURL = '';
    const showAlertConfirmNotifications = getShowAlertNotificationFromStore();
    if(extraDetails?.stepIndex && extraDetails?.stepIndex !== "-1" && extraDetails2?.isSubForm){
        extraDetails.stepIndex = "-1"
    }
    if(!extraDetails?.loading)
        window.loading(true);
    if (operationType === 'add') { 
        var headerjson = functions.readJson1(extraDetails?.targetId)  
        if (controlType === 'frame' || controlType === 'section') {
            if(activePage === 1){
                jsonToSend = {};

                if (extraDetails && extraDetails.sheetIndex !== undefined && extraDetails.sheetIndex !== "" && extraDetails.sheetIndex !== null) {
                    jsonToSend = {
                        frameIndex: frameIndex,
                        elem_type: "frame",
                        onTop : true,
                        elementIndex: extraDetails.elementIndex,
                        sheetId: parseInt(extraDetails.sheetIndex),
                        ...(extraDetails.insideMenu ? {
                            stepIndex: extraDetails.stepIndex,
                            subChildMenuIndex: extraDetails.subChildMenuIndex,
                            subStepIndex: extraDetails.substepIndex,
                        } : {})
                    };
                    jsonToSend['isSubForm'] = extraDetails?.isSubForm;
                    jsonToSend['isAdvanceListview'] = extraDetails?.isAdvanceListview;
                    jsonToSend["opType"] = 3
                    remainingURL = extraDetails.insideMenu ? '/idesign/addNewElementToTabSheetInStep' : '/idesign/addElement';
                }
                else if(extraDetails?.insideMenu){
                    jsonToSend = {
                        stepIndex: extraDetails?.stepIndex,
                        subStepIndex: (extraDetails?.substepIndex || extraDetails?.substepIndex === 0) ? extraDetails?.substepIndex : "-1" ,
                        subChildMenuIndex: (extraDetails?.subChildMenuIndex || extraDetails?.subChildMenuIndex === 0) ? extraDetails?.subChildMenuIndex : "-1",
                        onTop : true,
                        isSubForm: extraDetails?.isSubForm,
                        isAdvanceListview: extraDetails?.isAdvanceListview,
                        opType: 8
                      };
                      remainingURL = '/idesign/addElement';
                }
                else if(extraDetails?.insideWizard){
                    jsonToSend = {
                        stepIndex: extraDetails?.parentStep,
                        subStepIndex: (extraDetails?.parentSubStep || extraDetails?.parentSubStep === 0) ? extraDetails?.parentSubStep : "-1" ,
                        onTop : true,
                        isSubForm: extraDetails?.isSubForm,
                        isAdvanceListview: extraDetails?.isAdvanceListview,
                        opType: 8
                      };
                      remainingURL = '/idesign/addElement';
                }
                else {
                    jsonToSend = {
                        frameIndex: frameIndex,
                        elem_type: "frame",
                        onTop : true,
                        elementIndex: extraDetails.elementIndex,
                        sheetId: parseInt(extraDetails.sheetIndex),
                        isSubForm: extraDetails?.isSubForm,
                        isAdvanceListview: extraDetails?.isAdvanceListview,
                        opType: 7
                        
                      };
                    remainingURL = '/idesign/addElement';
                }
            }
            else if(activeSubFrom === 1 && targetElement !== "" && targetElement !== undefined){
                if (extraDetails && extraDetails2?.sheetIndex !== undefined && extraDetails2?.sheetIndex !== "") {
                    jsonToSend = {
                        frameIndex: frameIndex,
                        elem_type: "frame",
                        position : targetElement,
                        elementIndex: extraDetails.elementIndex,
                        sheetId: parseInt(extraDetails2.sheetIndex),
                        opType: 3
                    };
                    jsonToSend['isSubForm'] = extraDetails?.isSubForm;
                    jsonToSend['isAdvanceListview'] = extraDetails?.isAdvanceListview;
                    remainingURL = extraDetails.insideMenu ? '/idesign/addNewElementToTabSheetInStep' : '/idesign/addElement';
                }
                else if(extraDetails?.insideMenu){
                    jsonToSend = {
                        stepIndex: extraDetails?.stepIndex,
                        subStepIndex: (extraDetails?.substepIndex || extraDetails?.substepIndex === 0) ? extraDetails?.substepIndex : "-1" ,
                        subChildMenuIndex: (extraDetails?.subChildMenuIndex || extraDetails?.subChildMenuIndex === 0) ? extraDetails?.subChildMenuIndex : "-1",
                        position: targetElement,
                        isSubForm: extraDetails?.isSubForm,
                        isAdvanceListview: extraDetails?.isAdvanceListview,
                        opType: 8
                      };
                      remainingURL = '/idesign/addElement';
                }
                else if(extraDetails?.insideWizard){
                    jsonToSend = {
                        stepIndex: extraDetails?.parentStep,
                        subStepIndex: (extraDetails?.parentSubStep || extraDetails?.parentSubStep === 0) ? extraDetails?.parentSubStep : "-1" ,
                        position: targetElement,
                        isSubForm: extraDetails?.isSubForm,
                        isAdvanceListview: extraDetails?.isAdvanceListview,
                        opType: 8
                      };
                      remainingURL = '/idesign/addElement';
                }
                else{
                jsonToSend = {
                    position : targetElement,
                    isSubForm: extraDetails2?.isSubForm || extraDetails?.isSubForm,
                    isAdvanceListview: extraDetails2?.isAdvanceListview || extraDetails?.isAdvanceListview,
                    opType: 7
                    
                  };
                remainingURL = '/idesign/addElement';
                }
            }
            else{
            if (extraDetails?.targetElemType?.toLowerCase() === "step") {
                jsonToSend = {
                  stepIndex: extraDetails.frameIndex,
                  subStepIndex: "-1",
                  isSubForm: extraDetails?.isSubForm,
                  isAdvanceListview: extraDetails?.isAdvanceListview,
                  opType: 8
                };
                remainingURL = '/idesign/addElement';
            }
            else if(extraDetails?.targetElemType?.toLowerCase() === "mainmenu" || extraDetails?.targetElemType?.toLowerCase() === "submenu" || extraDetails?.targetElemType?.toLowerCase() === "subchildmenu" ){
                jsonToSend = {
                    stepIndex: extraDetails?.stepIndex,
                    subStepIndex: (extraDetails?.substepIndex || extraDetails?.substepIndex === 0) ? extraDetails?.substepIndex : "-1" ,
                    subChildMenuIndex: (extraDetails?.subChildMenuIndex || extraDetails?.subChildMenuIndex === 0) ? extraDetails?.subChildMenuIndex : "-1",
                    isSubForm: extraDetails?.isSubForm,
                    isAdvanceListview: extraDetails?.isAdvanceListview,
                    opType: 8
                  };
                remainingURL = '/idesign/addElement';
            }
            else if (extraDetails && extraDetails.targetElemType && extraDetails.targetElemType.toLowerCase() === "substep") {
                jsonToSend = {
                  stepIndex: extraDetails.frameIndex,
                  subStepIndex: extraDetails.parentSubStep,
                  isSubForm: extraDetails?.isSubForm,
                  isAdvanceListview: extraDetails?.isAdvanceListview,
                  opType: 8
                };
                remainingURL = '/idesign/addElement';
            }
            else if(extraDetails && extraDetails.targetElemType && extraDetails.targetElemType.toLowerCase()==="column"){

                jsonToSend = {};
                jsonToSend['isSubForm'] = extraDetails?.isSubForm;
                jsonToSend['isAdvanceListview'] = extraDetails?.isAdvanceListview;
                jsonToSend['opType'] = 7;
                remainingURL = remainingURL = '/idesign/addElement';
            }
            else {
                jsonToSend = {};
                
                if (extraDetails && extraDetails.sheetIndex !== undefined && extraDetails.sheetIndex !== null && extraDetails.sheetIndex !== "") {
                    jsonToSend = {
                        frameIndex: frameIndex,
                        elem_type: "frame",
                        elementIndex: extraDetails.elementIndex,
                        opType: 3,
                        sheetId: parseInt(extraDetails.sheetIndex),
                        ...(extraDetails.insideMenu ? {
                            stepIndex: extraDetails.stepIndex,
                            subChildMenuIndex: extraDetails.subChildMenuIndex,
                            subStepIndex: extraDetails.substepIndex,
                        } : {})
                    };
                    jsonToSend['isSubForm'] = extraDetails?.isSubForm;
                    jsonToSend['isAdvanceListview'] = extraDetails?.isAdvanceListview;
                    remainingURL = extraDetails.insideMenu ? '/idesign/addNewElementToTabSheetInStep' : '/idesign/addElement';
                }
                else {
                    jsonToSend['isSubForm'] = extraDetails?.isSubForm;
                    jsonToSend['isAdvanceListview'] = extraDetails?.isAdvanceListview;
                    jsonToSend['opType'] = 7;
                    jsonToSend['insideHeaderFrame'] = headerjson?.isWizardHeader === true || headerjson?.isWizardHeader === "true" ? "true" : undefined;
                    if(extraDetails2?.isAboveWizard)
                        jsonToSend['elem_type'] = 'headerframe';
                        jsonToSend['insideHeaderFrame'] = headerjson?.isWizardHeader === true || headerjson?.isWizardHeader === "true" ? "true" : undefined;
                    remainingURL = remainingURL = '/idesign/addElement';
                }

            }
        }
        if(extraDetails2?.isAboveWizard) {
            jsonToSend['isSubForm'] = extraDetails?.isSubForm;
            jsonToSend['isAdvanceListview'] = extraDetails?.isAdvanceListview;
            jsonToSend['opType'] = 7;
            jsonToSend['insideHeaderFrame'] =  headerjson?.isWizardHeader === true || headerjson?.isWizardHeader === "true" ? "true" : undefined;
            if(extraDetails2?.isAboveWizard)
                jsonToSend['elem_type'] = 'headerframe';
                jsonToSend['insideHeaderFrame'] = headerjson?.isWizardHeader === true || headerjson?.isWizardHeader === "true" ? "true" : undefined;
            remainingURL = remainingURL = '/idesign/addElement';
        }
        }
        else if (
            controlType === 'textbox' ||
            controlType === 'datepick' ||
            controlType === 'combo' ||
            controlType === 'checkbox' ||
            controlType === 'radio' ||
            controlType === 'button' ||
            controlType === 'textarea' ||
            controlType === 'multiSelect' ||
            controlType === 'tab' ||
            controlType === 'label' ||
            controlType === 'iframe' ||
            controlType === 'paragraph' ||
            controlType === 'image' ||
            controlType === 'richtexteditor' ||
            controlType === 'wizard_h' ||
            controlType === 'wizard_v' ||
            controlType === 'sidenavigation' ||
            controlType === 'toggle' ||
            controlType === 'imagecarousel' ||
            controlType === 'link' ||
            controlType === 'slider' ||
            controlType === 'doclist' ||
            controlType === 'email' ||
            controlType === 'password' ||
            controlType === 'percentage' ||
            controlType === 'phonenumber' ||
            controlType === 'picklist' ||
            controlType === 'listbox' ||
            controlType === 'tile' ||
            controlType === 'report' ||
            controlType === 'CustomControl' ||
            controlType === 'captcha' ||
            controlType === 'Menu' || 
            controlType === 'listview' ||
            controlType === 'table' ||
            controlType === 'advancelistview' ||
            controlType === 'paaragraph' 
        ) {
            if ( extraDetails?.insideWizard === true) {
                if (extraDetails.parentSubStep === "") {
                    jsonToSend = {
                      frameIndex: frameIndex,
                      elem_type: controlType === "password" ? "textbox" : controlType,
                      controlName: controlType,
                      stepIndex: extraDetails.parentStep,
                      isSubForm: extraDetails?.isSubForm,
                      insideHeaderFrame: headerjson?.isWizardHeader === true || headerjson?.isWizardHeader === "true" ? "true" : undefined,
                      isAdvanceListview: extraDetails?.isAdvanceListview,
                    };
                    if(controlType==="richtexteditor"){
                        jsonToSend["elem_type"]= "textarea"
                    }
                }
                else {
                    jsonToSend = {
                      frameIndex: frameIndex,
                      elem_type: controlType === "password" ? "textbox" : controlType,
                      controlName: controlType,
                      stepIndex: extraDetails.parentStep,
                      subStepIndex: extraDetails.parentSubStep,
                      isSubForm: extraDetails?.isSubForm,
                      isAdvanceListview: extraDetails?.isAdvanceListview,
                      insideHeaderFrame: headerjson?.isWizardHeader === true || headerjson?.isWizardHeader === "true" ? "true" : undefined,
                    };
                    if(controlType==="richtexteditor"){
                        jsonToSend["elem_type"]= "textarea"
                    }

                }
                if(controlType==="tile"){
                    jsonToSend = {
                        frameIndex: frameIndex,
                        elem_type: "CustomControl",
                        controlName: controlType,
                        stepIndex: extraDetails.parentStep,
                        subStepIndex: extraDetails.parentSubStep==""? "-1":extraDetails.parentSubStep,
                        isSubForm: extraDetails?.isSubForm,
                        isAdvanceListview: extraDetails?.isAdvanceListview,
                        opType:extraDetails?.isSubForm || extraDetails?.isAdvanceListview? 14: 9,
                        insideHeaderFrame: headerjson?.isWizardHeader === true || headerjson?.isWizardHeader === "true" ? "true" : undefined,
                    };
                  remainingURL = '/idesign/addElement'
                }
                else
               {
                jsonToSend["opType"] = extraDetails?.isSubForm || extraDetails?.isAdvanceListview? 1:2
                jsonToSend["insideHeaderFrame"] = headerjson?.isWizardHeader === true || headerjson?.isWizardHeader === "true" ? "true" : undefined;
                remainingURL = '/idesign/addElement';}
            }
            else if(extraDetails?.insideMenu){
                jsonToSend = {
                    frameIndex: frameIndex,
                    elem_type: controlType === "password" ? "textbox" : controlType,
                    controlName: controlType,
                    stepIndex: extraDetails?.stepIndex,
                    subStepIndex: extraDetails?.substepIndex,
                    subChildMenuIndex: extraDetails?.subChildMenuIndex,
                    isSubForm: extraDetails?.isSubForm,
                    isAdvanceListview: extraDetails?.isAdvanceListview,
                  };
                  if(controlType==="richtexteditor"){
                    jsonToSend["elem_type"]= "textarea"
                }
                  if(controlType==="tile"){
                    jsonToSend = {
                        frameIndex: frameIndex,
                        elem_type: "CustomControl",
                        controlName: controlType,
                        stepIndex: extraDetails?.stepIndex,
                        subStepIndex: (extraDetails?.substepIndex || extraDetails?.substepIndex === 0) ? extraDetails?.substepIndex: "-1",
                        subChildMenuIndex: extraDetails?.subChildMenuIndex,
                        isSubForm: extraDetails?.isSubForm,
                        isAdvanceListview: extraDetails?.isAdvanceListview,
                        opType:extraDetails?.isSubForm || extraDetails?.isAdvanceListview? 14: 9,
                        insideHeaderFrame: headerjson?.isWizardHeader === true || headerjson?.isWizardHeader === "true" ? "true" : undefined,
                      };
                    
                    remainingURL = '/idesign/addElement'
                }
                else
               {
                 jsonToSend["opType"] = extraDetails?.isSubForm || extraDetails?.isAdvanceListview? 1:2;
                 jsonToSend["insideHeaderFrame"] = headerjson?.isWizardHeader === true || headerjson?.isWizardHeader === "true" ? "true" : undefined;
                 remainingURL = '/idesign/addElement';
                }
            }
            else {   
                const insideFrameId= document.querySelector(`#${extraDetails?.targetId}`)?.closest(`[elem_type=frame]`)?.getAttribute("id");
                const frameinsideTabId= document.querySelector(`#${extraDetails?.targetId}`)?.closest(`[elem_type=frame]`)?.closest(`[elem_type=tab]`)?.getAttribute("id");

                if(insideFrameId && frameinsideTabId) {
                    const elementindexTab=document.querySelector(`#${extraDetails?.targetId}`)?.getAttribute("elementindex");
                const sheetIndexinTab=document.querySelector(`#${extraDetails?.targetId}`)?.getAttribute("sheetindex");
                
                const frameIndexinTab=document.querySelector(`#${extraDetails?.targetId}`)?.closest(`[elem_type=tab]`)?.closest(`[elem_type=frame]`)?.getAttribute("frameindex");
                
                var sheetElementIndexInTab;
                
                document.querySelector(`#${frameinsideTabId}`).querySelectorAll('[elem_type="frame"]').forEach((frame,index) => {
                    if(frame.getAttribute("id")===insideFrameId){
                        sheetElementIndexInTab=frame.getAttribute("sheetElementIndex");
                    }
                })
                    jsonToSend = {
                      frameIndex: frameIndexinTab || frameIndex,
                      elem_type: controlType === "paaragraph" ? "paragraph" :controlType,
                      controlName: controlType,
                      elementIndex: elementindexTab,
                      sheetId: parseInt(sheetIndexinTab) + "",  
                      sheetElementIndex: sheetElementIndexInTab.toString(),
                      opType: 4,
                      isSubForm: extraDetails?.isSubForm,
                      isAdvanceListview: extraDetails?.isAdvanceListview,
                      insideHeaderFrame: headerjson?.isWizardHeader === true || headerjson?.isWizardHeader === "true" ? "true" : undefined,
                      ...(extraDetails.insideMenu ? {
                          stepIndex: extraDetails.stepIndex,
                          subChildMenuIndex: extraDetails.subChildMenuIndex,
                          subStepIndex: extraDetails.substepIndex,
                      } : {})
                    };
                    remainingURL = extraDetails.insideMenu ? '/idesign/addNewElementToTabSheetFrameInStep' : '/idesign/addElement';
                }
                else if (extraDetails && extraDetails.sheetIndex !== undefined && extraDetails?.sheetIndex !== "" && extraDetails.sheetIndex !== null) {
                    jsonToSend = {
                        frameIndex: frameIndex,
                        elem_type: controlType === "paaragraph" ? "paragraph" :controlType,
                        elementIndex: extraDetails.elementIndex,
                        controlName: controlType,
                        sheetId: parseInt(extraDetails.sheetIndex) + "",
                        opType: 3,
                        isSubForm: extraDetails?.isSubForm,
                        insideHeaderFrame: headerjson?.isWizardHeader === true || headerjson?.isWizardHeader === "true" ? "true" : undefined,
                        isAdvanceListview: extraDetails?.isAdvanceListview,
                        ...(extraDetails.insideMenu ? {
                            stepIndex: extraDetails.stepIndex,
                            subChildMenuIndex: extraDetails.subChildMenuIndex,
                            subStepIndex: extraDetails.substepIndex,
                        } : {})
                    };
                    remainingURL = extraDetails.insideMenu ? '/idesign/addNewElementToTabSheetInStep' : '/idesign/addElement';
                }
                else if (controlType === 'wizard_h' || controlType === 'wizard_v') {
                    remainingURL = '/idesign/addElement';
                    jsonToSend = {
                      frameIndex: frameIndex,
                      elem_type: "wizard",
                      controlName: controlType,
                        isSubForm: extraDetails?.isSubForm,
                        opType: 1,
                        insideHeaderFrame: headerjson?.isWizardHeader === true || headerjson?.isWizardHeader === "true" ? "true" : undefined,
                    };
                }
                else if (controlType === "sidenavigation") {
                    remainingURL = '/idesign/addElement';
                    jsonToSend = {
                      frameIndex: frameIndex,
                      elem_type: "sidenavigation",
                      controlName: controlType,
                      isSubForm: extraDetails?.isSubForm,
                      isAdvanceListview: extraDetails?.isAdvanceListview,
                      opType: 1,
                      insideHeaderFrame: headerjson?.isWizardHeader === true || headerjson?.isWizardHeader === "true" ? "true" : undefined,
                    };
                }
                else if (controlType === "Menu") {
                    remainingURL = '/idesign/addElement';
                    jsonToSend = {"elem_type": "Menu" };
                    jsonToSend["opType"] = 1
                    jsonToSend['insideHeaderFrame'] = headerjson?.isWizardHeader === true || headerjson?.isWizardHeader === "true" ? "true" : undefined
                }
                else {
                    remainingURL = '/idesign/addElement';
                    jsonToSend = {
                        frameIndex: frameIndex,
                        elem_type: controlType === "paaragraph" ? "paragraph" :controlType,
                        controlName: controlType,
                        isSubForm: extraDetails?.isSubForm,
                        isAdvanceListview: extraDetails?.isAdvanceListview,
                        insideHeaderFrame: headerjson?.isWizardHeader === true || headerjson?.isWizardHeader === "true" ? "true" : undefined,
                        opType: 1
                    };                 
                }
                if (controlType === 'paragraph') {
                    jsonToSend = { ...jsonToSend, "controlName": "paaragraph" ,isSubForm: extraDetails?.isSubForm, isAdvanceListview: extraDetails?.isAdvanceListview,};
                }
                if (controlType === "richtexteditor") {
                    jsonToSend = { ...jsonToSend, "elem_type": "textarea", "controlName": "richtexteditor" ,isSubForm: extraDetails?.isSubForm, isAdvanceListview: extraDetails?.isAdvanceListview};
                }
                if (controlType === "imagecarousel") {
                    jsonToSend = { ...jsonToSend, "controlName": "imagecarousel" ,isSubForm: extraDetails?.isSubForm, isAdvanceListview: extraDetails?.isAdvanceListview};
                }
                if (controlType === "listbox") {
                    jsonToSend = { ...jsonToSend, "elem_type": "listbox", "controlName": "listbox" ,isSubForm: extraDetails?.isSubForm, isAdvanceListview: extraDetails?.isAdvanceListview};
                }
                if (controlType === "link") {
                    jsonToSend = { ...jsonToSend, "elem_type": "label", "controlName": "link" ,isSubForm: extraDetails?.isSubForm, isAdvanceListview: extraDetails?.isAdvanceListview};
                }
                if (controlType === "report") {
                    jsonToSend = { ...jsonToSend, "elem_type": "report", "controlName": "report" ,isSubForm: extraDetails?.isSubForm, isAdvanceListview: extraDetails?.isAdvanceListview};
                }
                if (controlType === 'email' || controlType === 'password' || controlType === 'percentage' || controlType === 'phonenumber' || controlType === 'picklist') {
                    jsonToSend = { ...jsonToSend, "elem_type": 'textbox', "controlName": controlType ,isSubForm: extraDetails?.isSubForm, isAdvanceListview: extraDetails?.isAdvanceListview};
                }
                if (controlType === 'tile') {
                    jsonToSend = { ...jsonToSend, "elem_type": 'CustomControl',  "opType":14, "controlName": controlType ,isSubForm: extraDetails?.isSubForm, isAdvanceListview: extraDetails?.isAdvanceListview, insideHeaderFrame: headerjson?.isWizardHeader === true || headerjson?.isWizardHeader === "true" ? "true" : undefined};
                    remainingURL = '/idesign/addElement';
                    
                }

            }

            
            if(controlType === 'CustomControl'){
                jsonToSend = { ...jsonToSend, "controlName" : extraDetails2.controlLabel}
            }   

        }

        else if (controlType === 'table') {
            if (extraDetails && extraDetails.sheetElementIndex !== undefined && extraDetails.sheetElementIndex !== null) {
                jsonToSend = {
                  formId:extraDetails?.formId || extraDetails2?.formId || activePage?.formId || activeSubFrom?.fragmentId,
                  layoutJson:"{}",
                  frameIndex: frameIndex,
                  elementIndex: extraDetails.elementIndex,
                  sheetId: parseInt(extraDetails.sheetIndex),
                  sheetElementIndex: extraDetails.sheetElementIndex,
                  elem_type: "table",
                  controlName: "table",
                  opType: 4,
                  isSubForm: extraDetails?.isSubForm,
                  insideHeaderFrame: headerjson?.isWizardHeader === true || headerjson?.isWizardHeader === "true" ? "true" : undefined,
                  isAdvanceListview: extraDetails?.isAdvanceListview,
                  ...(extraDetails.insideMenu ? {
                      stepIndex: extraDetails.stepIndex,
                      subChildMenuIndex: extraDetails.subChildMenuIndex,
                      subStepIndex: extraDetails.substepIndex,
                  } : {})
              };
              remainingURL = extraDetails.insideMenu ? '/idesign/addNewElementToTabSheetFrameInStep' : '/idesign/addElement';
            }
            else if (extraDetails && extraDetails.sheetIndex !== undefined && extraDetails.sheetIndex !== null && extraDetails?.sheetIndex !== "") {
                jsonToSend = { "frameIndex": frameIndex, "elementIndex": extraDetails.elementIndex, "sheetId": parseInt(extraDetails.sheetIndex), "elem_type": 'table', "controlName": "table" ,isSubForm: extraDetails?.isSubForm, isAdvanceListview: extraDetails?.isAdvanceListview,formId:extraDetails?.formId || extraDetails2?.formId,
                        ...(extraDetails.insideMenu ? {
                            stepIndex: extraDetails.stepIndex,
                            subChildMenuIndex: extraDetails.subChildMenuIndex,
                            subStepIndex: extraDetails.substepIndex,
                            opType: 3
                        } : {})
                    };
                    remainingURL = extraDetails.insideMenu ? '/idesign/addNewElementToTabSheetInStep' : '/idesign/addElement';
            } else {
                jsonToSend = { "frameIndex": frameIndex, "elem_type": 'table', "controlName": "table" ,
                formId:extraDetails?.formId || extraDetails2?.formDefId , isSubForm: extraDetails?.isSubForm, isAdvanceListview: extraDetails?.isAdvanceListview, opType:1, insideHeaderFrame: headerjson?.isWizardHeader === true || headerjson?.isWizardHeader === "true" ? "true" : undefined,};
                remainingURL = '/idesign/addElement';
            }
        }
        else if (controlType === 'tableColumn') {
            jsonToSend = cloneDeep((ThemeJSON.tableColumn1));


            let formId = getFormId()
            jsonToSend["FormId"] = formId;
            jsonToSend["layoutJson"] = "{}";
            jsonToSend["frameIndex"] = frameIndex;
            jsonToSend["elementIndex"] = extraDetails.elementIndex;
            jsonToSend["isSubForm"]= extraDetails?.isSubForm;
            jsonToSend["isAdvanceListview"]= extraDetails?.isAdvanceListview;
            jsonToSend["controlid"] = controlElemToAdd?.id
            jsonToSend["id"] = controlElemToAdd?.id
            jsonToSend["ColumnName"] = extraDetails?.columnName || ThemeJSON.tableColumn1.ColumnName;

            if (extraDetails !== undefined && extraDetails !== null) {
                for (let key in extraDetails) {
                    if (extraDetails.hasOwnProperty(key)) {
                        if (key === "sheetIndex") {
                            jsonToSend["sheetIndex"] = extraDetails[key];
                        } else {
                            jsonToSend[key] = extraDetails[key];
                        }
                    }
                }
                let formId = getFormId()
                jsonToSend["FormId"] = formId;
                jsonToSend["layoutJson"] = "{}";
                jsonToSend["stepIndex"] = getStepIndex();
                jsonToSend["subChildMenuIndex"] = getSubChildMenuIndex();
                jsonToSend["subStepIndex"] = getSubStepIndex();
            }
            if (extraDetails.sheetFrameElementIndex !== undefined && extraDetails.sheetFrameElementIndex !== null) {
                jsonToSend["opType"] = 4
                remainingURL = '/Properties/addColumn';
            }
            else if (extraDetails.sheetIndex !== undefined && extraDetails.sheetIndex !== null && extraDetails?.sheetIndex !== "") {
                jsonToSend["opType"] = 2
                remainingURL = '/Properties/addColumn';
            }
            else if(targetElement?.insideWizard){
                jsonToSend["opType"] = 3
                remainingURL = '/Properties/addColumn';
            }
            else if(targetElement?.insideMenu){
                jsonToSend["opType"] = 3
                remainingURL = '/Properties/addColumn';
            }
            else {
                jsonToSend["opType"] = 1
                remainingURL = '/Properties/addColumn';
            }
        } 
        else if (controlType === 'listview' || controlType === 'advancelistview') {
            if (extraDetails && extraDetails.sheetElementIndex !== undefined && extraDetails.sheetElementIndex !== null) {
                jsonToSend = {
                  formId:extraDetails?.formId || extraDetails?.formDefId || activePage?.formId || activeSubFrom?.fragmentId,
                  frameIndex: frameIndex,
                  elementIndex: extraDetails.elementIndex,
                  sheetId: parseInt(extraDetails.sheetIndex),
                  sheetElementIndex: extraDetails.sheetElementIndex,
                  elem_type: "listview",
                  controlName: "listview",
                  opType: 4,
                  isSubForm: extraDetails?.isSubForm,
                  isAdvanceListview: extraDetails?.isAdvanceListview,
                  ...(extraDetails.insideMenu ? {
                      stepIndex: extraDetails.stepIndex,
                      subChildMenuIndex: extraDetails.subChildMenuIndex,
                      subStepIndex: extraDetails.substepIndex,
                  } : {})
              };
              remainingURL = extraDetails.insideMenu ? '/idesign/addNewElementToTabSheetFrameInStep' : '/idesign/addElement';
            }
            else if (extraDetails.sheetIndex !== undefined && extraDetails.sheetIndex !== null && extraDetails?.sheetIndex !== "") {
                jsonToSend = {
                    formId:extraDetails.formId || extraDetails?.formDefId || activePage?.formId || activeSubFrom?.fragmentId,
                  frameIndex: frameIndex,
                  elementIndex: extraDetails.elementIndex,
                  sheetId: parseInt(extraDetails.sheetIndex),
                  elem_type: "listview",
                  controlName: "listview",
                  opType: 3,
                  isSubForm: extraDetails?.isSubForm,
                  insideHeaderFrame: headerjson?.isWizardHeader === true || headerjson?.isWizardHeader === "true" ? "true" : undefined,
                  isAdvanceListview: extraDetails?.isAdvanceListview,
                  ...(extraDetails.insideMenu ? {
                      stepIndex: extraDetails.stepIndex,
                      subChildMenuIndex: extraDetails.subChildMenuIndex,
                      subStepIndex: extraDetails.substepIndex,
                  } : {})
              };
              remainingURL = extraDetails.insideMenu ? '/idesign/addNewElementToTabSheetInStep' : '/idesign/addElement';
            } 
            else {
                jsonToSend = {
                  frameIndex: frameIndex,
                  formId:extraDetails.formId || extraDetails?.formDefId || activePage?.formId || activeSubFrom?.fragmentId,
                   elem_type: controlType === 'listview' ? "listview" : "advancelistView",
                   controlName: controlType === 'listview' ? "listview" : "advancelistView",
                  isSubForm: extraDetails?.isSubForm,
                  isAdvanceListview: extraDetails?.isAdvanceListview,
                  insideHeaderFrame: headerjson?.isWizardHeader === true || headerjson?.isWizardHeader === "true" ? "true" : undefined,
                  opType: 1
                };
                remainingURL = '/idesign/addElement';
            }
        }
        else if (controlType === 'tab') {
            jsonToSend = {
                isSubForm: extraDetails?.isSubForm,
                isAdvanceListview: extraDetails?.isAdvanceListview,
                opType: 7
            };
            remainingURL = '/idesign/addElement';
        }
        else if (controlType === 'sheet') {
            jsonToSend = {
              frameIndex: frameIndex,
              elem_type: controlType,
              opType:10,
              isSubForm: extraDetails?.isSubForm,
              isAdvanceListview: extraDetails?.isAdvanceListview,
              ...(extraDetails.insideMenu ? {
                  stepIndex: extraDetails.stepIndex,
                  subChildMenuIndex: extraDetails.subChildMenuIndex,
                  subStepIndex: extraDetails.substepIndex,
              } : {})
            };
            remainingURL = extraDetails.insideMenu ? '/idesign/addTabSheetControlInStep' : '/idesign/addElement';

            if (extraDetails !== undefined && extraDetails !== null) {
                for (let key in extraDetails) {
                    if (extraDetails.hasOwnProperty(key)) {
                        jsonToSend[key] = extraDetails[key];
                    }
                }
            }
        }
        else if (controlType === "step") {
            if(extraDetails?.elem_type==="MainMenu"){
                jsonToSend = { "elem_type":"MainMenu", "opType":11 };
                remainingURL = '/idesign/addElement';
            } 
            else{
                jsonToSend = { "frameIndex": frameIndex, "opType":11, "elem_type": "Step", "controlName": "Step" ,isSubForm: extraDetails?.isSubForm, isAdvanceListview: extraDetails?.isAdvanceListview};
                remainingURL = '/idesign/addElement';
            }
        } 
        else if (controlType === "addSubStep") {
            if(extraDetails?.elem_type==="SubMenu"){
                jsonToSend = { "elem_type":"SubMenu" , "opType":12, "stepIndex": extraDetails?.stepIndex };
                remainingURL = '/idesign/addElement';
            }
            else{
                jsonToSend = { "frameIndex": frameIndex, "opType":12, "elem_type": "SubStep", "controlName": "SubStep", "stepIndex": frameIndex ,isSubForm: extraDetails?.isSubForm, isAdvanceListview: extraDetails?.isAdvanceListview};
                remainingURL = '/idesign/addElement';
            }
        }
        else if(controlType=== "addSubChildMenu"){
            jsonToSend = { "elem_type":"SubChildMenu" , "opType":13, "stepIndex": extraDetails?.stepIndex ,"subStepIndex": extraDetails?.substepIndex };
            remainingURL = '/idesign/addElement';
        }

        else if(controlType?.includes("template")){
            const templateDetailsArray = controlType.split("-");
            if(templateDetailsArray[1]){
                try{
                    jsonToSend = {
                      templateid: parseInt(templateDetailsArray[1]),
                      isSubForm: extraDetails?.isSubForm,
                      isAdvanceListview: extraDetails?.isAdvanceListview,
                    };
                    remainingURL = '/idesign/loadControlTemplate';
                }
                catch(e){
                     console.log("Error while loading template :: " + e);
                }
            }
        }

        
    }
    else if (operationType === 'delete') {
       
        if(extraDetails?.insideWizard === true || extraDetails?.containerControl === "wizard_h" || extraDetails?.containerControl === "wizard_v" || extraDetails?.containerControl === "sidenavigation"){
         

            if (controlType === 'section' || controlType === 'frame') {
                jsonToSend = { 
                "frameIndex": frameIndex, 
                "id": extraDetails.id,
                "elem_type": controlType ,isSubForm: extraDetails?.isSubForm,  
                "stepIndex": extraDetails?.stepIndex ,
                "subStepIndex" : extraDetails?.subStepIndex,
                "subChildMenuIndex" : extraDetails.subChildMenuIndex,
                "isAdvanceListview": extraDetails?.isAdvanceListview, 
                "type": 'wizard'};
            }
            else if (controlType === "Step") {
                
                    jsonToSend = { "elem_type": "Step", "stepIndex": extraDetails.StepIndex || extraDetails?.stepIndex,
                    "subStepIndex" : "-1" ,"subChildMenuIndex" : "-1",
                    isSubForm: extraDetails?.isSubForm,  isAdvanceListview: extraDetails?.isAdvanceListview, "type": 'wizard'};
            
            }
             else if (controlType === "SubStep") {
            
                    jsonToSend = { "elem_type": "SubStep", "stepIndex": extraDetails?.StepIndex || extraDetails?.stepIndex, 
                    subStepIndex: extraDetails?.SubStepIndex || extraDetails?.subStepIndex ,  "subChildMenuIndex" : "-1",
                    isSubForm: extraDetails?.isSubForm,  isAdvanceListview: extraDetails?.isAdvanceListview, "type": 'wizard'};
                
             }
            else if(controlType === "wizard_h" || controlType === "wizard_v" || controlType === "sidenavigation"){
                jsonToSend = {"type": 'wizard'};
            }
            else {
                jsonToSend = { "frameIndex": frameIndex, "elementIndex": extraDetails?.elementIndex ,
                "stepIndex": extraDetails?.stepIndex ,
                "subStepIndex" : extraDetails?.subStepIndex ,
                "subChildMenuIndex" : extraDetails?.subChildMenuIndex,
                isSubForm: extraDetails?.isSubForm,  isAdvanceListview: extraDetails?.isAdvanceListview, "type": 'wizard'};
            }

        }
        else  if(extraDetails?.insideMenu === true || extraDetails?.containerControl?.toLowerCase() === "menu"){


              if (controlType === 'section' || controlType === 'frame') {
                  jsonToSend = { "frameIndex": frameIndex, "id": extraDetails.id, "elem_type": controlType ,isSubForm: extraDetails?.isSubForm,  
                  "stepIndex": extraDetails.stepIndex ,
                  "subStepIndex" : extraDetails.substepIndex ,
                  "subChildMenuIndex" : extraDetails.subChildMenuIndex,
                  isAdvanceListview: extraDetails?.isAdvanceListview, "type": 'menu'};
              }
              else if(controlType === "Menu"){
                  jsonToSend = {"type": 'menu' };
              }   
              else {
                  jsonToSend = { "frameIndex": frameIndex, "elementIndex": extraDetails?.elementIndex ,
                  "stepIndex": extraDetails.stepIndex ,
                  "subStepIndex" : extraDetails.substepIndex ,
                  "subChildMenuIndex" : extraDetails.subChildMenuIndex,
                  isSubForm: extraDetails?.isSubForm,  isAdvanceListview: extraDetails?.isAdvanceListview, "type": 'menu'};
              }
          }
        else if (extraDetails && extraDetails.sheetFrameElementIndex !== undefined) {
            jsonToSend = {
              frameIndex: frameIndex,
              elementIndex: extraDetails.elementIndex,
              sheetId: extraDetails.sheetIndex + "",
              sheetElementIndex: extraDetails.sheetElementIndex,
              sheetFrameElementIndex: extraDetails.sheetFrameElementIndex,
              isSubForm: extraDetails2?.isSubForm,
              isAdvanceListview: extraDetails2?.isAdvanceListview,
            };
        }
        else if (extraDetails && extraDetails.sheetIndex !== undefined && extraDetails?.sheetIndex !== "" && extraDetails?.sheetIndex !== null) {
            jsonToSend = {
              frameIndex: frameIndex,
              elementIndex: extraDetails.elementIndex,
              sheetId: extraDetails.sheetIndex + "",
              sheetElementIndex: extraDetails.sheetElementIndex,
              isSubForm: extraDetails2?.isSubForm,
              isAdvanceListview: extraDetails2?.isAdvanceListview,
            };
        }
        else {
            if (controlType === 'section' || controlType === 'frame') {
                jsonToSend = { "frameIndex": frameIndex, "id": extraDetails.id, "elem_type": controlType ,"isSubForm": extraDetails2?.isSubForm,  "isAdvanceListview": extraDetails2?.isAdvanceListview,};
            }
            else if (controlType === "step") {
                if(extraDetails?.elem_type==="MainMenu"){
                    jsonToSend = { "elem_type":"MainMenu" , "stepIndex": extraDetails.stepIndex ,
                    "subStepIndex" : "-1" ,"subChildMenuIndex" : "-1", "type": 'menu' };
                } 
                else{
                    jsonToSend = { "elem_type": "Step", "stepIndex": extraDetails.stepIndex ,"isSubForm": extraDetails2?.isSubForm,  "isAdvanceListview": extraDetails2?.isAdvanceListview, "type": 'wizard'};
                }
            }
            else if (controlType === "subStep") {
                if(extraDetails?.elem_type==="SubMenu"){
                    jsonToSend = { "elem_type":"SubMenu" , "stepIndex": extraDetails.stepIndex ,"subStepIndex" : extraDetails.subStepIndex ,"subChildMenuIndex" : "-1", "type": 'menu' };
                }
                else{
                    jsonToSend = { "elem_type": "SubStep", "stepIndex": extraDetails?.stepIndex, 
                    "subChildMenuIndex" : "-1",
                    subStepIndex: extraDetails?.subStepIndex ,isSubForm: extraDetails2?.isSubForm,  isAdvanceListview: extraDetails2?.isAdvanceListview, "type": 'wizard'};
                }
            }
            else if(controlType === "SubChildMenu"){
                jsonToSend = { "elem_type":"SubChildMenu" , "stepIndex": extraDetails.stepIndex ,
                "subStepIndex" : extraDetails.subStepIndex ,"subChildMenuIndex" : extraDetails.subChildMenuIndex, "type": 'menu' };
            }
            else if(controlType === "tabSheet123") {
                jsonToSend={
                    sheetId: extraDetails?.sheetId,
                    frameIndex: extraDetails?.frameIndex,
                    elementIndex: extraDetails?.elementIndex,
                    isSubForm: extraDetails?.isSubForm,
                    isAdvanceListview: extraDetails?.isAdvanceListview,
                }                
            }
            else {
                jsonToSend = { "frameIndex": frameIndex, "elementIndex": extraDetails?.elementIndex ,isSubForm: extraDetails2?.isSubForm,  isAdvanceListview: extraDetails2?.isAdvanceListview,};
            }
        }

        if (controlType === "column") {
            jsonToSend = extraDetails;
            jsonToSend["isSubForm"] = extraDetails?.isSubForm;
            jsonToSend["isAdvanceListview"] =  extraDetails?.isAdvanceListview;
            delete jsonToSend['remainingURL'];
            remainingURL = extraDetails["remainingURL"];
        }
    } 
    else if (operationType === 'duplicate') {
        remainingURL = '/idesign/uploadElement';
        jsonToSend = extraDetails;
        jsonToSend["isSubForm"] = extraDetails?.isSubForm;
        jsonToSend["isAdvanceListview"] =  extraDetails?.isAdvanceListview;
    }
    else if (operationType === 'import') {
        remainingURL = '/idesign/uploadElement';
        jsonToSend = extraDetails;
        jsonToSend["isSubForm"] = extraDetails?.isSubForm;
        jsonToSend["isAdvanceListview"] =  extraDetails?.isAdvanceListview;
    }
    else if (operationType === 'duplicateDataObject') {
        remainingURL = '/idesign/addDataObjects';
        jsonToSend = extraDetails;
        jsonToSend["isSubForm"] = extraDetails?.isSubForm;
        jsonToSend["isAdvanceListview"] =  extraDetails?.isAdvanceListview;
    } 
    else if (operationType === "upload" && controlType==='subform') {
      remainingURL = "/idesign/populateSubformFromJson";
      jsonToSend = { ...jsonToSend, ...extraDetails };
      jsonToSend["isSubForm"] = extraDetails?.isSubForm;
    }
    else if (operationType === "deLink") {
        jsonToSend = {
            "mappedField": extraDetails.treeName,
            "formId": extraDetails.formId,
        }
        remainingURL = "/idesign/deLinkDataObject";
    }
    if(extraDetails?.isUpload){
        jsonToSend["isAdvanceListview"] = extraDetails?.isAdvanceListview;
        jsonToSend["isSubForm"] = extraDetails?.isSubForm;
    }
    let formId = getFormId();
    jsonToSend.formId = formId?.toString();
    if(operationType === "delete"){
        remainingURL =  '/idesign/deleteElement';
        jsonToSend["controlid"] = extraDetails?.id

        if(jsonToSend["controlid"] === "wizard" && (jsonToSend["type"] === "wizard" || jsonToSend["type"] === "menu")) {
            const formStateDelete = getFormJsonFromStore();
            const setActiveMenuId = getSetActiveMenuId();

            if(setActiveMenuId) {
                setActiveMenuId(null);
            }

            if(formStateDelete.containerControl) {
                delete formStateDelete.containerControl;
            }
        }
    }
    if(operationType === "add" && remainingURL?.includes("/addColumn")){
        jsonToSend["controlid"] = extraDetails?.id
        if(getFormJsonFromStore()?.containerControl){
            if(getFormJsonFromStore()?.containerControl === "Menu"){
              jsonToSend["type"] = "menu"
            }
            if(getFormJsonFromStore()?.containerControl === "wizard_h" || getFormJsonFromStore()?.containerControl === "wizard_v" || getFormJsonFromStore()?.containerControl === "sidenavigation"){
              jsonToSend["type"] = "wizard"
            }
        }
    }
    if(operationType === "add" && containsWizard() && (!jsonToSend?.["stepIndex"] && jsonToSend?.["stepIndex"] !== 0) && (jsonToSend?.["elem_type"] === 'frame' || jsonToSend?.["elem_type"] === 'section') && !extraDetails2?.insideHeaderFrame1 && !extraDetails2?.isSubForm && !extraDetails2?.isAdvanceListview) {
        showAlertConfirmNotifications({
            open: true,
            showConfirm: "showNotification",
            alertType: "error",
            alertContentKey: "CANT_DROP",
          });
        return;
    }
    if(remainingURL !== "" && operationType === "deLink"){
        const res = await axios.post(remainingURL, jsonToSend, { withCredentials: true });
        window.loading(false);
        return;
    }
    else if(remainingURL !== "")
    if(controlElemToAdd?.id?.includes("table")) {
        jsonToSend["controlid"] = controlElemToAdd.id
        jsonToSend["targetElemType"] = undefined;
    }
    if(remainingURL === "/idesign/uploadElement" && jsonToSend?.populateInside?.isSubForm){
        if(jsonToSend?.populateInside?.elem_type === "form"){
            jsonToSend.populateInside.id = "RootControl"
        }
        if(jsonToSend?.populateElem?.elem_type === "doclist" || jsonToSend?.populateElem?.elem_type === "table" || 
            jsonToSend?.populateElem?.elem_type === "listview" || jsonToSend?.populateElem?.elem_type === "advancelistview" || 
            jsonToSend?.populateElem?.elem_type === "advancelistView" || jsonToSend?.populateElem?.elem_type === "report" 
         ){
            jsonToSend.populateInside.elem_type = "frame"
        }
        const indexkeys = ["stepIndex","subChildMenuIndex","subStepIndex"]
        indexkeys.forEach(indexkey=>{
            if(Object.keys(jsonToSend?.populateInside).includes(indexkey)){
                delete jsonToSend.populateInside[indexkey]
            } 
            if(Object.keys(jsonToSend).includes(indexkey)){
                delete jsonToSend[indexkey]
            } 
        })
    }
    const res = await axios.post(remainingURL, jsonToSend, { withCredentials: true });
    const formJson = getFormJsonFromStore();
  
    let data;
    if(operationType === "add" || operationType === "delete"){
        data = recursiveJsonReader1(formJson,operationType === "add" ? res?.data?.id : res?.data?.deleteId);
    }
    else if(operationType === "duplicate" || operationType === "import"){
        data = recursiveJsonReader1(formJson, res?.data?.populatedJson?.id);
    }
    if(jsonToSend?.elem_type?.toLowerCase()==="step" && extraDetails?.callSource==="properties"){
        window.loading(false);
    }
    else if(jsonToSend?.elem_type?.toLowerCase()==="step" && operationType === "delete"){
        window.loading(false);
    }
    else if(jsonToSend?.elem_type?.toLowerCase()==="step"){
        // window.loading(false);
        window.elem_typecalling_mf= "step";
    }
    else{
        if(!holdLoader){
            window.loading(false);
        }
    }
        if(operationType === "add" || operationType === 'duplicate' || operationType === 'import') {
            if(res?.status === 200 && (res?.data?.populatedJson || res?.data) && remainingURL !== "/Properties/addColumn") {
                if(data && Object.keys(data).length > 0) {
                    if(window?.mf_iforms_corrupt) 
                        window.mf_iforms_corrupt(true);
                    res.data.status = 1;
                    res.status = 500
                };                
            }
        }
        return res;
}

export const addParentToFrame = (frameId,formState,obj) => {
    if (formState?.children) {
        for(let i=0; i<formState.children.length;i++){
            if (formState.children[i].id === frameId) {
                if(formState.children[i].queueVars) {
                    if(!formState.children[i].queueVars?.includes(obj))
                        formState.children[i].queueVars.push(obj);
                }
                else {
                    formState.children[i].queueVars = [];
                    formState.children[i].queueVars.push(obj);
                }
                return;
            }
            else if(formState.children[i].subform && formState.children[i].elem_type === "button") {
                addParentToFrame(frameId,formState.children[i].subform,obj);
            }
            else if(formState.children[i].listviewFrameLayoutJson && formState.children[i].elem_type === "advancelistView") {
                addParentToFrame(frameId,formState.children[i].listviewFrameLayoutJson,obj);
            }
            else {
                addParentToFrame(frameId,formState.children[i],obj);
            }
        }
    }
}


// parentJson - Parent Json in which you want to add another Json
// componentToAdd - Json to add in parentJson 
// position - where to add the component json in parent ( before/after/inside/same), at same position it will replcae the existing control
// referenceControlId - reference id for the positioning of control
let depth = 0;
let foundRefElem = false;
let nextElem = null;
let ColumnLayout = null;
let parentRowBuffer = null;
let parentRowIndex = null;
let parentRowDepth = null;
let parentColumnBuffer = null;
let parentColumnIndex = null;
let parentColumnDepth = null;
let parentDepth = null;
let parentIndex = null;
let parentBuffer = null; // stores the parent
let bufferJson = null; // stores the json that need to be added after the 

export async function addComponentInJson(parentJson, componentToAdd, position, referenceControlId) {
    if (parentJson !== undefined && parentJson !== null) {
        if (Array.isArray(parentJson)) {
            if (parentJson.id === referenceControlId) {
                //not doing anthing here
                foundRefElem = true;
                return parentJson;
            }
        } else {
            if (parentJson.elem_type) {
                if (foundRefElem === false) {
                    if (parentJson.elem_type === "row") {
                        parentRowBuffer = parentJson;
                    } else if (parentJson.elem_type === "column") {
                        parentColumnBuffer = parentJson;
                    } else if (
                        parentJson.elem_type === "section" ||
                        parentJson.elem_type === "frame" ||
                        parentJson.elem_type === "wizard_h" ||
                        parentJson.elem_type === "wizard_v" ||
                        parentJson.elem_type === "sheet"
                    ) {
                        parentBuffer = parentJson;
                    }
                    if (parentJson.ColumnLayout) {
                        ColumnLayout = parentJson.ColumnLayout;
                    }
                }
            }
            if (
                parentJson.children !== undefined &&
                parentJson.children !== null
            ) {
                depth++;
                var children = [];
                children = parentJson.children.map((child, childIndex) => {
                    if (foundRefElem === false) {
                        if (child.elem_type === "row") {
                            parentRowIndex = childIndex;
                            parentRowDepth = depth;
                        } else if (child.elem_type === "column") {
                            parentColumnIndex = childIndex;
                            parentColumnDepth = depth;
                        } else if (
                            child.elem_type === "section" ||
                            child.elem_type === "frame" ||
                            child.elem_type === "wizard_h" ||
                            child.elem_type === "wizard_v" ||
                            child.elem_type === "sheet"
                        ) {
                            parentDepth = depth;
                            parentIndex = childIndex;
                        }
                    }
                    if (child !== null && child !== undefined) {
                        if (child.id !== null && child.id !== undefined) {
                            if (child.id === referenceControlId) {
                                foundRefElem = true;
                            } else {
                                if (child.elem_type) {
                                    if (foundRefElem === false) {
                                        if (child.elem_type === "row") {
                                            parentRowBuffer = child;
                                        } else if (child.elem_type === "column") {
                                            parentColumnBuffer = child;
                                        }
                                        if (child.ColumnLayout) {
                                            ColumnLayout = child.ColumnLayout;
                                        }
                                    } else {
                                        if (nextElem === null) {
                                            nextElem = child;
                                        }
                                    }
                                }
                                return addComponentInJson(child, componentToAdd, position, referenceControlId);
                            }
                        }
                    }
                });
                try {
                    var intColumnLayout = null;
                    if (
                        ColumnLayout !== null &&
                        ColumnLayout !== undefined &&
                        ColumnLayout.trim() !== ""
                    ) {
                        intColumnLayout = parseInt(ColumnLayout);
                        let parentRowBufferChildCount = null;
                        // if the element is such which goes inside the row and column
                        if (parentRowBuffer !== null && parentRowBuffer !== undefined && parentRowBuffer["children"]) {
                            parentRowBufferChildCount = parentRowBuffer["children"].size();
                            if (parentRowBufferChildCount < intColumnLayout) {
                                var columnJson = {};
                                columnJson.w = parentColumnBuffer.w;
                                columnJson.ms = parentColumnBuffer.ms;
                                columnJson.sm = parentColumnBuffer.sm;
                                columnJson.xs = parentColumnBuffer.xs;
                                columnJson.frameIndex = componentToAdd.elementIndex;
                                columnJson.elem_type = "column";
                                columnJson.elementIndex = componentToAdd.elementIndex;
                                if (componentToAdd.sheetIndex !== undefined) {
                                    columnJson.sheetIndex = componentToAdd.sheetIndex;
                                    columnJson.sheetElementIndex =
                                        componentToAdd.sheetElementIndex;
                                }
                                columnJson.children = [];
                                columnJson.children.push(componentToAdd);

                                parentRowBuffer["children"] = insertAt(
                                    parentRowBuffer["children"],
                                    parentColumnIndex + 1
                                );
                            } else {
                                //if there is no space in the existing row, then we will crete a new row and will create remaining columns in this as well.
                            }
                        }
                    }
                } catch (error) {
                     console.log(error);
                }
                parentJson.children = children;
                depth--;
            }
        }
    }
    return parentJson;
}

export function getTabActiveIndex(containerId){
    const state=formStateStore.getState();
    if(containerId===undefined){
        containerId=getContainerId()
    }
    return state.data.find(json => json.key === containerId)?.contexts?.tabActiveIndex;
}

export function updateElementById(id, updates) {
    const realId = window?.aliasMap?.get(id) || id; // Convert alias to real ID if needed
    const element = window?.elementMap?.get(realId);

    if (!element) {
        console.warn(`Element with ID '${id}' not found.`);
        return false;
    }

    // ✅ Create a new updated object (immutability-friendly, but not required)
    const updatedElement = updates ;

    // ✅ Update `elementMap` to ensure reference is refreshed
    window?.elementMap?.set(realId, updatedElement);

    // ✅ Ensure aliasMap stays consistent
    if (window?.aliasMap?.has(id)) window?.aliasMap?.set(id, realId);

    // return true; // Successfully updated
}

export function updateElementByValue(id, updates) {
    const realId = window?.aliasMap?.get(id) || id; // Convert alias to real ID if needed
    const element = window?.elementMap?.get(realId);

    if (!element) {
        console.warn(`Element with ID '${id}' not found.`);
        return false;
    }

    // ✅ Create a new updated object (immutability-friendly, but not required)
    element.value = updates
    const updatedElement = element ;

    // ✅ Update `elementMap` to ensure reference is refreshed
    window?.elementMap?.set(realId, updatedElement);

    // ✅ Ensure aliasMap stays consistent
    if (window?.aliasMap?.has(id)) window?.aliasMap?.set(id, realId);

    // return true; // Successfully updated
}

export const updatePartialJSON = (id,json, shouldSaveInFormState = true, subfmName) => {
    let formJson = {};
    const state = formStateStore.getState();
    let containerId = state.containerInfo.containerId;
    const isComposed = window?.event?.composed; 
    const isTrusted = window?.event?.isTrusted;

    if(shouldSaveInFormState === false) {
        shouldSaveInFormState = !json?.isAdvanceListview;
    }

    if(shouldSaveInFormState === false) {
        shouldSaveInFormState = !json?.isInsideListview;
    }

    if( isComposed || isTrusted ){
        getSetLatestChangesSaved(false);
        getSetFormstateChangedByUserNew(true);
    }
    else if(isComposed === false){
        getSetFormstateChangedByUserNew(false);
    }
    controlFoundFalseMaker();
    const { openCanvasForPreviewAdvance, currentAdvanceListviewStateJson, openCanvasForPreview, subFormListviewJson } = getGridStates();
    const subFormMetaData = getSubFormMetaData();
    const previewMode = getPreviewMode();
    if(subFormMetaData?.includes(json?.buttonId) && json?.isSubForm && previewMode) {
        formJson = getFormJsonFromStore();
    }
    else if(openCanvasForPreviewAdvance === "advanceListviewPopupInPreview" && currentAdvanceListviewStateJson && subFormListviewJson && openCanvasForPreview === "showDataAdditonSection") {
        // formJson = currentAdvanceListviewStateJson?.listviewFrameLayoutJson;
        // fetchAndUpdateJSON(formJson,id,json, subfmName);
        // let currentLvJson = functions.readJson(formJson, fetchGridStates()?.subFormListviewJson?.id)
        // console.log("inside updated9 partialJson", currentLvJson, formJson)
        // formStateStore.dispatch(
        //     updateGridContexts({
        //       name: "subFormListviewJson",
        //       key: containerId,
        //       value: { ...fetchGridStates()?.subFormListviewJson, listviewFrameLayoutJson: { ...currentLvJson?.listviewFrameLayoutJson }},
        //       renderListView: true, 
        //       // renderCanvas: true
        //     })
        //   );
        let lvJson = fetchGridStates()?.subFormListviewJson;
        fetchAndUpdateJSON(lvJson,id,json);
        formStateStore.dispatch(
            updateGridContexts({
              name: "subFormListviewJson",
              key: containerId,
              value: lvJson,
            //   value: { ...fetchGridStates()?.subFormListviewJson, listviewFrameLayoutJson: { ...currentLvJson?.listviewFrameLayoutJson }},
              renderListView: true, 
              // renderCanvas: true
            })
        );
        // formStateStore.dispatch(updateGridContexts({ name: "currentAdvanceListviewStateJson", key: containerId, value: { ...fetchGridStates().currentAdvanceListviewStateJson, listviewFrameLayoutJson: { ...formJson }}, renderAdvListView: false, renderListView: false}));
        return;
    } 
    else if(openCanvasForPreviewAdvance === "advanceListviewPopupInPreview" && currentAdvanceListviewStateJson && !shouldSaveInFormState) {
        formJson = currentAdvanceListviewStateJson?.listviewFrameLayoutJson;
    } 
    else if(subFormListviewJson && openCanvasForPreview === "showDataAdditonSection" && !shouldSaveInFormState) {
        formJson = subFormListviewJson?.listviewFrameLayoutJson;
    } 
    else {
        formJson = getFormJsonFromStore();
    }
    fetchAndUpdateJSON(formJson,id,json, subfmName);
    if(subFormMetaData?.includes(json?.buttonId) && json?.isSubForm && previewMode) {
        formStateStore.dispatch(updateFormStateWithoutRender(formJson));
    }
    else if(openCanvasForPreviewAdvance === "advanceListviewPopupInPreview" && currentAdvanceListviewStateJson && !shouldSaveInFormState) {
        formStateStore.dispatch(updateGridContexts({ name: "currentAdvanceListviewStateJson", key: containerId, value: { ...fetchGridStates().currentAdvanceListviewStateJson, listviewFrameLayoutJson: { ...formJson }}, renderAdvListView: true, renderListView: false}));
    }
    else if(subFormListviewJson && openCanvasForPreview === "showDataAdditonSection" && !shouldSaveInFormState) {
        formStateStore.dispatch(
            updateGridContexts({
              name: "subFormListviewJson",
              key: containerId,
              value: { ...fetchGridStates()?.subFormListviewJson, listviewFrameLayoutJson: { ...formJson }},
              renderListView: true, 
              // renderCanvas: true
            })
          );
    } 
    else{
        formStateStore.dispatch(updateFormStateWithoutRender(formJson));
    }
    // if(id && json){
    //     updateElementById(id, json)
    // }
}

export const fetchAndUpdateJSON = (formState,id,value, subfmName) => {   
        // if(value.elem_type==="button"){
        //     if(value.isButtonProperties){
        //         value.isButtonProperties = "";
        //     }
        // }
        if (formState?.children) {
        for(let i=0; i<formState.children.length;i++){
            if (id && formState.children[i].id === id) {
                if(subfmName?.toLowerCase() === "buttonsubform"){
                    formState.children[i].subform = {...value};
                    break;
                }
                else{
                    formState.children[i] = {...value};
                    break;
                } 
            }
            else if(formState.children[i].subform && formState.children[i].elem_type === "button") {
                fetchAndUpdateJSON(formState.children[i].subform,id,value, subfmName);
            }
            else if(formState.children[i].listviewFrameLayoutJson && formState.children[i].elem_type?.toLowerCase() === "advancelistview" || formState.children[i].elem_type?.toLowerCase() === "listview") {
                fetchAndUpdateJSON(formState.children[i].listviewFrameLayoutJson,id,value, subfmName);
            }
            else {
                fetchAndUpdateJSON(formState.children[i],id,value, subfmName);
            }
        }
    }
}

export const findStepName = (data, stepId, subStepId) => {
    for(let i = 0; i < data?.children?.length; i++) {
        if(data?.children?.[i]?.id === stepId) {
            if(containsSubsteps(data?.children?.[i],"substep") && subStepId) {
                for(let j = 0; j < data?.children?.[i]?.children?.length; j++) {
                    if(data?.children?.[i]?.children?.[j]?.id === subStepId)
                        return [data?.children?.[i]?.stepName, data?.children?.[i]?.children?.[j]?.substepName];
                }
            }
            return [data?.children?.[i]?.stepName, ""];                
        }
    }
    return ["",""];
}

export const updateStepIndexInSubForm = (state, updatedIndex, type, updatedIndex2, type2) => {
    state[type] = updatedIndex;
    if(type2)
        state[type2] = updatedIndex2;
    if (state?.children) {
        for(let i=0; i < state.children.length;i++){
            if(state.children[i].children) {
                updateStepIndexInSubForm(state.children[i],updatedIndex,type, updatedIndex2, type2);
            }
            else if(state.children[i].tileContents) {
                state.children[i].type = updatedIndex;
                if(type2)
                    state.children[i][type2] = updatedIndex2;
                for(let j = 0 ; j < state.children[i].tileContents.length; j++) {
                    state.children[i].tileContents[j][type] = updatedIndex;
                    if(type2)
                        state.children[i].tileContents[j][type2] = updatedIndex2;
                }
            }
            else {
                state.children[i][type] = updatedIndex;
                if(type2)
                    state.children[i][type2] = updatedIndex2;
            }
        }
    }
    else {
        return;
    }
}

window.isComponentValidated = function (type, formData, fromWizard, currentListviewColumnInfo) {

    console.log("type->",type);
    console.log("formData->",formData);
    console.log("fromWizard->",fromWizard);

    const openCanvasForPreviewAdvance = getOpenCanvasForPreviewAdvance();
    const showAlertConfirmNotifications = getShowAlertNotificationFromStore();
      const { currentAdvanceListviewStateJson = {} } = getGridStates();

    if(type === "buttonSubform" || type === "listviewSubform"){
        setMandatoryControls1([]);
    }
    if(openCanvasForPreviewAdvance === "advanceListviewPopupInPreview" && currentAdvanceListviewStateJson.style?.GridModalType === "modal" && type !== "buttonSubform" && type !== "listviewSubform") {
        showAlertConfirmNotifications({
            open: true,
            showConfirm: "showNotification",
            alertType: "error",
            autoHideDuration: 3000,
            alertContentKey: `Please close the popup first`,
          });
          return false;
    }
 
    let skipValidationFlag = false;
    let obj = {}
    const state=formStateStore.getState();
    const containerId=getContainerId()
    const formMataData = getFormMataData();
    const formState2 = getFormJsonFromStore();
    const mandatoryControls = getMandatoryControls();
    

    if (window.skipValidation) {
      skipValidationFlag = window.skipValidation(formData?.validationType, formData?.validationId);
    }

    if(fromWizard && !getGdToken()) return true
    

    if (!skipValidationFlag) {
        let skipControlValidation = []
        if (window.skipControlValidation) {
            if(fromWizard) 
                skipControlValidation = window.skipControlValidation("wizard", getSubStepName() || getStepName());
            else    
                skipControlValidation = window.skipControlValidation(formData?.validationType, formData?.validationId);
        }
    
        if((skipControlValidation?.includes(getStepName()) || skipControlValidation?.includes(getSubStepName())) && fromWizard) return true;
   
        let mandatoryArr = [];
        if (type === "listviewSubform") {
          checkForAllNonFilledMandatoryFields(formData, mandatoryArr, obj, type, { currentListviewColumnInfo, skipControlValidation });
        } else if (type === "buttonSubform") {
          checkForAllNonFilledMandatoryFields(formData, mandatoryArr, obj, type, { skipControlValidation });
        } else if (type === "wizardSubform") {
          checkForAllNonFilledMandatoryFields({"children": formData}, mandatoryArr, obj, type, { skipControlValidation });
        } else {
          checkForAllNonFilledMandatoryFields(formState2, mandatoryArr, obj, type, { skipControlValidation });
        }
        if (mandatoryArr.length > 0) {
            setMandatoryControls1([...mandatoryArr]);
        if(!formMataData && mandatoryArr.length !== 0){
            if(!mandatoryArr[0]?.includes("_")) {
                for(let i = 0; i < mandatoryArr.length; i++) {
                  if(!obj[mandatoryArr[i]]) {
                    if(type === "listviewSubform" || type === "buttonSubform")
                        functions.setFocus(mandatoryArr[i],formData);
                    else if(type === "wizardSubform")
                        functions.setFocus(mandatoryArr[i],{"children":formData});
                    else functions.setFocus(mandatoryArr[i]);
                    break;
                  } 
                }
            }
            if(!(type==="I" || type==="D" || type==="S")){
            showAlertConfirmNotifications({
              open: true,
              showConfirm: "showNotification",
              alertType: "error",
              autoHideDuration: 3000,
              alertContentKey: `FILL_MANDATORY_FIELDS`,
            });
        }
            return false;
        }
          formStateStore.dispatch(updateStateInRedux({name: "doclistRerenderCount", value: new Date()}));
          if(!formMataData){
            showAlertConfirmNotifications({
              open: true,
              showConfirm: "showNotification",
              alertType: "error",
              autoHideDuration: 5000,
              alertContentKey: `FILL_MANDATORY_FIELDS`,
            });
          }else{
            if(!mandatoryArr[0]?.includes("_")) {
                for(let i = 0; i < mandatoryArr.length; i++) {
                  if(!obj[mandatoryArr[i]]) {
                      if(type === "listviewSubform" || type === "buttonSubform")
                          functions.setFocus(mandatoryArr[i],formData);
                      else if(type === "wizardSubform")
                          functions.setFocus(mandatoryArr[i],{"children":formData});
                      else functions.setFocus(mandatoryArr[i]);
                      break;
                  } 
                }
            }
            if(!(type==="I" || type==="D" || type==="S")){
            showAlertConfirmNotifications({
                open: true,
                showConfirm: "showNotification",
                alertType: "error",
                autoHideDuration: 3000,
                alertContentKey: `FILL_MANDATORY_FIELDS`,
            });
        }
          }
          return false;
        } else {            
        if (mandatoryArr.length === 0) {
            setMandatoryControls1([]);
        }
            const errorState = getErrorState();
            if (mandatoryArr.length === 0) {
                setMandatoryControls1([]);
            }
            if(errorState?.length > 0)
                return false;
            if(window.checkErrorContainingControls){
                if(!isEmptyObject(window?.errorContainingControls) && window.checkErrorContainingControls()){
                    let err = ""
                    for (let key in window?.errorContainingControls) {
                        if (window?.errorContainingControls?.hasOwnProperty(key)) { // Use this to exclude inherited properties
                            functions.setFocus(key)
                            err = window?.errorContainingControls[key]
                            break;
                        }
                      }
                    showAlertConfirmNotifications({
                        open: true,
                        showConfirm: "showNotification",
                        alertType: "error",
                        autoHideDuration: 3000,
                        alertContentKey: err,
                      });
                      return false;
                }
                else{
                    return true;
                }
            }
            else{
                return true;
            }
        }
      
    } else {
      return true;
    }
  };

function insertAt(array, index, ...elements) {
    return array.splice(index, 0, ...elements);
}

export function getCurrentAdvanceListviewStateJsonFromStore(containerId)
{
    const state=formStateStore.getState();
    if(containerId===undefined){
        containerId=getContainerId()
    }
    return (state.data2.find(json => json.key === containerId))?.gridStates?.currentAdvanceListviewStateJson;
}

export function getSubFormListviewJsonFromStore(containerId)
{
    const state=formStateStore.getState();
    if(containerId===undefined){
        containerId=getContainerId()
    }
    return (state.data2.find(json => json.key === containerId))?.gridStates?.subFormListviewJson;
}

export function setDevicePreview(val) {
    const state=formStateStore.getState();
    const containerId=getContainerId()
    formStateStore.dispatch(updateStateInRedux({name: "devicePreview", value: val}));
}

export function getOpenCanvasForPreviewAdvanceSubform(containerId)
{
    const state=formStateStore.getState();
    if(containerId===undefined){
        containerId=getContainerId()
    }
    return (state.data.find(json => json.key === containerId))?.contexts?.openCanvasForPreviewAdvance;
}

export async function updateRowNColumnsId(jsonData) {
    if (Array.isArray(jsonData)) {
        jsonData.forEach((item, index) => {
            return updateRowNColumnsId(item);
        });
    } else {

        if (jsonData.elem_type === 'row') {
            jsonData = createUniqueId('row');
        } else if (jsonData === 'column') {
            jsonData = createUniqueId('column');
        }
        if (jsonData.children) {
            return updateRowNColumnsId(jsonData.children);
        } else if (jsonData.subform) {
            return updateRowNColumnsId(jsonData.subform);
        } else {
            return jsonData;
        }
    }
}

export function getContainerId(){
    let containerId;
 
    if(window.istaskOpen===true){
        containerId="ngform";
    }
    else {
        const state=formStateStore.getState();
        containerId=state.containerInfo.containerId;
    }
    return containerId;
}

export function getNonceValue(){
    let containerId = getContainerId() || "default";
    const state=formStateStore.getState();
    return state.data.find(json => json.key === containerId)?.noncevalue;
    
}

export function resetRedux(containerId,formState={},resetContainerId = false) {
    formStateStore.dispatch(reset({key: containerId,formState: formState, resetContainerId}));
}

export function getFormJsonFromStore(containerId)
{
    const state=formStateStore.getState();
    if(containerId===undefined){

        containerId = getContainerId();
    }
    return (state.data.find(json => json.key === containerId))?.contexts?.formState2;
}

export function getFormJsonMetaData(containerId)
{
    const state=formStateStore.getState();
    if(containerId===undefined){

        containerId = getContainerId();
    }
    return (state.data.find(json => json.key === containerId))?.contexts?.formJsonFromMataData;
}

export function getErrorState(containerId)
{
    const state=formStateStore.getState();
    if(containerId===undefined){

        containerId = getContainerId();
    }
    return (state.data.find(json => json.key === containerId))?.contexts?.errorState;
}

export function getChangeCanvasLayout(containerId)
{
    const state=formStateStore.getState();
    if(containerId===undefined){

        containerId = getContainerId();
    }
    return (state.data.find(json => json.key === containerId))?.contexts?.changeCanvasLayout;
}

export function gethandleEditor2FromRedux(containerId)
{
    const state=formStateStore.getState();
    if(containerId===undefined){
        containerId=getContainerId()
    }
    return (state.data.find(json => json.key === containerId))?.contexts?.handleEditor2;
}

export function getFormMataData(containerId)
{
    const state=formStateStore.getState();
    if(containerId===undefined){
        containerId=getContainerId()
    }
    return (state.data.find(json => json.key === containerId))?.contexts?.formMataData;
}

export function getDoclistRerenderCount(containerId)
{
    const state=formStateStore.getState();
    if(containerId===undefined){
        containerId=getContainerId()
    }
    return (state.data.find(json => json.key === containerId))?.contexts?.doclistRerenderCount;
}

export function getMandatoryControls(containerId)
{
    const state=formStateStore.getState();
    return state.mandatoryControls;
}

export function getCurrentDataObjectsContent(){
    const state = formStateStore.getState();
    return state?.dataObjectsContent;
}

export function setCurrentDataObjectsContent(dataObjectArr) {
    formStateStore.dispatch(updateStateInRedux({name: "dataObjectsContent", value: [...dataObjectArr]}));
}

export function getOpenCanvasForPreview(containerId)
{
    const state=formStateStore.getState();
    if(containerId===undefined){
        containerId=getContainerId()
    }
    return (state.data2.find(json => json.key === containerId))?.gridStates?.openCanvasForPreview;
}

export function getOpenCanvasForPreviewAdvance(containerId)
{
    const state=formStateStore.getState();
    if(containerId===undefined){
        containerId=getContainerId()
    }
    return (state.data2.find(json => json.key === containerId))?.gridStates?.openCanvasForPreviewAdvance;
}

export function getSelectedTableRow(containerId)
{
    const state=formStateStore.getState();
    if(containerId===undefined){
        containerId=getContainerId()
    }
    return (state.data2.find(json => json.key === containerId))?.gridStates?.selectedTableRow;
}

export function setMandatoryControls(mandatoryArr) {
    const state=formStateStore.getState();
    const containerId=getContainerId()
    formStateStore.dispatch(updateStateInRedux({name: "mandatoryControls1", value: [...mandatoryArr]}));
    formStateStore.dispatch(updateStateInRedux({name: "mandatoryControls", value: [...mandatoryArr]}));
}

export function setMandatoryControlsFromRedux(mandatoryArr) {
    const state=formStateStore.getState();
    const containerId=getContainerId()
    formStateStore.dispatch(updateStateInRedux({name: "mandatoryControls1", value: [...mandatoryArr]}));
    formStateStore.dispatch(updateStateInRedux({name: "mandatoryControls", value: [...mandatoryArr]}));
}

export function setMandatoryControls1(mandatoryArr) {
    const state=formStateStore.getState();
    const containerId=getContainerId()
    formStateStore.dispatch(updateStateInRedux({name: "mandatoryControls1", value: [...mandatoryArr]}));
    formStateStore.dispatch(updateStateInRedux({name: "mandatoryControls", value: [...mandatoryArr]}));
}

export function getOpenCanvasSubform(containerId)
{
    const state=formStateStore.getState();
    if(containerId===undefined){
        containerId=getContainerId()
    }
    return (state.data.find(json => json.key === containerId))?.contexts?.openCanvasForSubform;
}
export function getOpensubformCheck(containerId)
{
    const state=formStateStore.getState();
    if(containerId===undefined){
        containerId=getContainerId()
    }
    let checkSubformPresent = state.openSubformCheck
    return checkSubformPresent
}
export function getAdvanceListViewFormJsonFromStore(containerId)
{
    const state=formStateStore.getState();
    if(containerId===undefined){
        containerId=getContainerId()
    }
    return (state.data2.find(json => json.key === containerId))?.gridStates?.advanceListviewStateJson;
}

export function getSubFormStateJsonFromStore(containerId)
{
    const state=formStateStore.getState();
    if(containerId===undefined){
        containerId=getContainerId()
    }
    return (state.data.find(json => json.key === containerId))?.contexts?.subFormStateJson;
}

export function getSetActiveMenuId(containerId)
{
    const state=formStateStore.getState();
    if(containerId===undefined){
        containerId=getContainerId()
    }
    return (state.data.find(json => json.key === containerId))?.contexts?.setActiveMenuId;
}

export function getStepIndex(containerId){
    const state=formStateStore.getState();
    if(containerId===undefined){
        containerId=getContainerId()
    }
    return state.data.find(json => json.key === containerId)?.contexts?.wizard_type_step?.toString();
}

export function getActiveStepId(containerId){
    const state=formStateStore.getState();
    if(containerId===undefined){
        containerId=getContainerId()
    }
    return state.data.find(json => json.key === containerId)?.contexts?.activeStepId;
}

export function getActiveSubStepId(containerId){
    const state=formStateStore.getState();
    if(containerId===undefined){
        containerId=getContainerId()
    }
    return state.data.find(json => json.key === containerId)?.contexts?.activeSubStepId;
}

export function getGlobalContext(containerId){
    const state=formStateStore.getState();
    if(containerId===undefined){
        containerId=getContainerId()
    }
    const index = state.data.findIndex((json) => json.key === containerId);
    return state.data[index]?.contexts;
}

export function getSubStepIndex(containerId){
    const state=formStateStore.getState();
    if(containerId===undefined){
        containerId=getContainerId()
    }
    return state.data.find(json => json.key === containerId)?.contexts?.wizard_type_subStepIndex;
}

export function getApplicationId(containerId){
    const state=formStateStore.getState();
    if(containerId===undefined){
        containerId=getContainerId()
    }
    return state.data.find(json => json.key === containerId)?.contexts?.activeApplication.applicationId;
}

export function getSubChildMenuIndex(containerId){
    const state=formStateStore.getState();
    if(containerId===undefined){
        containerId=getContainerId()
    }
    return state.data.find(json => json.key === containerId)?.contexts?.wizard_type_subChildMenuIndex;
}

export function getFormId(containerId){
    const state=formStateStore.getState();
    if(containerId===undefined){
        containerId=getContainerId()
    }
    const microFrontendData = (state.data.find(json => json.key === containerId))?.contexts?.microFrontendData;
    const activePage = (state.data.find(json => json.key === containerId))?.contexts?.activePage;
    const activeSubForm = (state.data.find(json => json.key === containerId))?.contexts?.activeSubForm;
    return microFrontendData?.formDefId || activePage?.formId || activeSubForm?.fragmentId || microFrontendData?.formId || microFrontendData?.processDefId || microFrontendData?.templateId
}
export function updatedComponentInFormStates(containerId)
{
    const state=formStateStore.getState();
    if(containerId===undefined){
        containerId=getContainerId()
    }
    return (state.data.find(json => json.key === containerId))?.contexts?.updateJson;
}
export function getGdToken(containerId)
{
    const state=formStateStore.getState();
    const data=formStateStore.getState().data;
    if(containerId===undefined){
        containerId=getContainerId()
    }
    let gdtoken= state.data.find(json => json.key === containerId)?.gdtoken;

    if(!gdtoken){
        gdtoken = (state.data.find(json => json.gdtoken?.length > 0))?.gdtoken;
    }
    return gdtoken;
}

export function getStepName(containerId)
{
    const state=formStateStore.getState();
    if(containerId===undefined){
        containerId=getContainerId()
    }
    let activeStepName= state.data.find(json => json.key === containerId)?.contexts.activeStepName;
    return activeStepName;
}

export function getSubFormMetaData(containerId)
{
    const state=formStateStore.getState();
    if(containerId===undefined){
        containerId=getContainerId()
    }
    return state.data.find(json => json.key === containerId)?.contexts.subFormMetaData;
}

export function getPreviewMode(containerId)
{
    const state=formStateStore.getState();
    if(containerId===undefined){
        containerId=getContainerId()
    }
    const builderMode = state.data.find(json => json.key === containerId)?.contexts.builderMode;
    return builderMode !== "app" && builderMode !== "reusableFunction";
}

export function getSetLatestChangesSaved(containerId) {
    const state=formStateStore.getState();
    if(containerId===undefined){
        containerId=getContainerId()
    }
    return state.data.find(json => json.key === containerId)?.contexts.setLatestChangesSaved;
}

export function getSetFormstateChangedByUserNew(containerId) {
    const state=formStateStore.getState();
    if(containerId===undefined){
        containerId=getContainerId()
    }
    return state.data.find(json => json.key === containerId)?.contexts.setFormstateChangedByUserNew;
}

export function getSubStepName(containerId)
{
    const state=formStateStore.getState();
    if(containerId===undefined){
        containerId=getContainerId()
    }
    let activeSubStepName= state.data.find(json => json.key === containerId)?.contexts.activeSubStepName;
    return activeSubStepName;
}

export function getWIToken(containerId)
{
    const state=formStateStore.getState();
    const data=formStateStore.getState().data;

    if(containerId===undefined){
        containerId=getContainerId()
    }

    let witoken= state.data.find(json => json.key === containerId)?.witoken;

    if(!witoken){
        witoken = (state.data.find(json => json.witoken?.length > 0))?.witoken;
    }
    
    return witoken;
}

export function updateFormStateJson(formjson,containerId)
{
    const state=formStateStore.getState();
    const data=formStateStore.getState().data;
    if(containerId===undefined){
        containerId=getContainerId()
    }
    return (formStateStore.getState().data.find(json => json.key === containerId))?.updatedComponentInFormState;
    
}

export function nextTargetFinderInDataAdditionPopupForGridColumn(popupJson, targetElement){

    if(Array.isArray(popupJson)){
        popupJson.forEach((item,index)=>{
            
           if(item && (item["elem_type"]==='column' || item["elem_type"]==='row') && item["children"] &&
                item["children"].length == 0 && Object.keys(targetElement).length == 0){
                targetElement = item ;
                return targetElement ;
           }
            if(item && Object.keys(item).includes("children") && Object.keys(targetElement).length == 0){
                targetElement = nextTargetFinderInDataAdditionPopupForGridColumn(item["children"], targetElement)
            }
        })
    } 
    else{
         
        if(popupJson && (popupJson["elem_type"]==='column' || popupJson["elem_type"]==='row') && popupJson["children"] &&
            popupJson["children"].length == 0 && Object.keys(targetElement) == 0){
            targetElement = popupJson ;
            return targetElement ;
         }
          if(popupJson && Object.keys(popupJson).includes("children") && Object.keys(targetElement).length == 0){
            targetElement = nextTargetFinderInDataAdditionPopupForGridColumn(popupJson["children"], targetElement)
             
          }
       }
        
    return targetElement;
}

export const findDataObjectListView = (arr, itemId, nestingKey) => (
    arr.reduce((a, item) => {
      if (a) return a;
      if (item.treeName === itemId) return item;
      if (item[nestingKey]) return findDataObjectListView(item[nestingKey], itemId, nestingKey)
    }, null)
  );

export function updateRowNColumnIfExist(jsonObj) {
    if(checkVariableType(jsonObj)==='object'){
        if(jsonObj?.elem_type==='row'){
            if(checkControlIdExistance(jsonObj.id)){
                jsonObj.id = createUniqueId('row');
                jsonObj['children'] = updateRowNColumnIfExist(jsonObj?.children);
                return jsonObj;
            }
            else {
                addToAlreadyCreatedId(jsonObj.id);
            }
        } else if(jsonObj?.elem_type==='column'){
            if (checkControlIdExistance(jsonObj.id)) {
              jsonObj.id = createUniqueId("column");
              jsonObj["children"] = updateRowNColumnIfExist(jsonObj?.children);
              return jsonObj;
            }
            else {
                addToAlreadyCreatedId(jsonObj.id);
            }
        }
        if(jsonObj?.children){
            jsonObj['children'] = updateRowNColumnIfExist(jsonObj?.children);
            return jsonObj;
        } else {
            return jsonObj;
        }
    } else if(checkVariableType(jsonObj)==='array'){
        jsonObj.map((child) => {
            return updateRowNColumnIfExist(child);
        });
        return jsonObj;
    }
}

export function checkVariableType(varToCheck) {
    if (Array.isArray(varToCheck)) return 'array';
    else if (typeof varToCheck == 'string') return 'string';
    else if (varToCheck != null && typeof varToCheck == 'object') return 'object';
    else return 'other';
}

export function isChildrenPresent(json, find){
    const findKey=find?.toLowerCase();
    return json?.children?.findIndex(function(child){return child.elem_type.toLowerCase()=== findKey })!==-1
}

  var foundjson={};

export function findJson(formStatejson , activeId){
    
    if(formStatejson!==undefined && formStatejson!==null && activeId!=="" && activeId!==undefined && activeId!==null ){
        if(formStatejson.elem_type===activeId || formStatejson.id===activeId){
          foundjson = formStatejson;
        } 
        else {
            if(formStatejson.children!==undefined && formStatejson.children!==null){
                 formStatejson.children.map(child => {
                            if(child!==null && child!==undefined && child.id!==null && child.id!==undefined && child.elem_type!==null && child.elem_type!==undefined){
                                if(child.elem_type===activeId || child.id===activeId){
                                  foundjson =child;
                                }
                                else if( isObjectEmpty(foundjson) ) {
                                    findJson(child , activeId);
                                }
                        }
                    }
                );

            }
          }
        return foundjson;
    }
}

export function findIfRowIsEmpty(rowJSON, childrenfound =0 ){
    
    if(rowJSON!==undefined && rowJSON!==null ){
        if(rowJSON.elem_type==="row"){
            if(rowJSON.children!==undefined && rowJSON.children!==null){
                rowJSON.children.map(column => {
                            if(column!==null && column!==undefined && column.id!==null && column.id!==undefined && column.elem_type!==null && column.elem_type!==undefined){
                                if( column.elem_type==="column" ){
                                  if( column.children.length > 0){
                                    childrenfound++;
                                  }
                                }
                        }
                    }
                );

            }
          }
    }
    if(childrenfound === 0){
        return true;
    }
    else if(childrenfound > 1){
        return false;
    }
}

export const handleDisplayProperty = (props, device, setMobileDisplay, setTabDisplay, startMobile, endMobile, startTab, endTab) => {
    try {
        const tempCanWidth = getTempCanWidth()
        if (tempCanWidth) {
            const displayWidth = tempCanWidth

            if (
                props?.data?.style?.["MobileVisible"] === "false" &&
                ( (displayWidth <= endMobile && displayWidth >= startMobile) || device === "mobile")
            ) {
                setMobileDisplay(false);
            } else {
                setMobileDisplay(true);
            }

            if (
                props?.data?.style?.["TabsVisible"] === "false" &&
                ((displayWidth <= endTab && displayWidth >= startTab) || device === "tablet")
            ) {
                setTabDisplay(false);
            } else {
                setTabDisplay(true);
            }
        }
    } catch (error) {
        console.log("displayProperty Error: ", error);
    }
};

export function getReduxContexts(containerId)
{
    const state=formStateStore.getState();
    if(containerId===undefined){
        containerId=getContainerId()
    }
    return (state.data.find(json => json.key === containerId))?.contexts;
}

export function getGridStates(containerId)
{
    const state=formStateStore.getState();
    if(containerId===undefined){
        containerId=getContainerId()
    }
    return (state.data2.find(json => json.key === containerId))?.gridStates;
}

export function getTempCanWidth(containerId)
{
    const state=formStateStore.getState();
    return state?.tempCanWidth;
}


export async function encrypt_old_fn(message, count = 0)  {
    try {
    // defining key 
 
     var key = getEncKey_gcm();
 
 // defining init-vector for salting
 
     var ivf = getEncivf_gcm();
 
     var cipher = forge.cipher.createCipher('AES-GCM', key);
     cipher.start({ iv: ivf });
 
   cipher.update(forge.util.createBuffer(forge.util.encodeUtf8(message)));
   
     cipher.finish();
   
   console.log("cipher: ", cipher); 
   
     var tag = cipher.mode.tag.getBytes();   
   
   console.log("tag: " , window.btoa(tag) );
   
     var encryptedMessage = cipher.output.getBytes();
   
   console.log("encryptedMessage: " , window.btoa(encryptedMessage) );
   
     var result = window.btoa(encryptedMessage+tag);
   
   let result_replace = result.replaceAll("=","_");
   result_replace = result_replace.replaceAll("/","~");
   result_replace = result_replace.replaceAll("+","!");
 
    return result_replace;
    }
    catch{
       console.log("Error.");
    }
};


export function encryptSurvey_old_fn(value, key)  {
    // key here is "user_secret_key_"

    var rkEncryptionKey = CryptoJS.enc.Base64.parse(key );
    var rkEncryptionIv = CryptoJS.enc.Base64.parse("Interface_Viewer");

    if(value !== "" && value !== undefined) {

    const ciphertext = CryptoJS?.[window?.psh_configs?.encrypt_method]?.encrypt(value, rkEncryptionKey, {
                         iv: rkEncryptionIv
                        }).toString();

    return ciphertext
  }
};

export async function decryptMessage_old_fn(encryptedMessage) {
    try {
        // defining key 
        var key = getEncKey_gcm();

        // defining init-vector for salting

            var ivf = getEncivf_gcm();

            // Convert custom characters back to base64
            let result_replace = encryptedMessage.replaceAll("_", "=");
            result_replace = result_replace.replaceAll("~", "/");
            result_replace = result_replace.replaceAll("!", "+");

            // encryptedMessage = encryptedMessage.replaceAll("_", "=").replaceAll("~", "/").replaceAll("!", "+");

            // Decode base64
            const decodedMessage = forge.util.decode64(result_replace);

            // Split the message and tag
            const tagLength = 16; // Length of the tag in bytes
            const encryptedLength = decodedMessage.length - tagLength;
            const encryptedBytes = decodedMessage.slice(0, encryptedLength);
            const tagBytes = decodedMessage.slice(encryptedLength);

            // Create a decipher object
            const decipher = forge.cipher.createDecipher('AES-GCM', key);
            decipher.start({ iv: ivf, tag: tagBytes });

            // Update with the encrypted message
            decipher.update(forge.util.createBuffer(encryptedBytes));

            // Finish the decryption
            const success = decipher.finish();

            if (!success) {
            throw new Error('Decryption failed');
            }
        
            // Get the decrypted message as Utf8
            const decryptedMessage = decipher.output.toString('utf8');
            return decryptedMessage;
    } 
    catch {
        console.log("Error.");
    }
}


export const encrypt = async (message, count=0) => {

    if(message && typeof message === "string"){
        message = message.trim();
    }

    var result_replace="";
    if(message === ""){
        return result_replace
    }
    // if (message instanceof Promise) {
    //        return await encrypt(message);
    // }
    if (message && message instanceof Promise && count===0) {
        // return await encrypt(encryptedMessage);
        message.then((messagge)=>{
            return encrypt(messagge, count=1);
        })
    }
    
    try {
        // defining key and iv
        const key = getEncKey_gcm();
        const ivf = getEncivf_gcm();

        // Normalize to Uint8Array
        const toU8 = (input) => {
            if (input instanceof Uint8Array) return input;
            if (input instanceof ArrayBuffer) return new Uint8Array(input);
            if (typeof input === 'string') {
                const arr = new Uint8Array(input.length);
                for (let i = 0; i < input.length; i++) arr[i] = input.charCodeAt(i) & 0xff;
                return arr;
            }
            return new Uint8Array(0);
        };

        if (window.crypto?.subtle) {
            const cryptoKey = await window.crypto.subtle.importKey(
                'raw',
                toU8(key),
                { name: 'AES-GCM' },
                false,
                ['encrypt']
            );

            const plainBytes = new TextEncoder().encode(message);
            const cipherBuffer = await window.crypto.subtle.encrypt(
                { name: 'AES-GCM', iv: toU8(ivf) },
                cryptoKey,
                plainBytes
            );

            // Convert to Base64
            const bytes = new Uint8Array(cipherBuffer);
            let bin = '';
            for (let i = 0; i < bytes.length; i++) bin += String.fromCharCode(bytes[i]);
            const b64 = window.btoa(bin);

            let result_replace_local = b64.replaceAll("=","_").replaceAll("/","~").replaceAll("+","!");

            if( window?.psh_configs?.encrypt_method && ( !result_replace_local || result_replace_local==="" || isEmptyObject(result_replace_local) ) ){
                result_replace_local = await encrypt_old_fn( message, window?.psh_configs?.old_form_func);
            }

            return result_replace_local;
        }

        // Fallback if WebCrypto unavailable
        const fallback = await encrypt_old_fn( message, window?.psh_configs?.old_form_func);
        return fallback;
    }
    catch{
        const result_replace_fallback = await encrypt_old_fn( message, window?.psh_configs?.old_form_func);
        return result_replace_fallback;
    }
 };
 
 export const decryptMessage = async (encryptedMessage, callback_fn_updatestr , eventkeyname, count =0) => {

    if (encryptedMessage && encryptedMessage instanceof Promise && count===0) {
        // return await encrypt(encryptedMessage);
        const returnValue = encryptedMessage.then((messagge)=>{
            return decryptMessage(messagge, callback_fn_updatestr , eventkeyname , count=1);
        })

        return returnValue;
    }
    
    else if(encryptedMessage){

        try{
            // defining key and iv
            const key = getEncKey_gcm();
            const ivf = getEncivf_gcm();

            // Convert custom characters back to base64
            let result_replace = encryptedMessage.replaceAll("_", "=");
            result_replace = result_replace.replaceAll("~", "/");
            result_replace = result_replace.replaceAll("!", "+");

            // Base64 decode into Uint8Array
            const decodedBytes = (function base64ToUint8Array(b64){
                const bin = window.atob(b64);
                const len = bin.length;
                const out = new Uint8Array(len);
                for (let i = 0; i < len; i++) out[i] = bin.charCodeAt(i) & 0xff;
                return out;
            })(result_replace);

            // Normalize key/iv into Uint8Array (treat strings as binary bytes)
            const toU8 = (input) => {
                if (input instanceof Uint8Array) return input;
                if (input instanceof ArrayBuffer) return new Uint8Array(input);
                if (typeof input === 'string') {
                    const arr = new Uint8Array(input.length);
                    for (let i = 0; i < input.length; i++) arr[i] = input.charCodeAt(i) & 0xff;
                    return arr;
                }
                // Fallback empty
                return new Uint8Array(0);
            };

            if (window.crypto?.subtle) {
                const cryptoKey = await window.crypto.subtle.importKey(
                    'raw',
                    toU8(key),
                    { name: 'AES-GCM' },
                    false,
                    ['decrypt']
                );

                const plainBuffer = await window.crypto.subtle.decrypt(
                    { name: 'AES-GCM', iv: toU8(ivf) },
                    cryptoKey,
                    decodedBytes
                );

                const decryptedMessage = new TextDecoder().decode(new Uint8Array(plainBuffer));

                if( window?.psh_configs?.encrypt_method && ( !decryptedMessage || decryptedMessage==="" || isEmptyObject(decryptedMessage) ) ){
                    const legacy = await decryptMessage_old_fn(encryptedMessage);
                    if(callback_fn_updatestr && legacy){
                        callback_fn_updatestr( legacy, eventkeyname);
                    }
                    return legacy;
                }

                if(callback_fn_updatestr && decryptedMessage){
                    callback_fn_updatestr( decryptedMessage, eventkeyname);
                }
                return decryptedMessage;
            }

            // If WebCrypto not available, fallback to legacy
            const legacy = await decryptMessage_old_fn(encryptedMessage);
            if(callback_fn_updatestr && legacy){
                callback_fn_updatestr( legacy, eventkeyname);
            }
            return legacy;
        }
        catch{
            const decryptedMessage = await decryptMessage_old_fn(encryptedMessage);
            if(callback_fn_updatestr && decryptedMessage){
                callback_fn_updatestr( decryptedMessage, eventkeyname);
            }
            return decryptedMessage;
        }
     }
 };
 
 export const encryptforge_aes_gcm = async (message ,key ,ivf) => {
     try{
        const toU8 = (input) => {
            if (input instanceof Uint8Array) return input;
            if (input instanceof ArrayBuffer) return new Uint8Array(input);
            if (typeof input === 'string') {
                const arr = new Uint8Array(input.length);
                for (let i = 0; i < input.length; i++) arr[i] = input.charCodeAt(i) & 0xff;
                return arr;
            }
            return new Uint8Array(0);
        };

        if (window.crypto?.subtle) {
            const cryptoKey = await window.crypto.subtle.importKey(
                'raw',
                toU8(key),
                { name: 'AES-GCM' },
                false,
                ['encrypt']
            );

            const plainBytes = new TextEncoder().encode(message);
            const cipherBuffer = await window.crypto.subtle.encrypt(
                { name: 'AES-GCM', iv: toU8(ivf) },
                cryptoKey,
                plainBytes
            );

            const bytes = new Uint8Array(cipherBuffer);
            let bin = '';
            for (let i = 0; i < bytes.length; i++) bin += String.fromCharCode(bytes[i]);
            const b64 = window.btoa(bin);

            let result_replace = b64.replaceAll("=","_").replaceAll("/","~").replaceAll("+","!");
            return result_replace;
        }
        // Fallback to legacy encrypt if WebCrypto not available
        return await encrypt_old_fn( message, window?.psh_configs?.old_form_func);
     }
     catch{
        return await encrypt_old_fn( message, window?.psh_configs?.old_form_func);
     }
 };
export const fetchGridStates = () => {
    const state=formStateStore.getState();
    const containerId=getContainerId()
    const {
      // listViewAddRecordFrom,
      // currentAdvanceListviewJSON,
      advanceListviewStateJson,
      currentAdvanceListviewStateJson,
      // openCanvasForPreview,
      // openCanvasForPreviewAdvance,
      subFormListviewJson,
      // listviewClearState,
      // selectedRowIndex,
      // advSaveAndContinue,
      globalError,
      spareAdvListviewPopupStyle,
      spareListviewPopupStyle,
      spareAdvanceListviewStateJson,
      // selectedRowIndexAdvance
    } = getGridStates(containerId);

    return {
      advanceListviewStateJson,
      currentAdvanceListviewStateJson,
      subFormListviewJson,
      globalError,
      spareAdvListviewPopupStyle,
      spareListviewPopupStyle,
      spareAdvanceListviewStateJson
    };
  }

export function handleDataAdditionNew(eventName, selectedControl, dataObjectsContent) {
    const state=formStateStore.getState();
    const containerId=getContainerId()

    if (selectedControl.listviewFrameLayoutJson) {
      const colLayout = selectedControl.listviewFrameLayoutJson.children[0]?.children[0]?.ColumnLayout || "4";
      const frameLVId = `${selectedControl?.style?.CustomId || selectedControl?.dataclass || selectedControl?.id}_frameLV`
        .replace(/ (?=[^a-zA-Z_-])/g, '_')
        .replace(/^(?=[^a-zA-Z_-])/, '_');
      let listviewJson = {
        children: [
          {
            children: [
              {
                frameIndex: "0",
                elem_type: "frame",
                isInsideListview: true,
                id: frameLVId,
                ColumnLayout: colLayout,
                children: [],
                style: {
                  ...selectedControl?.listviewFrameLayoutJson?.children[0]?.children[0]?.style,
                  RemoveHeader: "true",
                  isListview: "true",
                  Visible: "true"
                }
              }
            ],
            id: "RootControl",
            elem_type: "form",
            isListview: true
          }
        ],
        ControlType: "form",
        id: "FormDef",
        elem_type: "form",
        isListview: true,
        overlayStyle: {}
      };

      let controlElemToAdd = listviewJson.children[0].children[0];
      if(selectedControl.listviewFrameLayoutJson.children[0]?.children[0]?.event && selectedControl.listviewFrameLayoutJson.children[0]?.children[0]?.eventsInArray){
        controlElemToAdd["event"] = selectedControl.listviewFrameLayoutJson.children[0]?.children[0]?.event
        controlElemToAdd["eventsInArray"] = selectedControl.listviewFrameLayoutJson.children[0]?.children[0]?.eventsInArray
      }
      let columnCount = selectedControl.columnList.length;
      let rowCount = Math.ceil(columnCount / parseInt(controlElemToAdd.ColumnLayout));
      let colCount = 0;

      let rowElement = {};
      rowElement.id = createUniqueId("row");
      rowElement.elem_type = "row";
      rowElement.isInsideListview = true;
      rowElement.frameIndex = controlElemToAdd.frameIndex;
      rowElement.children = [];
      rowElement.parent_id = controlElemToAdd.id;

      let noOfCols = parseInt(controlElemToAdd.ColumnLayout);
        for (let c = 0; c < parseInt(columnCount); c++) {
          const controlId = `${selectedControl.id}_${selectedControl.columnList[colCount]?.style?.ColumnName}`;
          let currentControlJson = recursiveJsonReader1(selectedControl.listviewFrameLayoutJson, controlId);
          
          let col = {
            elem_type: "column",
            isInsideListview: true,
            style: { heightselect: "set" },
            sequenceIndex: currentControlJson?.sequenceIndex ?? colCount
          };
          const w = 12 / parseInt(noOfCols);

          let controlJson = {};

          if (selectedControl.columnList[colCount]?.elementJson) {
            const addAndDeleteKey = (controlKey, columnKey) => {
                if(selectedControl?.columnList?.[colCount]?.style?.[columnKey] && !controlJson.style[controlKey]) {
                    controlJson.style[controlKey] = selectedControl.columnList[colCount].style[columnKey];
                }
                if(selectedControl?.columnList?.[colCount]?.style?.[columnKey]) {
                    delete selectedControl.columnList[colCount].style[columnKey];
                }
            }

            // const controlId = `${selectedControl.id}_${selectedControl.columnList[colCount]?.style?.ColumnName}`;

            // var currentControlJson = recursiveJsonReader1(selectedControl.listviewFrameLayoutJson, controlId);
            if (currentControlJson) {
              const tempControlJson = cloneDeep(currentControlJson);
              controlJson = { ...tempControlJson, ...selectedControl.columnList[colCount]?.elementJson };

                if(controlJson?.elem_type === "radio" || controlJson?.elem_type === "combo") {
                    const defaultOption =
                        controlJson?.elem_type === "radio"
                            ? [{ label: "Option1", value: "Option1", tooltip: "", FE_id: "1" }]
                            : [{ label: "Select", value: "", FE_id: "1" }];

                    const colOptions = selectedControl?.columnList?.[colCount]?.style?.options?.length
                        ? selectedControl?.columnList?.[colCount]?.style?.options
                        : tempControlJson?.options?.length ? tempControlJson?.options : defaultOption;

                    if (colOptions.length > 1 || (colOptions.length === 1 && colOptions[0]?.value !== "Select")) {
                        controlJson["options"] = [...colOptions];
                    } else {
                        controlJson["options"] = [...(tempControlJson?.options || [])];
                    }
                    if(selectedControl?.columnList?.[colCount]?.style?.options) {
                        delete selectedControl.columnList[colCount].style.options;
                    }
                }

              controlJson.style = tempControlJson.style;
            } else {
              controlJson = cloneDeep(selectedControl.columnList[colCount]?.elementJson);
            }

            const frameColArray = selectedControl?.listviewFrameLayoutJson?.children[0]?.children[0]?.children[0]?.children;
            const columnJson = frameColArray?.find(obj => obj?.children[0]?.style?.ColumnName === controlJson?.style?.ColumnName)

            if (columnJson) {
              col.id = columnJson.id;
              col.w = columnJson.w || 4;
              col.md = columnJson.md || w;
              col.sm = columnJson.sm || 6;
              col.xs = columnJson.xs || 12;
            } else {
              col.id = createUniqueId("column");
              col.w = 4;
              col.md = w;
              col.sm = 6;
              col.xs = 12;
            }

            controlJson.id = controlId;
            controlJson.jsonColumnId = col.id;
            controlJson.isInsideListview = true;
            controlJson.listviewId = selectedControl.id;
            controlJson.sequenceIndex = currentControlJson?.sequenceIndex ?? colCount;
            if(!controlJson.marvin) {
                controlJson.marvin = "false";
            }

            //check if the column have associatedFields value
            if (selectedControl.columnList[colCount]?.style?.complexFieldName) {
              if (Object.keys(dataObjectsContent).length > 0) {
                const foundObj = findDataObjectListView(
                  dataObjectsContent,
                  `${selectedControl?.dataclass}.${selectedControl.columnList[colCount].style.complexFieldName}`,
                  "children"
                );
                if (foundObj) {
                  controlJson.datamapVariableType = foundObj?.VariableType;
                  controlJson.datamapPercision = foundObj?.VarPrecision;
                  controlJson.datamapVariableLength = foundObj?.VariableLength;
                }
              }
            }
            if(selectedControl?.dataclass && selectedControl?.columnList?.[colCount]?.style?.complexFieldName)
                controlJson.dataclass = `${selectedControl?.dataclass}.${selectedControl?.columnList?.[colCount]?.style?.complexFieldName}`;
            const DBQuery = controlJson.style.DBQuery;
            const Mandatory = controlJson.style.Mandatory;
            if(controlJson?.style?.DateFormat && selectedControl?.columnList?.[colCount]?.style?.DateFormat){
                selectedControl.columnList[colCount].style.DateFormat = controlJson?.style?.DateFormat
            }
            if(controlJson?.style?.DBQuery && !selectedControl?.columnList?.[colCount]?.style?.DBQuery){
                selectedControl.columnList[colCount].style.DBQuery = controlJson?.style?.DBQuery
                selectedControl.columnList[colCount].style.addOptionsMethod = controlJson?.style?.addOptionsMethod
            }
            controlJson.style = {
              ...ThemeJSON[controlJson.elem_type],
              ...selectedControl.columnList[colCount].elementJson.style,
              ...selectedControl.columnList[colCount].style,
              ...controlJson.style,
              ColumnName: selectedControl.columnList[colCount]?.style?.ColumnName,
              MaskingValue: selectedControl.columnList[colCount]?.style?.ColumnMasking,
            //   DBQuery, 
              Mandatory,
            //   addOptionsMethod: selectedControl?.columnList[colCount]?.style?.addOptionsMethod
            };
            if(selectedControl?.style?.additionmethods === "Section above Listview" || selectedControl?.style?.additionmethods === "Section below Listview"){
                controlJson.isAboveListview = true
            }
            else{
                controlJson.isAboveListview = false;
            }

            addAndDeleteKey("DBQuery", "DBQuery");
            addAndDeleteKey("addOptionsMethod", "addOptionsMethod");
            
            if (controlJson.style?.ColumnType === "textbox" || controlJson.style?.ColumnType === "textarea") {
                addAndDeleteKey("Alphabets", "AllowAlphabets");
                addAndDeleteKey("CharacterSet", "columnCharacterSet");
                addAndDeleteKey("Numerals", "AllowNumbers");
                addAndDeleteKey("Spaces", "AllowSpaces");
                addAndDeleteKey("SpecialCharacter", "AllowSpecialCharsContent");
            }
            // if (controlJson.style?.ColumnType === "textbox" || controlJson.style?.ColumnType === "textarea") {
            //     controlJson.style.Alphabets = controlJson.style?.AllowAlphabets;
            //     controlJson.style.CharacterSet = controlJson.style?.columnCharacterSet;
            //     controlJson.style.Numerals = controlJson.style?.AllowNumbers;
            //     controlJson.style.Spaces = controlJson.style?.AllowSpaces;
            //     controlJson.style.SpecialCharacter = controlJson.style?.AllowSpecialCharsContent;
            //   }
              if (controlJson.style?.ColumnType === "datetimepick") {
                controlJson.style.PickerType = "2";
              }
              controlJson.style.Label = controlJson.style.Label || controlJson.style?.ColumnName;
            //   controlJson.style.MaskingValue = controlJson.style?.ColumnMasking;
            //   controlJson.style.SpecialCharacter = controlJson.style?.AllowSpecialCharsContent;
              controlJson.style.Enable =
                controlJson.style.previousEnable || controlJson.style.previousEnable === false
                    ? controlJson.style.previousEnable
                    : selectedControl.style.Enable;
                controlJson.style.ReadOnly =
                controlJson.style.ReadOnly || controlJson.style.ReadOnly === false
                    ? controlJson.style.ReadOnly
                    : selectedControl.style.ReadOnly || "false";
                controlJson.style.ReadOnlyStyle =
                controlJson.style.ReadOnlyStyle || controlJson.style.ReadOnlyStyle === false
                    ? controlJson.style.ReadOnlyStyle
                    : selectedControl.style.ReadOnlyStyle;

            if (controlJson?.style?.ColumnType === "label") {
              controlJson.style.Label =
                controlJson?.style?.LabelOfColumnTypeLabel || controlJson.style.Label || controlJson.style?.ColumnName;
            }
            if (controlJson?.style?.ColumnType === "link") {
              controlJson.style.Label =
                controlJson?.style?.LabelOfColumnTypeLabel || controlJson.style.Label || controlJson.style?.ColumnName;
              controlJson.style.OnClick = controlJson?.style?.MethodName1 ? "Code" : "URL";
              controlJson.style.MethodName = controlJson?.style?.MethodName1;
              controlJson.style.LinkURL = controlJson?.style?.ListviewLinkURL;
            }
          }

          col.children = [controlJson];
          col.frameIndex = controlElemToAdd.frameIndex;
          col.isInsideListview = true;
          if (selectedControl.columnList[colCount]?.elementJson) {
            rowElement.children.push(col);
          }
          colCount++;
        }

        // Sort columns by sequenceIndex before adding the row so visual/render order respects swaps
        if (rowElement?.children?.length) {
            rowElement.children.sort((a, b) => {
                const aSeq = typeof a.sequenceIndex === 'number' ? a.sequenceIndex : 0;
                const bSeq = typeof b.sequenceIndex === 'number' ? b.sequenceIndex : 0;
                return aSeq - bSeq;
            });
        }
        controlElemToAdd.children.push(rowElement);
        selectedControl.listviewFrameLayoutJson = cloneDeep(listviewJson);
        normalizeSequenceIndices(selectedControl);
  
      const updateJson = state.data.find(json => json.key === containerId)?.contexts?.updateJson;
      if(updateJson.updatedComponentInFormState) {
        updateJson.updatedComponentInFormState(selectedControl.id, selectedControl);
      }
    }
    
    if (eventName) {
        const applyChanges = state.data.find(json => json.key === containerId)?.contexts?.applyChanges;
        const setCurrentListviewForSubform = state.data.find(json => json.key === containerId)?.contexts?.setCurrentListviewForSubform;
        const setSubformStack = state.data.find(json => json.key === containerId)?.contexts?.setSubformStack;

        if(selectedControl?.popupStyle) {
            selectedControl.popupStyle = { ...ThemeJSON.advancelistviewPopup, ...selectedControl.popupStyle};
        } else {
            selectedControl["popupStyle"] = { ...ThemeJSON.advancelistviewPopup }
            selectedControl["popupStyle"]["AdvlistviewTitle"] = selectedControl.style.Label
        }

        if(selectedControl?.["popupStyle"]?.["AllowDuplicatingRow"] === undefined) {
            selectedControl["popupStyle"]["AllowDuplicatingRow"] = "true";
        }
        if(selectedControl?.["popupStyle"]?.["ShowOverlayBatchsButtons"] === undefined) {
            selectedControl["popupStyle"]["ShowOverlayBatchsButtons"] = "true";
        }

        applyChanges(selectedControl.listviewFrameLayoutJson, "showDataAdditonSection");
        setCurrentListviewForSubform(selectedControl);
        setSubformStack((prev) => [...prev, "showDataAdditonSection"]);

        formStateStore.dispatch(
            updateGridContexts({
                name: "spareAdvListviewPopupStyle",
                key: containerId,
                value: cloneDeep(selectedControl.popupStyle)
            })
        );

        window.selectedControlId_function(selectedControl);
    }
  }

export const normalizeSequenceIndices = (selectedControl) => {
  if (!selectedControl?.listviewFrameLayoutJson) {
    return false;
  }

  // Simple approach: just renumber controls 0, 1, 2...
  let index = 0;
  const updateSequence = (json) => {
    if (Array.isArray(json)) {
      json.forEach((item) => updateSequence(item));
    } else if (json && typeof json === "object") {
      if (json.elem_type === "row" && json.children) {
        json.children.forEach((column) => {
          if (column.children && column.children[0] && column.children[0].style?.ColumnName) {
            column.children[0].sequenceIndex = index;
            column.sequenceIndex = index;
            index++;
          }
        });
      }
      if (json.children) {
        updateSequence(json.children);
      }
    }
  };

  updateSequence(selectedControl.listviewFrameLayoutJson);
  return true;
};

export const swapControlsInListview = (
  selectedControl,
  fromSequenceIndex,
  toSequenceIndex,
  setOldControl,
  extraProps = {}
) => {
  const { isWithin, position } = extraProps; // position can be "after" or "before"
  const state = formStateStore.getState();
  const containerId = getContainerId();
  setOldControl({});

  if (!selectedControl.listviewFrameLayoutJson) {
    console.warn("Selected control does not have listview data");
    return false;
  }

  // Simple validation: just check if indices are valid numbers
  if (fromSequenceIndex < 0 || toSequenceIndex < 0 || fromSequenceIndex === toSequenceIndex) {
    return false;
  }

  // Helper to move an item in array
  function moveItem(array, fromIndex, toIndex) {
    if (fromIndex === toIndex) return;
    const item = array.splice(fromIndex, 1)[0];
    array.splice(toIndex, 0, item);
  }

  // Find and swap/move controls in the listviewFrameLayoutJson structure
  const processControlsInJson = (json) => {
    if (Array.isArray(json)) {
      json.forEach((item) => processControlsInJson(item));
    } else if (json && typeof json === "object") {
      if (json.children && Array.isArray(json.children)) {
        if (json.elem_type === "row") {
          if (!isWithin) {
            // Default swap logic
            const columnsToSwap = [];
            json.children.forEach((column, index) => {
              if (column && (column.sequenceIndex === fromSequenceIndex || column.sequenceIndex === toSequenceIndex)) {
                columnsToSwap.push({ column, index });
              }
            });
            if (columnsToSwap.length === 2) {
              const [first, second] = columnsToSwap;
              // Swap the actual column objects
              const tempColumn = json.children[first.index];
              json.children[first.index] = json.children[second.index];
              json.children[second.index] = tempColumn;
              // Update the sequence indices
              json.children[first.index].children[0].sequenceIndex =
                fromSequenceIndex > toSequenceIndex ? toSequenceIndex : fromSequenceIndex;
              json.children[second.index].children[0].sequenceIndex =
                toSequenceIndex > fromSequenceIndex ? toSequenceIndex : fromSequenceIndex;
              json.children[first.index].sequenceIndex =
                fromSequenceIndex > toSequenceIndex ? toSequenceIndex : fromSequenceIndex;
              json.children[second.index].sequenceIndex =
                toSequenceIndex > fromSequenceIndex ? toSequenceIndex : fromSequenceIndex;
            }
          } else {
            // isWithin: move picked column before/after target column
            // Find indices
            const fromIdx = json.children.findIndex((col) => col.sequenceIndex === fromSequenceIndex);
            const toIdx = json.children.findIndex((col) => col.sequenceIndex === toSequenceIndex);
            if (fromIdx === -1 || toIdx === -1) return;
            let insertIdx = toIdx;
            if (position === "after") {
              insertIdx = toIdx + (fromIdx < toIdx ? 0 : 1);
            } else if (position === "before") {
              insertIdx = toIdx + (fromIdx < toIdx ? -1 : 0);
            }
            moveItem(json.children, fromIdx, insertIdx);
            // Reassign sequenceIndex for all columns and their children[0]
            json.children.forEach((col, idx) => {
              col.sequenceIndex = idx;
              if (col.children && col.children[0]) {
                col.children[0].sequenceIndex = idx;
              }
            });
          }
        }
        processControlsInJson(json.children);
      }
    }
  };

  // Perform the swap or move
  processControlsInJson(selectedControl.listviewFrameLayoutJson);

  // Update form state
  const updateJson = state.data.find((json) => json.key === containerId)?.contexts?.updateJson;
  if (updateJson?.updatedComponentInFormState) {
    updateJson.updatedComponentInFormState(selectedControl.id, selectedControl);
  }

  return true;
};

  export const updateColumnMandatory = (columnName = "", value) => {
    const state = formStateStore.getState();
    const containerId=getContainerId()
    const currentListviewForSubform = state.data.find(json => json.key === containerId)?.contexts?.currentListviewForSubform;

  if(currentListviewForSubform?.columnList?.length) {
      for (let i = 0; i < currentListviewForSubform.columnList.length; i++) {
          const item = currentListviewForSubform.columnList[i];
          if(item.style.ColumnName === columnName) {
              item.style.mandatory = value === "true" ? "Y" : "N";
                updatePartialJSON(currentListviewForSubform?.id, currentListviewForSubform)
              break;
          }
      }
  }
}

export const setListviewStateOnValueChange = (data, eventCB) => {
    const { listviewColumnInfo } = getReduxContexts();
    const { openCanvasForPreview } = getGridStates();
    if (
      data?.calledFromAPI &&
      (openCanvasForPreview === "showDataAdditonSection" || data?.isAboveListview) &&
      data?.style?.hasOwnProperty("ColumnName") && data?.value !== undefined && data?.value !== null
    ) {
      const state = formStateStore.getState();
      const containerId = state?.containerInfo?.containerId;

      formStateStore.dispatch(updateGridContexts({ key: containerId, name: "listviewClearState", value: false }));
  
      const tableId = data?.id?.split("_")?.[0];
      let currentListviewColumnInfo = listviewColumnInfo.get(tableId);
      if (!currentListviewColumnInfo) {
        listviewColumnInfo.set(tableId, new Map());
        currentListviewColumnInfo = listviewColumnInfo.get(tableId);
      }
  
      currentListviewColumnInfo.set(data.style.ColumnName, data.value);
    //   formStateStore.dispatch(setMap(tableId, { [data.style.ColumnName]: data.value }));
      // eventCB();
  
      // resetting key to false
      data.calledFromAPI = false;
      updatePartialJSON(data?.id, data, false);
    }
  };

  export const parentFrameMappedId = (formState2, selectedControl, frameIndex) => {
    const getControlIDWithDataClass = selectedControl?.dataclass && document.querySelector(`[control_id="${selectedControl?.dataclass}_group"][frameIndex="${frameIndex}"]`)
    const getControlIDWithId = selectedControl?.id && document.querySelector(`[control_id="${selectedControl?.dataclass}_group"][frameIndex="${frameIndex}"]`)
    const getControlWithID = document.getElementById(selectedControl?.dataclass) || document.getElementById(`${selectedControl?.dataclass}_group`) || document.getElementById(selectedControl?.id) || document.getElementById(`${selectedControl?.id}_group`) || document.getElementById(selectedControl?.style?.CustomId) || document.getElementById(`${selectedControl?.style?.CustomId}_group`)
    const getControlWithselectedControl = (selectedControl && typeof selectedControl === "string") && document.querySelector(`[control_id="${selectedControl}_group"][frameIndex="${frameIndex}"]`)
    const currentControl = getControlIDWithDataClass || getControlIDWithId || getControlWithID || getControlWithselectedControl || null;
    const closestFrame = currentControl?.closest('[id*="frame"]');
    const parentFrameId = closestFrame?.id;
    const parentFrameIds = parentFrameId?.split("_")[0].includes("frame") ? parentFrameId?.split("_")[0] : parentFrameId?.split("_")[1]
    const parentFrameBuffer = recursiveJsonReader1(formState2, parentFrameIds)

    return parentFrameBuffer
}

export const updateRenderState = (id,callingFromFormLoad = false) => {
    if(!id || id === "undefined") return
    // const formBuffer = getFormJsonFromStore();
    // const controlJson = functions.readJson1(id);
    // let flag = false;
    // if(controlJson){
    //     const elemType = controlJson.elem_type;
    //     const controlId = controlJson.id;
    //     if(elemType === 'doclist') {
    //         if(document.getElementById(`${controlId}_parent`))
    //             flag = true;
    //     }
    //     else if(elemType === 'toggle') {
    //         if(document.getElementById(`${controlJson?.id}span`))
    //             flag = true;
    //     }
    //     else if(callingFromFormLoad){
    //             flag=true;
    //     }
    //     else {
    //         if(document.getElementById(controlJson?.style?.CustomId) || document.getElementById(`${controlJson?.style?.CustomId}_group`) || 
    //             document.getElementById(controlJson?.dataclass) || document.getElementById(`${controlJson?.dataclass}_group`) || document.getElementById(controlId) || document.getElementById(`${controlId}_group`))
    //             flag = true;
    //     }
    // } else flag = true;


    // if(flag)
        formStateStore.dispatch(updateRenderElement({ id: id, value: new Date() }));
};

export const loadArabicImage = (imageBaseURL) => {
    const isArabic = (window?.psh_configs?.selectedLanguage === "ar" || localStorage?.getItem("i18nextLng") === "ar")
    const arabicApplied = imageBaseURL && isArabic
    return `${ arabicApplied ? `?lang=${(window?.psh_configs?.selectedLanguage || localStorage?.getItem("i18nextLng"))}` : ""}`
}

export const isControlDroppedUnderTabColumn = (controlId) => {
    if( document.querySelector(`#${controlId}`)?.closest(`[elem_type=tab]`) ){
      return true
    }
    else if( !document.querySelector(`#${controlId}`)?.closest(`[elem_type=tab]`) ){
      return false
    }
    else{
      return true
    }
  }

export const businessFunctionDataObjects = (SerialId) => {
    axios.get(`customRestApi/getListOfDataObjects/${SerialId}/`, {withCredentials: true})
    .then((resp) => {
        console.log("resp", resp)
        const listOfDataObjects = resp?.data?.ListOfdataObjects?.replace(/[\[\]]/g, '').split(',').map(item => item.trim())
        if(listOfDataObjects){
            formStateStore.dispatch(updateStateInRedux({name: "listOfDataObjects", value: [...listOfDataObjects]}));
            formStateStore.dispatch(updateStateInRedux({name: "bfProcessName", value: ''}))
        } 
        if(resp?.data?.ProcessName){
            formStateStore.dispatch(updateStateInRedux({name: "listOfDataObjects", value: []}));
            formStateStore.dispatch(updateStateInRedux({name: "bfProcessName", value: resp?.data?.ProcessName}))
        }
        formStateStore.dispatch(updateStateInRedux({name: "isBFChanged", value: true}))
    })
    .catch((err) => {
        console.log("err", err)
        return err
    })
}

export const wizardThemeUpdate = (formBuffer,formState2) => {
    const formStateOriginal=cloneDeep(formState2)
    let updatedTheme = {
      ...formBuffer?.theme,
      WizardStyle: formStateOriginal?.theme?.WizardStyle,
      CustomStyle: formBuffer?.theme?.CustomStyle + formStateOriginal?.theme?.CustomStyle
    };
    formState2.theme = updatedTheme;
    formStateStore.dispatch(updateFormStateContextWithoutRender(formState2));                     
                            
}

export const updateColLayout = (json, columnLayout, view) => { 
        for(let i = 0; i < json?.length; i++) {
            if(json[i]?.elem_type === "column") {
                if (view === "web") {
                    json[i].md = json[i]?.w;
                }
                if (view === "tablet") {
                    json[i].md = json[i]?.sm;
                }
                if (view === "mobile") {
                    json[i].md = json[i]?.xs;
                }
            }
            if(json[i]?.children?.length > 0) {
                updateColLayout(json[i]?.children, columnLayout, view);
            } else if((json[i]?.elem_type === "advancelistView" || json[i]?.elem_type === "listView") && json[i]?.listviewFrameLayoutJson) {
                updateColLayout(json[i]?.listviewFrameLayoutJson, columnLayout, view);
            } else if(json[i]?.elem_type === "button" && json[i]?.subform) {
                updateColLayout(json[i]?.subform, columnLayout, view);
            }
        }
    }